import { SearchPresentationContext } from 'libs/productnavigation/feature/types';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Byte: any;
  Date: any;
  JSON: any;
};

export type AddAHeadFacets = {
  __typename?: 'AddAHeadFacets';
  attr_string_Product_State?: Maybe<Array<Scalars['String']>>;
  attr_string_Prong_Count?: Maybe<Array<Scalars['String']>>;
  attr_string_Quality?: Maybe<Array<Scalars['String']>>;
  attr_string_Stone_Shape?: Maybe<Array<Scalars['String']>>;
  attr_string_Stone_Size?: Maybe<Array<Scalars['String']>>;
  attrs_string_Related_Shank_Product_Id?: Maybe<Array<Scalars['String']>>;
  series?: Maybe<Array<Scalars['String']>>;
};

export type AddAHeadFacetsAndResults = {
  __typename?: 'AddAHeadFacetsAndResults';
  Facets?: Maybe<AddAHeadFacets>;
  Items?: Maybe<Array<Maybe<AddAHeadResult>>>;
  QueryTimeMs?: Maybe<Scalars['Int']>;
  Total?: Maybe<Scalars['Int']>;
};

export type AddAHeadProductDocument = {
  __typename?: 'AddAHeadProductDocument';
  attr_string_Product_State?: Maybe<Scalars['String']>;
  attr_string_Prong_Count?: Maybe<Scalars['String']>;
  attr_string_Quality: Scalars['String'];
  attr_string_Secondary_Stone_Origin?: Maybe<Scalars['String']>;
  attr_string_Secondary_Stone_Type?: Maybe<Scalars['String']>;
  attr_string_Stone_Shape: Scalars['String'];
  attr_string_Stone_Size?: Maybe<Scalars['String']>;
  attr_string_Title?: Maybe<Scalars['String']>;
  attrs_string_Parent_ATO_Model_Number: Array<Maybe<Scalars['String']>>;
  attrs_string_Related_Shank_Product_Id?: Maybe<Array<Maybe<Scalars['String']>>>;
  attrs_string_img_A?: Maybe<ImageUrlsDto>;
  attrs_string_img_AngleA?: Maybe<ImageUrlsDto>;
  attrs_string_img_B?: Maybe<ImageUrlsDto>;
  attrs_string_img_ViewE?: Maybe<ImageUrlsDto>;
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  category_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  default_group_id: Scalars['Int'];
  filtered_categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  filtered_category_ids?: Maybe<Array<Maybe<Scalars['String']>>>;
  filtered_group_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  group_by?: Maybe<Scalars['String']>;
  group_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  id?: Maybe<Scalars['String']>;
  image: ImageUrlsDto;
  image_angles?: Maybe<Array<Maybe<Scalars['String']>>>;
  in_stock?: Maybe<Scalars['Boolean']>;
  is_new?: Maybe<Scalars['Boolean']>;
  is_valid?: Maybe<Scalars['Boolean']>;
  item_number?: Maybe<Scalars['String']>;
  price?: Maybe<JsonPrice>;
  price_percarat?: Maybe<JsonPrice>;
  pricelist_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  product_id: Scalars['Int'];
  quickshop_id?: Maybe<Scalars['Int']>;
  serial_number: Scalars['Int'];
  series?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AddAHeadResult = {
  __typename?: 'AddAHeadResult';
  AddToCartViewModel: AddToCartViewModel;
  DetailsUrl?: Maybe<Scalars['String']>;
  Product: AddAHeadProductDocument;
};

export type AddOnItemInput = {
  AddToCartData?: Maybe<AddToCartDtoInput>;
  Label: Scalars['String'];
};

export type AddOrderComment = {
  __typename?: 'AddOrderComment';
  success: Scalars['Boolean'];
};

export type AddOrderCommentsParams = {
  comments: Scalars['String'];
  webOrderNumber: Scalars['Int'];
};

export type AddToCartDataInput = {
  Color?: Maybe<Scalars['String']>;
  CustomerNotes?: Maybe<Scalars['String']>;
  EstimatedShipDate?: Maybe<Scalars['Date']>;
  EstimatedShipDateLogId?: Maybe<Scalars['Int']>;
  FillerInstructions?: Maybe<Scalars['String']>;
  IgnoreWebEnabledFlag: Scalars['Boolean'];
  IsAnnealed: Scalars['Boolean'];
  IsExpedited: Scalars['Boolean'];
  IsMatch: Scalars['Boolean'];
  IsMemo: Scalars['Boolean'];
  IsSaturdayDelivery?: Maybe<Scalars['Boolean']>;
  Length?: Maybe<Scalars['Float']>;
  LengthUOM?: Maybe<Scalars['String']>;
  OrderOrigin?: Maybe<Scalars['String']>;
  Quantity: Scalars['Float'];
  SalesType?: Maybe<Scalars['String']>;
  Saturation?: Maybe<Scalars['String']>;
  ShipSetCode?: Maybe<Scalars['String']>;
  ShippingMethod?: Maybe<Scalars['String']>;
  SpecialInstructions?: Maybe<Scalars['String']>;
  Tone?: Maybe<Scalars['String']>;
  Tracking?: Maybe<LineSourceTrackingInput>;
  Width?: Maybe<Scalars['Float']>;
  WidthUOM?: Maybe<Scalars['String']>;
};

export type AddToCartDtoInput = {
  AddOnItems?: Maybe<Array<AddOnItemInput>>;
  AddToCart?: Maybe<AddToCartDataInput>;
  CertifiedStoneType?: Maybe<Scalars['String']>;
  ConfigId?: Maybe<Scalars['Int']>;
  ConfiguredCartItem?: Maybe<ConfiguredCartItemViewModelInput>;
  GroupId: Scalars['Int'];
  InventoryItemId: Scalars['Int'];
  MatchedSetId?: Maybe<Scalars['Int']>;
  Price: Scalars['Float'];
  Quantity: Scalars['Float'];
  SerialNumber?: Maybe<Scalars['Int']>;
  ShowOutOfStockMessage: Scalars['Boolean'];
};

export type AddToCartProduct = {
  __typename?: 'AddToCartProduct';
  JsonPrice?: Maybe<JsonPrice>;
};

export type AddToCartViewModel = {
  __typename?: 'AddToCartViewModel';
  Product?: Maybe<AddToCartProduct>;
};

export type AddToFavorites = {
  __typename?: 'AddToFavorites';
  favoriteListId: Scalars['Int'];
  favoriteListName: Scalars['String'];
  nameAlreadyExists?: Maybe<Scalars['Boolean']>;
  success: Scalars['Boolean'];
};

export type AddToFavoritesParams = {
  configId?: Maybe<Scalars['Int']>;
  favoriteListId?: Maybe<Scalars['Int']>;
  favoriteListName: Scalars['String'];
  itemID?: Maybe<Scalars['Int']>;
  length?: Maybe<Scalars['Int']>;
  lengthUom?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  serial?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
  widthUom?: Maybe<Scalars['String']>;
};

export type ArticleResult = {
  __typename?: 'ArticleResult';
  ContentType: Scalars['String'];
  CreationDate: Scalars['String'];
  Teaser: Scalars['String'];
  Title: Scalars['String'];
  Url: Scalars['String'];
};

export type ArticleResultsParams = {
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  q: Scalars['String'];
};

export type ArticleResultsResponse = {
  __typename?: 'ArticleResultsResponse';
  Pager: Pager;
  Query: Scalars['String'];
  SearchResults?: Maybe<Array<ArticleResult>>;
  SortBy: Array<SelectListItem>;
};

export type Attributes = {
  __typename?: 'Attributes';
  CenterX: Scalars['Float'];
  CenterY: Scalars['Float'];
  CenterZ: Scalars['Float'];
  OutsideHeight: Scalars['Float'];
  OutsideLength: Scalars['Float'];
  OutsideWidth: Scalars['Float'];
};

export type AutomaticPayment = {
  __typename?: 'AutomaticPayment';
  AmountDue?: Maybe<Scalars['Float']>;
  BankName?: Maybe<Scalars['String']>;
  CardExpirationDate?: Maybe<Scalars['Date']>;
  CardType?: Maybe<Scalars['String']>;
  CreationDate: Scalars['Date'];
  CurrencyCode: Scalars['String'];
  CustomerAccountId: Scalars['Int'];
  DayOfMonth?: Maybe<Scalars['Int']>;
  DayOfWeek?: Maybe<Scalars['String']>;
  Frequency: FrequencyType;
  Id: Scalars['Int'];
  ImageUrl?: Maybe<Scalars['String']>;
  InstrumentId: Scalars['Int'];
  IsDebitCard?: Maybe<Scalars['Boolean']>;
  IsPending?: Maybe<Scalars['Boolean']>;
  LastUpdatedDate: Scalars['Date'];
  NextPaymentDate?: Maybe<Scalars['Date']>;
  NextPaymentDueAmount: Scalars['Float'];
  Nickname: Scalars['String'];
  NumberOfInstallments: Scalars['Int'];
  OrderNumber: Scalars['Int'];
  PastDuePaymentAmount: Scalars['Float'];
  PaymentFailedCount?: Maybe<Scalars['Int']>;
  PaymentFailedReason?: Maybe<Scalars['String']>;
  SKU?: Maybe<Scalars['String']>;
  Title?: Maybe<Scalars['String']>;
  TokenizedBankAccountNumber?: Maybe<TokenizedPaymentMethodNumber>;
  TokenizedCardNumber?: Maybe<TokenizedPaymentMethodNumber>;
  TotalAmount?: Maybe<Scalars['Float']>;
  TransactionCount: Scalars['Int'];
  TransactionErrorMessage?: Maybe<Scalars['String']>;
  Type: AutomaticPaymentType;
};

export type AutomaticPaymentParams = {
  automaticPaymentId?: Maybe<Scalars['Int']>;
  types?: Maybe<Array<Scalars['String']>>;
};

export type AutomaticPaymentType = {
  __typename?: 'AutomaticPaymentType';
  Name: Scalars['String'];
  Value: Scalars['String'];
};

export type BankAccount = {
  __typename?: 'BankAccount';
  AccountNumber: Scalars['String'];
  AccountNumberConfirmation: Scalars['String'];
  BankName: Scalars['String'];
  Id: Scalars['String'];
  RoutingNumber: Scalars['String'];
  Tokenized?: Maybe<Scalars['Boolean']>;
};

export type BankAccountInput = {
  AccountNumber: Scalars['String'];
  AccountNumberConfirmation: Scalars['String'];
  AccountNumberUntokenized: Scalars['String'];
  BankName: Scalars['String'];
  RoutingNumber: Scalars['String'];
  RoutingNumberUntokenized: Scalars['String'];
  TokenType: Scalars['String'];
  Tokenized?: Maybe<Scalars['Boolean']>;
};

export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  EncodedText: Scalars['String'];
  Url?: Maybe<Scalars['String']>;
};

export type CadCamProfileViewModel = {
  SelectedContactViewModel: SelectedContactViewModel;
};

export type CadCamRenderViewModel = {
  __typename?: 'CadCamRenderViewModel';
  Render: Scalars['String'];
  RenderType: Scalars['String'];
};

export type CadCamRequestReactViewModel = {
  __typename?: 'CadCamRequestReactViewModel';
  CanPurchaseShippingLabel: Scalars['Boolean'];
  ContactViewModels: Array<ContactViewModel>;
  FontViewModels: Array<FontViewModel>;
  IsNewPreferenceCenter: Scalars['Boolean'];
  MerchandiseRingSizeSelects: Array<MerchandiseRingSizeSelect>;
  MetalCodes: Array<Scalars['String']>;
  RingSizeSelects: Array<RingSizeSelect>;
  SourceList: Array<SourceList>;
};

export type CadCamRequestSubmitViewModel = {
  __typename?: 'CadCamRequestSubmitViewModel';
  Comments?: Maybe<Scalars['String']>;
  CustomerReference?: Maybe<Scalars['String']>;
  ParentId?: Maybe<Scalars['Int']>;
  PerspectiveRender?: Maybe<CadCamRenderViewModel>;
  Quantity: Scalars['Int'];
  RingSize?: Maybe<Scalars['Int']>;
  SideRender?: Maybe<CadCamRenderViewModel>;
  StullerItemNumber?: Maybe<Scalars['String']>;
  ThroughRender?: Maybe<CadCamRenderViewModel>;
  TopRender?: Maybe<CadCamRenderViewModel>;
};

export type CadCamResubmitReactViewModel = {
  __typename?: 'CadCamResubmitReactViewModel';
  CadCamRequestReactViewModel: CadCamRequestReactViewModel;
  CadCamRequestSubmitViewModel: CadCamRequestSubmitViewModel;
};

export type CancelAutomaticPaymentParams = {
  AutomaticPaymentId: Scalars['Int'];
};

export type CancelAutomaticPaymentResult = {
  __typename?: 'CancelAutomaticPaymentResult';
  AutomaticPaymentId: Scalars['Int'];
};

export type CancelFakePaymentParams = {
  comment?: Maybe<Scalars['String']>;
  from: Scalars['String'];
  id: Scalars['Int'];
};

export type CancelFakePaymentResult = {
  __typename?: 'CancelFakePaymentResult';
  CanceledPaymentId: Scalars['Int'];
};

export type CancelLineParams = {
  configId?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  isMonogram: Scalars['Boolean'];
  lineId: Scalars['Int'];
  orderNumber: Scalars['Int'];
  reason: Scalars['String'];
};

export type CancelOrderParams = {
  orderNumber: Scalars['Int'];
};

export type CancellationReasonViewModel = {
  __typename?: 'CancellationReasonViewModel';
  Display: Scalars['String'];
  Value: Scalars['String'];
};

export type CartItemConfiguredCustomImprintingLocationInput = {
  ColorInstructions?: Maybe<Array<Scalars['String']>>;
  EngravingText?: Maybe<Scalars['String']>;
  HasAcceptedTermsOfService: Scalars['Boolean'];
  HighlightColors?: Maybe<Array<Scalars['String']>>;
  LocationId: Scalars['Int'];
  LocationType?: Maybe<Scalars['String']>;
  TrademarkId?: Maybe<Scalars['Int']>;
};

export type CartItemConfiguredEngravingLocationInput = {
  EngravingTypeId: Scalars['Int'];
  Engravings?: Maybe<Array<Scalars['String']>>;
  FillColorId?: Maybe<Scalars['Int']>;
  FontId: Scalars['Int'];
  LocationId: Scalars['Int'];
  LocationNumber: Scalars['Int'];
  UploadedFile?: Maybe<Scalars['String']>;
};

export type CartItemConfiguredKitItemLocationInput = {
  LocationNumber: Scalars['Int'];
  RingId: Scalars['Int'];
};

export type CartItemConfiguredMonogramLocationInput = {
  LocationNumber: Scalars['Int'];
  Text: Scalars['String'];
};

export type CartItemConfiguredSpecialFinishLocationInput = {
  LocationId: Scalars['Int'];
  SpecialFinishId: Scalars['Int'];
};

export type CartItemConfiguredStoneLocationInput = {
  CustomerStoneValue?: Maybe<Scalars['Int']>;
  LocationId: Scalars['Int'];
  LocationNumber: Scalars['Int'];
  SerialNumber?: Maybe<Scalars['Int']>;
  StoneGroup?: Maybe<Scalars['String']>;
  StoneProductId: Scalars['Int'];
};

export type CategoryOrSearchViewModel = {
  __typename?: 'CategoryOrSearchViewModel';
  AllowNewContentBlockCreation: Scalars['Boolean'];
  ArticlesCount: Scalars['Int'];
  BottomNavigationSectionContentId?: Maybe<Scalars['Int']>;
  BreadCrumbs?: Maybe<Array<Breadcrumb>>;
  Category?: Maybe<Scalars['String']>;
  CategoryId?: Maybe<Scalars['Int']>;
  CategoryPermalinkUrl?: Maybe<Scalars['String']>;
  CenterStoneColors?: Maybe<Array<CenterStoneColor>>;
  ChildCategories?: Maybe<Array<CategoryViewModel>>;
  ClearAllUrl?: Maybe<Scalars['String']>;
  CmsContentType: Scalars['Int'];
  ContentBlockLocation: Scalars['Int'];
  ContentId?: Maybe<Scalars['Int']>;
  CorrectedQuery?: Maybe<Scalars['String']>;
  FacetValues?: Maybe<Array<FacetValue>>;
  Filters?: Maybe<Array<Maybe<SearchFilters>>>;
  HideSideNav: Scalars['Boolean'];
  ImpressionListName?: Maybe<Scalars['String']>;
  IsContentOnlyDisplayTemplate: Scalars['Boolean'];
  MerchandisingMode: Scalars['Boolean'];
  NavigationSections?: Maybe<Array<NavigationSection>>;
  NewContentBlockName: Scalars['String'];
  OriginalQuery?: Maybe<Scalars['String']>;
  PageHeader: Scalars['String'];
  PageSizeFilter: Array<SelectListItem>;
  PageTitle: Scalars['String'];
  Pager?: Maybe<Pager>;
  PresentationContext: SearchPresentationContext;
  Query?: Maybe<Scalars['String']>;
  QueryId?: Maybe<Scalars['String']>;
  RedirectUrl?: Maybe<Scalars['String']>;
  RelatedSearchTerms?: Maybe<Array<Maybe<SearchSuggestion>>>;
  SearchByStoneSize?: Maybe<SearchByStoneSizeViewModel>;
  SearchResults?: Maybe<Array<SearchResult>>;
  SearchSource?: Maybe<Scalars['String']>;
  SelectedFacets?: Maybe<Array<SelectedFacet>>;
  ShowCenterStoneColors: Scalars['Boolean'];
  ShowDiscounts: Scalars['Boolean'];
  ShowPageSize: Scalars['Boolean'];
  ShowSeriesAboveImage: Scalars['Boolean'];
  SortByFilter: Array<SelectListItem>;
  StoneForViewAvailableMountings?: Maybe<StoneForViewAvailableMountingsViewModel>;
  TopAcrossPageContentId?: Maybe<Scalars['Int']>;
  TopNavigationSections?: Maybe<Array<NavigationSection>>;
  TopRowInResultsContentID?: Maybe<Scalars['Int']>;
  UnderCategorySectionContentId?: Maybe<Scalars['Int']>;
};

export type CategoryViewModel = {
  __typename?: 'CategoryViewModel';
  BottomContentId?: Maybe<Scalars['Int']>;
  CDNImageName: Scalars['String'];
  ChildCategories?: Maybe<Array<Maybe<CategoryViewModel>>>;
  ContentId?: Maybe<Scalars['Int']>;
  HideCategory: Scalars['Boolean'];
  Id: Scalars['Int'];
  IsAShopCategory: Scalars['Boolean'];
  Name: Scalars['String'];
  OverrideUrl: Scalars['String'];
  PageHeader: Scalars['String'];
  PageMetaDescription: Scalars['String'];
  PageTitle: Scalars['String'];
  SanitizedName: Scalars['String'];
  SanitizedPath: Scalars['String'];
  ShowGrandChildren: Scalars['Boolean'];
  ShowImages: Scalars['Boolean'];
  ShowInShowcase: Scalars['Boolean'];
  ShowcaseDisplayName: Scalars['String'];
  ShowcasePageTitle: Scalars['String'];
  SortOrder: Scalars['Int'];
  StandardDisplayName: Scalars['String'];
};

export type CenterStoneColor = {
  __typename?: 'CenterStoneColor';
  HexCode: Scalars['String'];
  IsSelected: Scalars['Boolean'];
  Name: Scalars['String'];
};

/** Input to get nav content container id */
export type CmsNavContentContainerIdInput = {
  /** Nav category id */
  categoryId: Scalars['Int'];
};

export type ColliderData = {
  __typename?: 'ColliderData';
  Front: Scalars['String'];
  PimData: PimData;
  Side: Scalars['String'];
  Top: Scalars['String'];
};

export type ConfigDetails = {
  __typename?: 'ConfigDetails';
  Description?: Maybe<Scalars['String']>;
  TemplateData: Array<Maybe<Scalars['JSON']>>;
  TemplateName: Scalars['String'];
  Title?: Maybe<Scalars['String']>;
};

export type ConfigResponse = {
  __typename?: 'ConfigResponse';
  configDetails?: Maybe<Array<Array<ConfigDetails>>>;
};

export type ConfiguredCartItemViewModelInput = {
  ChainLength?: Maybe<Scalars['Float']>;
  ClaspProductId?: Maybe<Scalars['Int']>;
  ConfigId?: Maybe<Scalars['Int']>;
  CustomImprintings?: Maybe<Array<CartItemConfiguredCustomImprintingLocationInput>>;
  EarringBackProductId?: Maybe<Scalars['Int']>;
  EarringPostProductId?: Maybe<Scalars['Int']>;
  Engravings?: Maybe<Array<CartItemConfiguredEngravingLocationInput>>;
  HeadConfiguration?: Maybe<ConfiguredCartItemViewModelInput>;
  KitItems?: Maybe<Array<CartItemConfiguredKitItemLocationInput>>;
  MonogramChainOptionId?: Maybe<Scalars['Int']>;
  Monograms?: Maybe<Array<CartItemConfiguredMonogramLocationInput>>;
  PendantChainProductId?: Maybe<Scalars['Int']>;
  ProductId: Scalars['Int'];
  RingSize?: Maybe<Scalars['Float']>;
  RingStockSize?: Maybe<Scalars['Float']>;
  SelectedSpecialFinishes?: Maybe<Array<CartItemConfiguredSpecialFinishLocationInput>>;
  Stones?: Maybe<Array<CartItemConfiguredStoneLocationInput>>;
  TrademarkHasAcceptedTermsOfService: Scalars['Boolean'];
  TrademarkId?: Maybe<Scalars['Int']>;
  VignetteEngravingInfos?: Maybe<Array<VignetteEngravingInfoInput>>;
  VignetteStoneInfos?: Maybe<Array<VignetteStoneInfoInput>>;
};

export type Connector = {
  __typename?: 'Connector';
  LocationX: Scalars['Float'];
  LocationY: Scalars['Float'];
  LocationZ: Scalars['Float'];
};

export type ContactViewModel = {
  __typename?: 'ContactViewModel';
  Active: Scalars['Boolean'];
  AllowDuplicate: Scalars['Boolean'];
  BadEmailAddress: Scalars['String'];
  BusinessPhoneNumber: Scalars['String'];
  CadCamAcceptAllModFees: Scalars['Boolean'];
  CadCamHasLogoOnFile: Scalars['Boolean'];
  ColumnCount: Scalars['String'];
  ContactIsDeletable: Scalars['Boolean'];
  CreationDate: Scalars['Date'];
  DirectPhoneNumber: Scalars['String'];
  DuplicateEmail: Scalars['String'];
  EmailAddress: Scalars['String'];
  FirstName: Scalars['String'];
  FullName: Scalars['String'];
  Id?: Maybe<Scalars['Int']>;
  IsAssignedToUser: Scalars['Boolean'];
  IsBadEmail: Scalars['Boolean'];
  IsCheckoutDefault: Scalars['Boolean'];
  IsEmailAddressRequired: Scalars['Boolean'];
  IsMinimal: Scalars['Boolean'];
  IsSingleContactForCurrentUser: Scalars['Boolean'];
  JobTitle: Scalars['String'];
  LastName: Scalars['String'];
  MobilePhoneNumber: Scalars['String'];
  ModificationDate: Scalars['Date'];
  OptIn302SMSNotifications: Scalars['Boolean'];
  OptInEverAndEverSMSNotifications: Scalars['Boolean'];
  OraclePartyId?: Maybe<Scalars['Int']>;
  PreferredMethodOfContact: Scalars['String'];
  PreferredName: Scalars['String'];
  RenderMinimalWithMobilePhoneUpdate: Scalars['Boolean'];
  Salutation: Scalars['String'];
  ShowPreferredMethodOfContact: Scalars['Boolean'];
  Suffix: Scalars['String'];
  Unsubscribed: Scalars['Boolean'];
  UseTextInputForEmailAddresses: Scalars['Boolean'];
};

/** Context object for Stuller.com */
export type Context = {
  __typename?: 'Context';
  AccountCountry?: Maybe<Scalars['String']>;
  AccountCurrencyCode?: Maybe<Scalars['String']>;
  ActionName?: Maybe<Scalars['String']>;
  AllowIframeHostApi: Scalars['Boolean'];
  AllowIframeHostApiDomainsCsvList?: Maybe<Scalars['String']>;
  AllowUniqueRequests: Scalars['Boolean'];
  CanCheckout: Scalars['Boolean'];
  CanManageRevenueCycle: Scalars['Boolean'];
  CanPromoteShowcase: Scalars['Boolean'];
  CanPromoteStullerFirst: Scalars['Boolean'];
  CartCount: Scalars['Int'];
  ControllerName?: Maybe<Scalars['String']>;
  Currency: ContextCurrency;
  CurrentCultureName: Scalars['String'];
  DefaultShipToAccountNumber?: Maybe<Scalars['String']>;
  DefaultShipToAddress?: Maybe<DefaultShipToAddress>;
  HasJewelerShowcase: Scalars['Boolean'];
  HasScheduledOrder: Scalars['Boolean'];
  HideAddToCart: Scalars['Boolean'];
  HideBreadcrumbs: Scalars['Boolean'];
  HideCartLinkInHeader: Scalars['Boolean'];
  HidePrices: Scalars['Boolean'];
  HideShipDatesAndItemStatuses: Scalars['Boolean'];
  IsArtisanAccount: Scalars['Boolean'];
  IsDev: Scalars['Boolean'];
  IsEcommMerchandisingMode: Scalars['Boolean'];
  IsEligibleForStullerFirst: Scalars['Boolean'];
  IsEmployee: Scalars['Boolean'];
  IsFoundryAndShowcase: Scalars['Boolean'];
  IsGroupCodeViewer: Scalars['Boolean'];
  IsInCmsMode: Scalars['Boolean'];
  IsInConsultantMode: Scalars['Boolean'];
  IsInJewelerShowcase: Scalars['Boolean'];
  IsInMetalsClub: Scalars['Boolean'];
  IsInShowcase: Scalars['Boolean'];
  IsInStullerFirst: Scalars['Boolean'];
  IsInStullerFirstTrial: Scalars['Boolean'];
  IsJaredStudioLogin: Scalars['Boolean'];
  IsOrderApprovalByPassCheckout: Scalars['Boolean'];
  IsOrderApprover: Scalars['Boolean'];
  IsRJOAccount: Scalars['Boolean'];
  IsRJOMasterAccount: Scalars['Boolean'];
  IsSalesPerformanceViewer: Scalars['Boolean'];
  IsSterling: Scalars['Boolean'];
  IsToolsOnly: Scalars['Boolean'];
  LoginId?: Maybe<Scalars['String']>;
  MadeByStullerViewer: Scalars['Boolean'];
  OrderDoesNotRequireApproval: Scalars['Boolean'];
  PunchOutTheme: Scalars['String'];
  RecaptchaSiteKey: Scalars['String'];
  RequiresPanPad: Scalars['Boolean'];
  ScheduledOrderCutoffTime?: Maybe<Scalars['Date']>;
  SearchEngine?: Maybe<Scalars['String']>;
  SessionId: Scalars['String'];
  ShouldShowShipDateImmediately: Scalars['Boolean'];
  ShowDGLauncher: Scalars['Boolean'];
  ShowEstimatedShipDatesOverride: Scalars['Boolean'];
  ShowPricePerCt: Scalars['Boolean'];
  ShowShowcaseSalePrice: Scalars['Boolean'];
  ShowcaseCanShowSendAQuote: Scalars['Boolean'];
  ShowcaseEmailAddress?: Maybe<Scalars['String']>;
  ShowcasePhoneNumber?: Maybe<Scalars['String']>;
  ShowcaseTitle?: Maybe<Scalars['String']>;
  StullerFirstPromotionalShippingCost?: Maybe<Scalars['String']>;
  StullerFirstPromotionalShippingMethod?: Maybe<Scalars['String']>;
  TurnToKey: Scalars['String'];
  UseClientACHTokenization?: Maybe<Scalars['Boolean']>;
  UserFirstName?: Maybe<Scalars['String']>;
  UserIsAssignedContact: Scalars['Boolean'];
  UserMemberId?: Maybe<Scalars['String']>;
  UserNeedsToAgreeToTermsForReview: Scalars['Boolean'];
};

/** Currency view model */
export type ContextCurrency = {
  __typename?: 'ContextCurrency';
  Currency: Scalars['String'];
  DecimalDigits: Scalars['Int'];
  DecimalSeparator: Scalars['String'];
  GroupSeparator: Scalars['String'];
  Symbol: Scalars['String'];
  SymbolIsPrefix: Scalars['Boolean'];
};

export enum CountdownType {
  NoOrder = 'noOrder',
  PreviousOrder = 'previousOrder',
  ScheduledOrder = 'scheduledOrder'
}

export type CreateAutomaticPaymentForOrderParams = {
  AcceptedTerms: Scalars['Boolean'];
  AccountId: Scalars['String'];
  Name: Scalars['String'];
  OrderNumber: Scalars['Int'];
  PaymentType: Scalars['String'];
};

export type CreateAutomaticPaymentForOrderResult = {
  __typename?: 'CreateAutomaticPaymentForOrderResult';
  AutomaticPaymentId?: Maybe<Scalars['Int']>;
  ErrorMessage?: Maybe<Scalars['String']>;
};

export type CreateAutomaticPaymentForStatementParams = {
  AcceptedTerms: Scalars['Boolean'];
  AccountId: Scalars['String'];
  DayOfMonth: Scalars['Int'];
  Name: Scalars['String'];
  PaymentType: Scalars['String'];
};

export type CreateAutomaticPaymentForStatementResult = {
  __typename?: 'CreateAutomaticPaymentForStatementResult';
  AutomaticPaymentId?: Maybe<Scalars['Int']>;
  ErrorMessage?: Maybe<Scalars['String']>;
};

export type CreateAutomaticPaymentForTransactionsParams = {
  AcceptedTerms: Scalars['Boolean'];
  AccountId: Scalars['String'];
  CurrentStatementOnly?: Maybe<Scalars['Boolean']>;
  DayOfMonth: Scalars['Int'];
  DayOfWeek: Scalars['String'];
  EndDate?: Maybe<Scalars['Date']>;
  Frequency: Scalars['String'];
  Name: Scalars['String'];
  NumberOfInstallments: Scalars['Int'];
  PastDueOnly?: Maybe<Scalars['Boolean']>;
  PaymentType: Scalars['String'];
  ShipToAccount?: Maybe<Scalars['String']>;
  StartDate?: Maybe<Scalars['Date']>;
  TransactionIds?: Maybe<Array<Scalars['Int']>>;
  TransactionListType?: Maybe<Scalars['String']>;
};

export type CreateAutomaticPaymentForTransactionsResult = {
  __typename?: 'CreateAutomaticPaymentForTransactionsResult';
  AutomaticPaymentId?: Maybe<Scalars['Int']>;
  ErrorMessage?: Maybe<Scalars['String']>;
};

export type CreateDataFeedParams = {
  catId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type CreateFakePaymentParams = {
  amount: Scalars['Float'];
  comment?: Maybe<Scalars['String']>;
  from: Scalars['String'];
};

export type CreateFakePaymentResult = {
  __typename?: 'CreateFakePaymentResult';
  Id: Scalars['Int'];
};

export type CreateRmaInput = {
  cardId?: Maybe<Scalars['String']>;
  packageWeight?: Maybe<Scalars['Int']>;
  purchaseShippingLabel?: Maybe<Scalars['Boolean']>;
  returnItems: Array<ReturnItem>;
  shippingMethod?: Maybe<Scalars['String']>;
};

export type CreateRmaResult = {
  __typename?: 'CreateRMAResult';
  errors?: Maybe<Array<Scalars['String']>>;
  orderNumber?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CreditCard = {
  __typename?: 'CreditCard';
  CardHolderName: Scalars['String'];
  CardNumber: Scalars['String'];
  CardType: Scalars['String'];
  Cvv?: Maybe<Scalars['String']>;
  DataSource: Scalars['String'];
  ExpirationDate?: Maybe<Scalars['String']>;
  ExpirationMonth: Scalars['Int'];
  ExpirationYear: Scalars['Int'];
  Id: Scalars['String'];
  InstrumentId: Scalars['String'];
  IsDebit: Scalars['Boolean'];
  IsExpired: Scalars['Boolean'];
  Schema?: Maybe<Scalars['String']>;
  Zip: Scalars['String'];
};

export type CreditCardParams = {
  CardHolderName: Scalars['String'];
  CardNumber?: Maybe<Scalars['String']>;
  CardType: Scalars['String'];
  Cvv?: Maybe<Scalars['String']>;
  ExpirationMonth?: Maybe<Scalars['Int']>;
  ExpirationYear?: Maybe<Scalars['Int']>;
  Id?: Maybe<Scalars['String']>;
  IsDebit?: Maybe<Scalars['Boolean']>;
  LastFour?: Maybe<Scalars['String']>;
  Zip: Scalars['String'];
};

export type CreditCardType = {
  __typename?: 'CreditCardType';
  CssClassName?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['String']>;
};

export type Currency = {
  __typename?: 'Currency';
  CurrencyCode: Scalars['String'];
  Value: Scalars['Float'];
};

export type DefaultShipToAddress = {
  __typename?: 'DefaultShipToAddress';
  AddressLine1?: Maybe<Scalars['String']>;
  AddressLine2?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  Country?: Maybe<Scalars['String']>;
  IsResidential?: Maybe<Scalars['Boolean']>;
  Province?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  Zip?: Maybe<Scalars['String']>;
};

export type DeleteBankAccountParams = {
  bankAccountId?: Maybe<Scalars['String']>;
};

export type DeleteBankAccountResponse = {
  __typename?: 'DeleteBankAccountResponse';
  success: Scalars['Boolean'];
};

export type DeleteCredtCardParams = {
  creditCardId?: Maybe<Scalars['String']>;
};

export type DeleteCredtCardResponse = {
  __typename?: 'DeleteCredtCardResponse';
  success: Scalars['Boolean'];
};

export type DiscountedProductResult = {
  __typename?: 'DiscountedProductResult';
  Code?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  DisplayPrice?: Maybe<Scalars['String']>;
  GroupDetailsUrl?: Maybe<Scalars['String']>;
  Id: Scalars['Int'];
  ImageUrls?: Maybe<ImageUrlsDto>;
  IsAlmostGoneBadge?: Maybe<Scalars['Boolean']>;
  IsDiscounted?: Maybe<Scalars['Boolean']>;
  IsExcessBadge?: Maybe<Scalars['Boolean']>;
  IsOutOfStockBadge?: Maybe<Scalars['Boolean']>;
  MaxDiscount?: Maybe<Scalars['Int']>;
  MinDiscount?: Maybe<Scalars['Int']>;
  OriginalPrice?: Maybe<Scalars['String']>;
  ProductState?: Maybe<Scalars['String']>;
};

export type DiscountedProductResultsResponse = {
  __typename?: 'DiscountedProductResultsResponse';
  results: Array<DiscountedProductResult>;
};

export type FacetValue = {
  __typename?: 'FacetValue';
  First: Scalars['String'];
  Second: Scalars['String'];
};

export type FacetValueInput = {
  First: Scalars['String'];
  Second: Scalars['String'];
};

export type FakePayment = {
  __typename?: 'FakePayment';
  Amount: Scalars['Float'];
  Comment?: Maybe<Scalars['String']>;
  From: Scalars['String'];
  Id: Scalars['Int'];
};

export type FavoritesList = {
  __typename?: 'FavoritesList';
  name: Scalars['String'];
  value: Scalars['Int'];
};

export type FavoritesOptions = {
  __typename?: 'FavoritesOptions';
  DefaultList?: Maybe<Scalars['Int']>;
  Lists: Array<FavoritesList>;
};

export type FinalizeAutomaticPaymentParams = {
  AutomaticPaymentId: Scalars['Int'];
};

export type FinalizeAutomaticPaymentResult = {
  __typename?: 'FinalizeAutomaticPaymentResult';
  AutomaticPaymentId: Scalars['Int'];
};

export type FindAllActiveAutorenewalsByCreditCardIdParams = {
  creditCardId: Scalars['String'];
};

export type FindShipToAccountNumbersParams = {
  term: Scalars['String'];
};

export type FontViewModel = {
  __typename?: 'FontViewModel';
  Description: Scalars['String'];
  Face: Scalars['String'];
  FontSampleImage: Scalars['String'];
  Id: Scalars['Int'];
  MaxCharacters: Scalars['Int'];
  MaxLines?: Maybe<Scalars['Int']>;
  MeteorFont: Scalars['String'];
  MeteorFontSizeScalingFactor: Scalars['String'];
  SpriteClass: Scalars['String'];
  ValidationMessage: Scalars['String'];
  ValidationPattern: Scalars['String'];
};

export type FrequencyType = {
  __typename?: 'FrequencyType';
  Name: Scalars['String'];
  Value: Scalars['String'];
};

export type GetAddAHeadColliderObjectParams = {
  headItemId: Scalars['String'];
  shankItemId: Scalars['String'];
};

export type GetApprovalOrderParams = {
  confirmationNumber?: Maybe<Scalars['Int']>;
  returnView?: Maybe<Scalars['Boolean']>;
};

export type GetConfigItemSummaryParams = {
  configId: Scalars['Int'];
};

export type GetContactsFromShipToAccountParams = {
  shipToAccountNumber: Scalars['String'];
};

export type GetContainsCustomsDocumentsResponse = {
  __typename?: 'GetContainsCustomsDocumentsResponse';
  containsCustomsDocuments: Scalars['Boolean'];
};

export type GetCustomsDocumentsForInvoiceResponse = {
  __typename?: 'GetCustomsDocumentsForInvoiceResponse';
  contentType: Scalars['String'];
  fileData: Scalars['String'];
  fileName: Scalars['String'];
  success: Scalars['Boolean'];
};

export type GetCustomsDocumentsParams = {
  invoiceNumber: Scalars['Int'];
};

export type GetInvoicesParams = {
  beginDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  searchType: Scalars['String'];
  searchValue?: Maybe<Scalars['String']>;
  shipToAccountNumber?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

export type GetOrderDetailsParams = {
  id?: Maybe<Scalars['String']>;
};

export type GetOrdersParams = {
  approvalOrdersOnly?: Maybe<Scalars['Boolean']>;
  beginDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
  excludeWebOrders?: Maybe<Scalars['Boolean']>;
  openOnly?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  searchType?: Maybe<Scalars['String']>;
  searchValue?: Maybe<Scalars['String']>;
  shipToAccountNumber?: Maybe<Scalars['String']>;
};

export type GetProductNavigationParams = {
  bestSellers?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Scalars['String']>;
  centerStone?: Maybe<Scalars['String']>;
  facetValues?: Maybe<Array<FacetValueInput>>;
  featured?: Maybe<Scalars['String']>;
  originalQuery?: Maybe<Scalars['String']>;
  overrideSpellingSuggestion?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  query: Scalars['String'];
  sanitizedCategoryNames: Array<Scalars['String']>;
  searchType?: Maybe<Scalars['String']>;
  showfeaturedForDev?: Maybe<Scalars['Boolean']>;
  sortby?: Maybe<Scalars['String']>;
  suggested?: Maybe<Scalars['Boolean']>;
  suggestionRank?: Maybe<Scalars['Int']>;
};

export type GetProductParams = {
  seriesOrItemNumber: Scalars['String'];
};

export type GetProductResponse = {
  __typename?: 'GetProductResponse';
  cannotModifyStyleReason?: Maybe<Scalars['String']>;
  customerSpecificSku?: Maybe<Scalars['String']>;
  isModifiable: Scalars['Boolean'];
  isRing: Scalars['Boolean'];
  product?: Maybe<Product>;
};

export type GetReceivableTransactionsParams = {
  currentStatementOnly?: Maybe<Scalars['Boolean']>;
  descending?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['Date']>;
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  pastDueOnly?: Maybe<Scalars['Boolean']>;
  shipToAccount?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  transactionIds?: Maybe<Array<Scalars['Int']>>;
  transactionListType?: Maybe<Scalars['String']>;
};

export type GetShippingCountdownInput = {
  addToCart?: Maybe<AddToCartDtoInput>;
  shipToAccountNumber?: Maybe<Scalars['String']>;
};

export type ImageAsset = {
  __typename?: 'ImageAsset';
  id: Scalars['String'];
  source: Scalars['String'];
  type: Scalars['String'];
};

export type ImageUrlsDto = {
  __typename?: 'ImageUrlsDto';
  Angle?: Maybe<Scalars['String']>;
  Format?: Maybe<Scalars['String']>;
  FullSizeUrl?: Maybe<Scalars['String']>;
  Height?: Maybe<Scalars['Int']>;
  ImageId: Scalars['Int'];
  IsNotFoundImage?: Maybe<Scalars['Boolean']>;
  IsSuperZoomable?: Maybe<Scalars['Boolean']>;
  IsZoomable?: Maybe<Scalars['Boolean']>;
  MediaType?: Maybe<Scalars['String']>;
  Preview360Compare?: Maybe<Scalars['String']>;
  Preview360PDP?: Maybe<Scalars['String']>;
  Preview360Zoom?: Maybe<Scalars['String']>;
  RawUrl?: Maybe<Scalars['String']>;
  Size190Url?: Maybe<Scalars['String']>;
  Size250Url: Scalars['String'];
  Size350Url?: Maybe<Scalars['String']>;
  Size430Url?: Maybe<Scalars['String']>;
  Size640Url?: Maybe<Scalars['String']>;
  SortOrder?: Maybe<Scalars['Int']>;
  Thumb40Url?: Maybe<Scalars['String']>;
  Thumb75Url?: Maybe<Scalars['String']>;
  Thumb100Url?: Maybe<Scalars['String']>;
  Thumb125Url?: Maybe<Scalars['String']>;
  Thumb150Url?: Maybe<Scalars['String']>;
  Thumb165Url: Scalars['String'];
  Video360CompareHtml?: Maybe<Scalars['String']>;
  Video360PDPHtml?: Maybe<Scalars['String']>;
  Video360ZoomHtml?: Maybe<Scalars['String']>;
  Video640x480Html?: Maybe<Scalars['String']>;
  Video1024x768Html?: Maybe<Scalars['String']>;
  VideoDynamicHtml?: Maybe<Scalars['String']>;
  Width?: Maybe<Scalars['Int']>;
  ZoomUrl?: Maybe<Scalars['String']>;
};

export type InvoiceSearchResults = {
  __typename?: 'InvoiceSearchResults';
  Errors: Array<Scalars['String']>;
  ReceivableTransactions: Array<ReceivableTransaction>;
  TotalRecords: Scalars['Int'];
};

export type JsonPrice = {
  __typename?: 'JsonPrice';
  CurrentPrice: JsonPriceUnit;
  DiscountPercent?: Maybe<Scalars['Float']>;
  DiscountType: Scalars['String'];
  EligibleAdditionalStullerFirstDiscountPercent?: Maybe<Scalars['Float']>;
  OriginalPrice: JsonPriceUnit;
  ValueSaved: JsonPriceUnit;
};

export type JsonPriceUnit = {
  __typename?: 'JsonPriceUnit';
  HtmlFormattedPrice: Scalars['String'];
  ValueAtCurrency: Scalars['Float'];
  ValueInUSD: Scalars['Float'];
};

export type LineSourceTrackingInput = {
  Index?: Maybe<Scalars['Int']>;
  RelatedId?: Maybe<Scalars['String']>;
  SearchId?: Maybe<Scalars['String']>;
  SearchTerm?: Maybe<Scalars['String']>;
  Source?: Maybe<Scalars['String']>;
  SourceType?: Maybe<Scalars['String']>;
};

export type LogoResponse = {
  __typename?: 'LogoResponse';
  hasMissingLogo?: Maybe<Scalars['Boolean']>;
};

export type Lookup = {
  __typename?: 'Lookup';
  Code: Scalars['String'];
  ID: Scalars['Int'];
  Order?: Maybe<Scalars['Int']>;
  Type: Scalars['String'];
  Value: Scalars['String'];
  Value2?: Maybe<Scalars['String']>;
  Value3?: Maybe<Scalars['String']>;
  Value4?: Maybe<Scalars['String']>;
  Value5?: Maybe<Scalars['String']>;
  Value6?: Maybe<Scalars['String']>;
  Value7?: Maybe<Scalars['String']>;
  Value8?: Maybe<Scalars['String']>;
  Value9?: Maybe<Scalars['String']>;
  Value10?: Maybe<Scalars['String']>;
};

export type LoyaltyProgramDetails = {
  __typename?: 'LoyaltyProgramDetails';
  Renewals?: Maybe<Array<Maybe<Renewals>>>;
};

export type MarketplaceProfileReactViewModel = {
  __typename?: 'MarketplaceProfileReactViewModel';
  AmazonSellerId?: Maybe<Scalars['String']>;
  ContactInvalid?: Maybe<Scalars['Boolean']>;
  Errors?: Maybe<Scalars['Boolean']>;
  TokenActive?: Maybe<Scalars['Boolean']>;
};

export type MerchandiseRingSizeSelect = {
  __typename?: 'MerchandiseRingSizeSelect';
  Key: Scalars['Int'];
  Value: Scalars['String'];
};

export type MerchandiseSubmissionShippingRatesInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  isResidential?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  replacementValue?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type MerchandiseSubmissionShippingRatesResults = {
  __typename?: 'MerchandiseSubmissionShippingRatesResults';
  Carrier: Scalars['String'];
  Description: Scalars['String'];
  FreightPrice: Scalars['Float'];
  InsurancePrice: Scalars['Float'];
  ReplacementValue: Scalars['Float'];
  ShippingMethodCode: Scalars['String'];
  TotalShippingPrice: Scalars['Float'];
};

export type MetalQuality = {
  __typename?: 'MetalQuality';
  BaseMetal?: Maybe<Scalars['String']>;
  Code?: Maybe<Scalars['String']>;
  ColorHexValue?: Maybe<Scalars['String']>;
  ColorName?: Maybe<Scalars['String']>;
  ColorNameLower?: Maybe<Scalars['String']>;
  CounterSketchMetalMaterialCode?: Maybe<Scalars['String']>;
  DisplayName?: Maybe<Scalars['String']>;
  IconPath?: Maybe<Scalars['String']>;
  IsMultiTone?: Maybe<Scalars['Boolean']>;
  Karat?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  RelatedContentContainerId?: Maybe<Scalars['String']>;
  SubGroup?: Maybe<Scalars['String']>;
};

export type MonthlyStatementEligibilityResult = {
  __typename?: 'MonthlyStatementEligibilityResult';
  IsEligible: Scalars['Boolean'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addOrderComments?: Maybe<AddOrderComment>;
  addToFavorites?: Maybe<AddToFavorites>;
  cancelAutomaticPayment?: Maybe<CancelAutomaticPaymentResult>;
  cancelFakePayment?: Maybe<CancelFakePaymentResult>;
  cancelLine?: Maybe<Scalars['Boolean']>;
  cancelOrder?: Maybe<Scalars['Boolean']>;
  createAutomaticPaymentForOrder?: Maybe<CreateAutomaticPaymentForOrderResult>;
  createAutomaticPaymentForStatement?: Maybe<CreateAutomaticPaymentForStatementResult>;
  createAutomaticPaymentForTransactions?: Maybe<CreateAutomaticPaymentForTransactionsResult>;
  createFakePayment?: Maybe<CreateFakePaymentResult>;
  createProductDataFeed?: Maybe<SaveDataFeedResponse>;
  createRMA?: Maybe<CreateRmaResult>;
  deleteBankAccount?: Maybe<DeleteBankAccountResponse>;
  deleteCreditCard?: Maybe<DeleteCredtCardResponse>;
  finalizeAutomaticPayment?: Maybe<FinalizeAutomaticPaymentResult>;
  saveCard?: Maybe<SaveCardResponse>;
  saveDefaultPaymentMethod?: Maybe<SaveDefaultPaymentMethodResponse>;
  saveNewBankAccount?: Maybe<SaveNewBankAccountResponse>;
  saveSeries?: Maybe<SaveDataFeedResponse>;
  saveSku?: Maybe<SaveDataFeedResponse>;
  sendPasswordLink?: Maybe<SendPasswordLinkResponse>;
  stullerPayAddToCart?: Maybe<StullerPayResponse>;
  stullerPayAddToCartJson?: Maybe<StullerPayResponse>;
  submitContactRequest: SubmitContactResponse;
  submitPayments?: Maybe<SubmitPaymentResult>;
  submitRequestAQuote?: Maybe<RequestAQuoteResponse>;
  updateAutomaticPayment?: Maybe<UpdateAutomaticPaymentResult>;
  validateReturnShippingAddress: ValidateReturnShippingAddressResponse;
};


export type MutationAddOrderCommentsArgs = {
  params: AddOrderCommentsParams;
};


export type MutationAddToFavoritesArgs = {
  params: AddToFavoritesParams;
};


export type MutationCancelAutomaticPaymentArgs = {
  input: CancelAutomaticPaymentParams;
};


export type MutationCancelFakePaymentArgs = {
  input: CancelFakePaymentParams;
};


export type MutationCancelLineArgs = {
  params: CancelLineParams;
};


export type MutationCancelOrderArgs = {
  params: CancelOrderParams;
};


export type MutationCreateAutomaticPaymentForOrderArgs = {
  input: CreateAutomaticPaymentForOrderParams;
};


export type MutationCreateAutomaticPaymentForStatementArgs = {
  input: CreateAutomaticPaymentForStatementParams;
};


export type MutationCreateAutomaticPaymentForTransactionsArgs = {
  input: CreateAutomaticPaymentForTransactionsParams;
};


export type MutationCreateFakePaymentArgs = {
  input: CreateFakePaymentParams;
};


export type MutationCreateProductDataFeedArgs = {
  input?: Maybe<CreateDataFeedParams>;
};


export type MutationCreateRmaArgs = {
  input?: Maybe<CreateRmaInput>;
};


export type MutationDeleteBankAccountArgs = {
  input?: Maybe<DeleteBankAccountParams>;
};


export type MutationDeleteCreditCardArgs = {
  input?: Maybe<DeleteCredtCardParams>;
};


export type MutationFinalizeAutomaticPaymentArgs = {
  input: FinalizeAutomaticPaymentParams;
};


export type MutationSaveCardArgs = {
  input?: Maybe<SaveCardParams>;
};


export type MutationSaveDefaultPaymentMethodArgs = {
  input?: Maybe<SaveDefaultPaymentMethodParams>;
};


export type MutationSaveNewBankAccountArgs = {
  input?: Maybe<SaveNewBankAccountParams>;
};


export type MutationSaveSeriesArgs = {
  input?: Maybe<SaveSeriesParams>;
};


export type MutationSaveSkuArgs = {
  input?: Maybe<SaveSkuParams>;
};


export type MutationSendPasswordLinkArgs = {
  input: SendPasswordLinkParams;
};


export type MutationStullerPayAddToCartArgs = {
  input: StullerPayAddToCartParams;
};


export type MutationStullerPayAddToCartJsonArgs = {
  input: Scalars['JSON'];
};


export type MutationSubmitContactRequestArgs = {
  params: SubmitContactRequestParams;
};


export type MutationSubmitPaymentsArgs = {
  input: SubmitPaymentParams;
};


export type MutationSubmitRequestAQuoteArgs = {
  input?: Maybe<Scalars['JSON']>;
};


export type MutationUpdateAutomaticPaymentArgs = {
  input: UpdateAutomaticPaymentParams;
};


export type MutationValidateReturnShippingAddressArgs = {
  params: ValidateReturnShippingAddressParams;
};

export type NavigationItem = {
  __typename?: 'NavigationItem';
  Children?: Maybe<Array<Maybe<NavigationItem>>>;
  CssClass?: Maybe<Scalars['String']>;
  FromSectionTitle?: Maybe<Scalars['String']>;
  ImageAsset?: Maybe<ImageAsset>;
  IsSelected: Scalars['Boolean'];
  LinkText: Scalars['String'];
  LinkUrl: Scalars['String'];
  TrackingName: Scalars['String'];
  Value: Scalars['String'];
};

export type NavigationSection = {
  __typename?: 'NavigationSection';
  CssClass?: Maybe<Scalars['String']>;
  DecorationText?: Maybe<Scalars['String']>;
  DefaultImageAsset?: Maybe<ImageAsset>;
  HideForSterling: Scalars['Boolean'];
  IsMultiSelect: Scalars['Boolean'];
  IsPivot: Scalars['Boolean'];
  IsSingleSelect: Scalars['Boolean'];
  Layout: Scalars['String'];
  LoggedInOnly: Scalars['Boolean'];
  NavPosition: Scalars['String'];
  NavigationItems: Array<NavigationItem>;
  SearchField: Scalars['String'];
  SelectedNavigationItem?: Maybe<NavigationItem>;
  SortOrder?: Maybe<Scalars['Int']>;
  Title: Scalars['String'];
  TopLabel: Scalars['String'];
  UseDecorationForLink: Scalars['Boolean'];
  UseIcon: Scalars['Boolean'];
};

export type NonPastDueCodReceivableTransactionResults = {
  __typename?: 'NonPastDueCODReceivableTransactionResults';
  NonPastDueCODTransactions: Array<ReceivableTransactionRollup>;
};

export type OracleAttachmentViewModel = {
  __typename?: 'OracleAttachmentViewModel';
  CategoryText: Scalars['String'];
  Text: Scalars['String'];
};

export type OracleInvoiceViewModel = {
  __typename?: 'OracleInvoiceViewModel';
  CodTotalAmt: Scalars['Int'];
  CodTotalAmtString: Scalars['String'];
  InvoiceDate: Scalars['Date'];
  InvoiceDateShortString: Scalars['String'];
  InvoiceNumber: Scalars['Int'];
  InvoiceTotal: Scalars['Int'];
  InvoiceTotalString: Scalars['String'];
  InvoiceUrl: Scalars['String'];
  IsPickUp: Scalars['Boolean'];
  PickedUpDate?: Maybe<Scalars['Date']>;
  ReadyForPickUpDate?: Maybe<Scalars['Date']>;
  SalesTax: Scalars['Int'];
  ShipmentTracking?: Maybe<ShipmentTracking>;
  ShippingCarrier?: Maybe<Scalars['String']>;
  ShippingCarrierTrackingSupported: Scalars['Boolean'];
  TrackingLink: Scalars['String'];
  TrackingNumber: Scalars['String'];
};

export type OracleOrderDetailViewModel = {
  __typename?: 'OracleOrderDetailViewModel';
  AdditionalDescription: Scalars['String'];
  CamJobID?: Maybe<Scalars['Int']>;
  CanAddToCart: Scalars['Boolean'];
  CanShowConfigurationSummary: Scalars['Boolean'];
  CancelOrderRequested: Scalars['Boolean'];
  CancellationReasons: Array<CancellationReasonViewModel>;
  CancelledQuantity: Scalars['Float'];
  CertUrl: Scalars['String'];
  ConfigHeaderId: Scalars['Int'];
  ConfigOnWebNotOracle: Scalars['Boolean'];
  ConfigurationBaseProductUrl: Scalars['String'];
  ConfigurationImage: Scalars['String'];
  ConfigurationInventoryItemId?: Maybe<Scalars['Int']>;
  ConfigurationIsMonogram: Scalars['Boolean'];
  ConfigurationItemNumber?: Maybe<Scalars['String']>;
  ConfigurationPrice: Scalars['Float'];
  ConfigurationTitle: Scalars['String'];
  ConfigurationUrl: Scalars['String'];
  CreationDate: Scalars['Date'];
  CustomerPoNumber: Scalars['String'];
  Description: Scalars['String'];
  DocumentReference: Scalars['String'];
  EstShipDate?: Maybe<Scalars['Date']>;
  ExtendedSellingPrice: Scalars['Float'];
  FlowStatusCode: Scalars['String'];
  FreightTermsCode: Scalars['String'];
  FulfilledQuantity: Scalars['Float'];
  HasDivert: Scalars['Boolean'];
  HeaderId: Scalars['Int'];
  Image: Scalars['String'];
  InventoryItemId: Scalars['Int'];
  InvoiceToOrgId: Scalars['Int'];
  IsCadCam?: Maybe<Scalars['Boolean']>;
  IsCancellable: Scalars['Boolean'];
  IsCancelled: Scalars['Boolean'];
  IsFirstLineOfConfiguration: Scalars['Boolean'];
  IsLastLineOfConfiguration: Scalars['Boolean'];
  IsNonConfiguredHotStampingSku: Scalars['Boolean'];
  IsPartOfConfiguration: Scalars['Boolean'];
  IsShippable: Scalars['Boolean'];
  IsTopModelLine: Scalars['Boolean'];
  ItemNumber: Scalars['String'];
  ItemStatus: Scalars['String'];
  ItemTypeCode: Scalars['String'];
  ItemURL: Scalars['String'];
  LineCategoryCode: Scalars['String'];
  LineId: Scalars['Int'];
  LineNumber: Scalars['Int'];
  LineTypeId: Scalars['Int'];
  MakeBuy: Scalars['Int'];
  OrderNumber: Scalars['Int'];
  OrderQuantityUom: Scalars['String'];
  OrderedItem: Scalars['String'];
  OrderedQuantity: Scalars['Float'];
  OrgId: Scalars['Int'];
  PaymentMethod: Scalars['String'];
  PaymentTermId: Scalars['Int'];
  PrettyStatus: Scalars['String'];
  PriceListId: Scalars['Int'];
  PricingQuantity: Scalars['Float'];
  PricingQuantityUom: Scalars['String'];
  ProductTracking?: Maybe<Scalars['JSON']>;
  PtsQuality: Scalars['String'];
  PtsSrs: Scalars['String'];
  Report: Scalars['String'];
  RevisedShipDate?: Maybe<Scalars['Date']>;
  SerialNumber: Scalars['Int'];
  ShipFromOrgId: Scalars['Int'];
  ShipSetCode: Scalars['String'];
  ShipToOrgId: Scalars['Int'];
  ShippedQuantity: Scalars['Float'];
  ShippingMethod: Scalars['String'];
  ShippingQuantity: Scalars['Float'];
  ShippingQuantityUom: Scalars['String'];
  ShowActions: Scalars['Boolean'];
  ShowFakeConfigurationLine: Scalars['Boolean'];
  SoldFromOrgId: Scalars['Int'];
  SoldToOrgId: Scalars['Int'];
  SpecialInstructions: Scalars['String'];
  SpecialServiceCode: Scalars['String'];
  TopModelLineId?: Maybe<Scalars['Int']>;
  UnitListPrice: Scalars['Int'];
  UnitSellingPrice: Scalars['Int'];
  ValidatedWebConfigId?: Maybe<Scalars['Int']>;
  WMSStatus: Scalars['String'];
  WebConfigId?: Maybe<Scalars['Int']>;
  WebConfigIsInvalid: Scalars['Boolean'];
  WorkingDaysTil: Scalars['Int'];
};

export type OracleOrderViewModel = {
  __typename?: 'OracleOrderViewModel';
  AllItemsHaveShipped: Scalars['Boolean'];
  BillToAccountNumber: Scalars['String'];
  BillToAddress1: Scalars['String'];
  BillToAddress2: Scalars['String'];
  BillToAddress3: Scalars['String'];
  BillToAddress4: Scalars['String'];
  BillToCity: Scalars['String'];
  BillToCompanyName: Scalars['String'];
  BillToCountry: Scalars['String'];
  BillToCounty: Scalars['String'];
  BillToFormatted: Scalars['String'];
  BillToOrigSysRef: Scalars['String'];
  BillToProvince: Scalars['String'];
  BillToState: Scalars['String'];
  BillToZip: Scalars['String'];
  CanAddComments: Scalars['Boolean'];
  CreatedBy: Scalars['String'];
  CurrencyCode: Scalars['Int'];
  CustomerPoNumber: Scalars['String'];
  DropShipNumber: Scalars['String'];
  ExistsInWebTable: Scalars['Boolean'];
  ExportLink: Scalars['String'];
  IsCancellable: Scalars['Boolean'];
  IsCancelled: Scalars['Boolean'];
  IsDropShip: Scalars['Boolean'];
  IsInConsultantMode: Scalars['Boolean'];
  LastFourOfCreditCard: Scalars['String'];
  MaskedCreditCardNumber: Scalars['String'];
  OracleAttachments: Array<OracleAttachmentViewModel>;
  OracleInvoices: Array<OracleInvoiceViewModel>;
  OrderDate: Scalars['Date'];
  OrderDateToShortString: Scalars['String'];
  OrderDetails: Array<OracleOrderDetailViewModel>;
  OrderNumber: Scalars['Int'];
  OrderStatus: Scalars['String'];
  OrderTotal: Scalars['Int'];
  PaymentMethod: Scalars['String'];
  ShipToAccountNumber: Scalars['String'];
  ShipToAddress1: Scalars['String'];
  ShipToAddress2: Scalars['String'];
  ShipToAddress3: Scalars['String'];
  ShipToAddress4: Scalars['String'];
  ShipToCity: Scalars['String'];
  ShipToCompanyName: Scalars['String'];
  ShipToCountry: Scalars['String'];
  ShipToCounty: Scalars['String'];
  ShipToFormatted: Scalars['String'];
  ShipToLocation: Scalars['String'];
  ShipToOrigSysRef: Scalars['String'];
  ShipToProvince: Scalars['String'];
  ShipToState: Scalars['String'];
  ShipToTimeZone: Scalars['String'];
  ShipToZip: Scalars['String'];
  ShippingCarrier: Scalars['String'];
  ShippingCharge: Scalars['Int'];
  ShippingMethod: Scalars['String'];
  ShippingMethodDescription: Scalars['String'];
  SubTotal: Scalars['Int'];
  TaxTotal: Scalars['Int'];
  WebOrderNumber: Scalars['String'];
};

export type Order = {
  __typename?: 'Order';
  order?: Maybe<OracleOrderViewModel>;
};

export type OrderListingLineViewModel = {
  __typename?: 'OrderListingLineViewModel';
  ConfigHeaderId?: Maybe<Scalars['Int']>;
  Description?: Maybe<Scalars['String']>;
  ExtendedPrice?: Maybe<Scalars['String']>;
  Image: Scalars['String'];
  IsBulkChain: Scalars['Boolean'];
  IsConfigItem: Scalars['Boolean'];
  IsFiltered: Scalars['Boolean'];
  IsGroundShippingOnly: Scalars['Boolean'];
  IsHazardous: Scalars['Boolean'];
  IsHeavy: Scalars['Boolean'];
  IsMemo: Scalars['Boolean'];
  IsMetal: Scalars['Boolean'];
  IsReturnable: Scalars['Boolean'];
  ItemNumber: Scalars['String'];
  ItemTypeCode?: Maybe<Scalars['String']>;
  MetalsDetailString?: Maybe<Scalars['String']>;
  OracleOrderHeaderId?: Maybe<Scalars['Int']>;
  OracleOrderLineId: Scalars['Int'];
  OracleOrderNumber?: Maybe<Scalars['String']>;
  QuantityShipped: Scalars['Int'];
  ReturnNote?: Maybe<Scalars['String']>;
  ReturnQuantity?: Maybe<Scalars['Int']>;
  ReturnReason?: Maybe<Scalars['String']>;
  SerialNumber?: Maybe<Scalars['Int']>;
  ShipToAccountCountry?: Maybe<Scalars['String']>;
  ShipToAccountNumber?: Maybe<Scalars['String']>;
  ShipToAccountState?: Maybe<Scalars['String']>;
  SoldByDescription?: Maybe<Scalars['String']>;
  UOM?: Maybe<Scalars['String']>;
  UnitPrice: Scalars['String'];
  UnitWeightInPounds: Scalars['Int'];
  Url: Scalars['String'];
  WebOrderNumber?: Maybe<Scalars['String']>;
  pendingReturn?: Maybe<Scalars['Boolean']>;
};

export type OrderListingViewModel = {
  __typename?: 'OrderListingViewModel';
  BillToAccountNumber: Scalars['String'];
  HasReturnableOrderLines: Scalars['Boolean'];
  IsApprovalOrder: Scalars['Boolean'];
  IsExpanded?: Maybe<Scalars['Boolean']>;
  LoginId?: Maybe<Scalars['String']>;
  OracleOrderNumber?: Maybe<Scalars['String']>;
  OrderDate?: Maybe<Scalars['Date']>;
  OrderDateString?: Maybe<Scalars['String']>;
  OrderLines: Array<OrderListingLineViewModel>;
  OrderPONumber?: Maybe<Scalars['String']>;
  OrderStatus?: Maybe<Scalars['String']>;
  OrderTotal?: Maybe<Scalars['Int']>;
  OrderTotalString?: Maybe<Scalars['String']>;
  ShipToAccountNumber: Scalars['String'];
  WebOrderNumber?: Maybe<Scalars['String']>;
};

export type Orders = {
  __typename?: 'Orders';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  orders?: Maybe<Array<OrderListingViewModel>>;
  totalRecords?: Maybe<Scalars['Int']>;
};

export type Pager = {
  __typename?: 'Pager';
  ChangePageIsJavascript?: Maybe<Scalars['Boolean']>;
  CurrentPage: Scalars['Int'];
  FirstDisplayPage: Scalars['Int'];
  HidePagerWhenOnlyOnePageIsAvailable: Scalars['Boolean'];
  LastDisplayPage: Scalars['Int'];
  RecordsPerPage: Scalars['Int'];
  ShowingText: Scalars['String'];
  TotalPages: Scalars['Int'];
  TotalRecords: Scalars['Int'];
};

export type PaymentInvoice = {
  __typename?: 'PaymentInvoice';
  Amount: Currency;
  Id: Scalars['Int'];
  Installment?: Maybe<Scalars['Int']>;
  InvoiceId: Scalars['Int'];
  InvoiceNumber: Scalars['String'];
  PaymentId: Scalars['Int'];
  SequenceNumber?: Maybe<Scalars['Int']>;
  TransactionType?: Maybe<Scalars['String']>;
  TransactionTypeDisplay?: Maybe<Scalars['String']>;
};

export type PaymentInvoicesResults = {
  __typename?: 'PaymentInvoicesResults';
  Invoices: Array<PaymentInvoice>;
  Page: Scalars['Int'];
  PageSize: Scalars['Int'];
  TotalInvoices: Scalars['Int'];
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  BankAccount?: Maybe<BankAccount>;
  CardTypeIcon?: Maybe<Scalars['String']>;
  CreditCard?: Maybe<CreditCard>;
  DisplayCardType?: Maybe<Scalars['String']>;
  DisplayName: Scalars['String'];
  IsSelected: Scalars['Boolean'];
  Method: Scalars['String'];
  OnlyShowInConsultantMode: Scalars['Boolean'];
  SelectableValue: Scalars['String'];
  UniqueKey: Scalars['String'];
};

export type PaymentMethodOption = {
  __typename?: 'PaymentMethodOption';
  Method: PaymentMethodType;
  UniqueKey: Scalars['String'];
};

export type PaymentMethodResponse = {
  __typename?: 'PaymentMethodResponse';
  AllowedCreditCardTypes: Array<CreditCardType>;
  AllowedMethods: Array<PaymentMethodType>;
  AllowedMethodsForConsultantOnly: Array<PaymentMethodType>;
  IsLoggedIn: Scalars['Boolean'];
  NoneSelected: Scalars['Boolean'];
  PaymentMethods: Array<PaymentMethod>;
  UserCanUseACH: Scalars['Boolean'];
  UserCanUseCOD: Scalars['Boolean'];
  UserCanUseCreditCards: Scalars['Boolean'];
  UserCanUseDebitCards: Scalars['Boolean'];
  UserCanUseTerms: Scalars['Boolean'];
};

export enum PaymentMethodType {
  Ach = 'ACH',
  Cod = 'COD',
  Creditcard = 'CREDITCARD',
  Debitandcreditcard = 'DEBITANDCREDITCARD',
  Debitcard = 'DEBITCARD',
  Oraclecard = 'ORACLECARD',
  Terms = 'TERMS'
}

export type PaymentOnAccount = {
  __typename?: 'PaymentOnAccount';
  AccountId: Scalars['String'];
  Amount: Currency;
  BillToAccountNumber?: Maybe<Scalars['String']>;
  Id: Scalars['Int'];
  PaymentAuthorizationCode?: Maybe<Scalars['String']>;
  PaymentCreditCardType?: Maybe<Scalars['String']>;
  PaymentDate: Scalars['Date'];
  PaymentLabel: Scalars['String'];
  PaymentType: Scalars['String'];
  ProcessingStatus?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['String']>;
};

export type PimData = {
  __typename?: 'PimData';
  Attributes: Attributes;
  Connector: Connector;
};

export type Product = {
  __typename?: 'Product';
  DefaultCDNImagePath: Scalars['String'];
  ItemNumber: Scalars['String'];
  ProductUrl: Scalars['String'];
  Title: Scalars['String'];
};

export type ProductDataFeed = {
  __typename?: 'ProductDataFeed';
  CreationDate?: Maybe<Scalars['Date']>;
  Description?: Maybe<Scalars['String']>;
  FileName?: Maybe<Scalars['String']>;
  Id?: Maybe<Scalars['Int']>;
  LoginId?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
  Process?: Maybe<Scalars['Boolean']>;
  ProcessComplete?: Maybe<Scalars['Boolean']>;
  ProcessCount?: Maybe<Scalars['Int']>;
  ProductRequest?: Maybe<Scalars['String']>;
  Properties?: Maybe<Scalars['String']>;
};

export type ProductDataFeedResults = {
  __typename?: 'ProductDataFeedResults';
  SavedExports: Array<ProductDataFeed>;
};

export type ProductSearchAttribute = {
  __typename?: 'ProductSearchAttribute';
  AttributeImageAsset?: Maybe<ImageAsset>;
  AttributeValue: Scalars['String'];
  ImageUrls?: Maybe<ImageUrlsDto>;
  ItemDetailsUrl: Scalars['String'];
  ItemId: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  addToFavoritesOptions?: Maybe<FavoritesOptions>;
  /** Get available ship to accounts on current user */
  availableShipToAccounts: ShipToAccounts;
  /** Get CMS content by content container id or content container name */
  cmsContent?: Maybe<Scalars['String']>;
  /** Get nav content container id by category */
  cmsNavContentContainerId?: Maybe<Scalars['Int']>;
  /** Get context for the current session */
  context: Context;
  darkMode: Scalars['Boolean'];
  findAllActiveAutorenewalsByCreditCardId?: Maybe<LoyaltyProgramDetails>;
  findShipToAccountNumbers: Array<ShipToAccountNumber>;
  getAddAHeadColliderObject?: Maybe<SuperColliderObject>;
  getAddAHeadFacetsAndResults?: Maybe<AddAHeadFacetsAndResults>;
  getApprovalOrder?: Maybe<Scalars['String']>;
  getArticleResults: ArticleResultsResponse;
  getAutomaticPayments: Array<AutomaticPayment>;
  getCategoryNavigation: CategoryOrSearchViewModel;
  getConfigItemSummary?: Maybe<ConfigResponse>;
  getContactsFromShipToAccount: Array<ContactViewModel>;
  getContainsCustomsDocuments?: Maybe<GetContainsCustomsDocumentsResponse>;
  getCurrentBalanceAccountSummary?: Maybe<ReceivableTransactionBillToAccountSummary>;
  getCurrentStatementAccountSummary?: Maybe<ReceivableTransactionBillToAccountSummary>;
  getCustomsDocumentsForInvoice?: Maybe<GetCustomsDocumentsForInvoiceResponse>;
  getDataExportFeeds?: Maybe<ProductDataFeedResults>;
  getDiscountedProducts: DiscountedProductResultsResponse;
  getFakePayment?: Maybe<FakePayment>;
  getFakePaymentIds?: Maybe<Array<Scalars['Int']>>;
  getHasMissingLogoOnConfig?: Maybe<LogoResponse>;
  getInvoices?: Maybe<InvoiceSearchResults>;
  getLookupsByType: Array<Lookup>;
  getMetalQualities?: Maybe<Array<Maybe<MetalQuality>>>;
  getNewAuthToken: Scalars['String'];
  getNonPastDueCODTransactions?: Maybe<NonPastDueCodReceivableTransactionResults>;
  getOrderDetails?: Maybe<Order>;
  getOrders?: Maybe<Orders>;
  getPastDueBalanceAccountSummary?: Maybe<ReceivableTransactionBillToAccountSummary>;
  getPayment?: Maybe<PaymentOnAccount>;
  getPaymentInvoices?: Maybe<PaymentInvoicesResults>;
  getPaymentMethodsAndOptions?: Maybe<PaymentMethodResponse>;
  getPendingPayments: Array<PaymentOnAccount>;
  getProduct?: Maybe<GetProductResponse>;
  getReceivableTransactions?: Maybe<ReceivableTransactionResults>;
  getRequestAQuoteViewModel?: Maybe<RequestAQuoteViewModel>;
  getReturnReasons: Array<ReturnReason>;
  getSearchNavigation: CategoryOrSearchViewModel;
  getShippingCountdown?: Maybe<ShippingCountdownResults>;
  getStatementDates?: Maybe<StatementDates>;
  getTransactionsAccountSummary?: Maybe<ReceivableTransactionBillToAccountSummary>;
  getValidatedCadCamRequestSummary: ValidatedCadCamRequestViewModel;
  /** Get if Oracle is currently up or down */
  isOracleUp: Scalars['Boolean'];
  merchandiseSubmissionShippingRates?: Maybe<Array<MerchandiseSubmissionShippingRatesResults>>;
  monthlyStatementEligibility?: Maybe<MonthlyStatementEligibilityResult>;
  returnHistory?: Maybe<ReturnHistory>;
  stullerPay?: Maybe<StullerPayResponse>;
  /** Get system setting by name */
  systemSettingValue?: Maybe<SystemSettingResponse>;
  tokenizeCard: Scalars['String'];
};


export type QueryCmsContentArgs = {
  contentContainerId?: Maybe<Scalars['Int']>;
  contentContainerName?: Maybe<Scalars['String']>;
  params?: Maybe<Scalars['JSON']>;
};


export type QueryCmsNavContentContainerIdArgs = {
  input: CmsNavContentContainerIdInput;
};


export type QueryFindAllActiveAutorenewalsByCreditCardIdArgs = {
  params?: Maybe<FindAllActiveAutorenewalsByCreditCardIdParams>;
};


export type QueryFindShipToAccountNumbersArgs = {
  params: FindShipToAccountNumbersParams;
};


export type QueryGetAddAHeadColliderObjectArgs = {
  params?: Maybe<GetAddAHeadColliderObjectParams>;
};


export type QueryGetAddAHeadFacetsAndResultsArgs = {
  query: Scalars['String'];
};


export type QueryGetApprovalOrderArgs = {
  params: GetApprovalOrderParams;
};


export type QueryGetArticleResultsArgs = {
  params?: Maybe<ArticleResultsParams>;
};


export type QueryGetAutomaticPaymentsArgs = {
  params?: Maybe<AutomaticPaymentParams>;
};


export type QueryGetCategoryNavigationArgs = {
  params: Scalars['String'];
};


export type QueryGetConfigItemSummaryArgs = {
  params: GetConfigItemSummaryParams;
};


export type QueryGetContactsFromShipToAccountArgs = {
  params: GetContactsFromShipToAccountParams;
};


export type QueryGetContainsCustomsDocumentsArgs = {
  params: GetCustomsDocumentsParams;
};


export type QueryGetCustomsDocumentsForInvoiceArgs = {
  params: GetCustomsDocumentsParams;
};


export type QueryGetDiscountedProductsArgs = {
  groupuid: Scalars['Int'];
  searchsource?: Maybe<Scalars['String']>;
};


export type QueryGetFakePaymentArgs = {
  id: Scalars['Int'];
};


export type QueryGetHasMissingLogoOnConfigArgs = {
  params: GetConfigItemSummaryParams;
};


export type QueryGetInvoicesArgs = {
  params: GetInvoicesParams;
};


export type QueryGetLookupsByTypeArgs = {
  type: Scalars['String'];
};


export type QueryGetMetalQualitiesArgs = {
  query: Scalars['String'];
};


export type QueryGetOrderDetailsArgs = {
  params: GetOrderDetailsParams;
};


export type QueryGetOrdersArgs = {
  params: GetOrdersParams;
};


export type QueryGetPaymentArgs = {
  id: Scalars['Int'];
};


export type QueryGetPaymentInvoicesArgs = {
  id: Scalars['Int'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type QueryGetProductArgs = {
  params: GetProductParams;
};


export type QueryGetReceivableTransactionsArgs = {
  params: GetReceivableTransactionsParams;
};


export type QueryGetSearchNavigationArgs = {
  pathname: Scalars['String'];
  search: Scalars['String'];
};


export type QueryGetShippingCountdownArgs = {
  input?: Maybe<GetShippingCountdownInput>;
};


export type QueryGetTransactionsAccountSummaryArgs = {
  filter: TransactionFilter;
};


export type QueryGetValidatedCadCamRequestSummaryArgs = {
  id: Scalars['Int'];
};


export type QueryMerchandiseSubmissionShippingRatesArgs = {
  input?: Maybe<MerchandiseSubmissionShippingRatesInput>;
};


export type QueryReturnHistoryArgs = {
  params: ReturnHistoryParams;
};


export type QueryStullerPayArgs = {
  params?: Maybe<StullerPayParams>;
};


export type QuerySystemSettingValueArgs = {
  appendSearch?: Maybe<Scalars['String']>;
  settingName: Scalars['String'];
};

export type ReceivableInstallment = {
  __typename?: 'ReceivableInstallment';
  AmountDue: Currency;
  DueDate: Scalars['Date'];
  IsInAutomaticPayment: Scalars['Boolean'];
  OrderNumber: Scalars['String'];
  PONumber: Scalars['String'];
  Pending: Scalars['Boolean'];
  Sequence: Scalars['Int'];
  Status: Scalars['String'];
  Terms: Scalars['String'];
  TotalAmount: Currency;
  TransactionDate: Scalars['Date'];
  TransactionId: Scalars['Int'];
  TransactionNumber: Scalars['String'];
  Type: Scalars['String'];
};

export type ReceivableTransaction = {
  __typename?: 'ReceivableTransaction';
  AccountNumber: Scalars['String'];
  CurrencyCode: Scalars['String'];
  OrderNumber: Scalars['String'];
  PONumber?: Maybe<Scalars['String']>;
  ShipmentMethodCode: Scalars['String'];
  Status: Scalars['String'];
  Total: Scalars['Int'];
  TotalDue: Scalars['Int'];
  TrackingNumber: Scalars['String'];
  TransactionDate: Scalars['Date'];
  TransactionNumber: Scalars['Int'];
  TransactionType: Scalars['String'];
};

export type ReceivableTransactionBillToAccountSummary = {
  __typename?: 'ReceivableTransactionBillToAccountSummary';
  Balance: Currency;
  IncludesAutomaticPaymentTransaction?: Maybe<Scalars['Boolean']>;
  StatementIssueDate?: Maybe<Scalars['Date']>;
  TransactionCount: Scalars['Int'];
};

export type ReceivableTransactionResults = {
  __typename?: 'ReceivableTransactionResults';
  Page: Scalars['Int'];
  PageSize: Scalars['Int'];
  TotalTransactions: Scalars['Int'];
  Transactions: Array<ReceivableTransactionRollup>;
};

export type ReceivableTransactionRollup = {
  __typename?: 'ReceivableTransactionRollup';
  AmountDue: Currency;
  DueDate: Scalars['Date'];
  Installments: Array<ReceivableInstallment>;
  IsInAutomaticPayment: Scalars['Boolean'];
  OrderNumber: Scalars['String'];
  PONumber: Scalars['String'];
  Pending: Scalars['Boolean'];
  ShipToAccountNumber: Scalars['String'];
  Status: Scalars['String'];
  Terms: Scalars['String'];
  TotalAmount: Currency;
  TransactionDate: Scalars['Date'];
  TransactionId: Scalars['Int'];
  TransactionNumber: Scalars['String'];
  Type: Scalars['String'];
};

export type Renewals = {
  __typename?: 'Renewals';
  DateForAutoRenewal?: Maybe<Scalars['String']>;
  IsStullerFirst?: Maybe<Scalars['Boolean']>;
  Name?: Maybe<Scalars['String']>;
};

export type RequestAQuoteResponse = {
  __typename?: 'RequestAQuoteResponse';
  messages?: Maybe<Array<Scalars['String']>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RequestAQuoteViewModel = {
  __typename?: 'RequestAQuoteViewModel';
  CompanyName?: Maybe<Scalars['String']>;
  ConfirmationEmail?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  FirstName?: Maybe<Scalars['String']>;
  LastName?: Maybe<Scalars['String']>;
  MessageToJeweler?: Maybe<Scalars['String']>;
  PhoneNumber?: Maybe<Scalars['String']>;
};

export type ReturnHistory = {
  __typename?: 'ReturnHistory';
  returns?: Maybe<Array<ReturnHistoryItem>>;
  totalRecords?: Maybe<Scalars['Int']>;
};

export type ReturnHistoryItem = {
  __typename?: 'ReturnHistoryItem';
  AccountNumber: Scalars['String'];
  OrderDate: Scalars['String'];
  OrderDateString: Scalars['String'];
  OrderLineCount: Scalars['Int'];
  OrderNumber: Scalars['Int'];
  Status: Scalars['String'];
  TotalPrice: Scalars['Int'];
  TrackingNumber?: Maybe<Scalars['String']>;
  TrackingUrl?: Maybe<Scalars['String']>;
  WebNumber?: Maybe<Scalars['Int']>;
};

export type ReturnHistoryParams = {
  beginDate?: Maybe<Scalars['Date']>;
  days?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['Date']>;
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  shipToAccountNumber?: Maybe<Scalars['String']>;
};

export type ReturnItem = {
  ConfigHeaderId?: Maybe<Scalars['Int']>;
  Description?: Maybe<Scalars['String']>;
  ExtendedPrice?: Maybe<Scalars['String']>;
  Image: Scalars['String'];
  IsConfigItem: Scalars['Boolean'];
  IsFiltered: Scalars['Boolean'];
  IsGroundShippingOnly: Scalars['Boolean'];
  IsHazardous: Scalars['Boolean'];
  IsHeavy: Scalars['Boolean'];
  IsMemo: Scalars['Boolean'];
  IsMetal: Scalars['Boolean'];
  IsReturnable: Scalars['Boolean'];
  ItemNumber: Scalars['String'];
  ItemTypeCode?: Maybe<Scalars['String']>;
  MetalsDetailString?: Maybe<Scalars['String']>;
  OracleOrderHeaderId?: Maybe<Scalars['Int']>;
  OracleOrderLineId: Scalars['Int'];
  OracleOrderNumber?: Maybe<Scalars['String']>;
  QuantityShipped: Scalars['Int'];
  ReturnNote?: Maybe<Scalars['String']>;
  ReturnQuantity?: Maybe<Scalars['Int']>;
  ReturnReason?: Maybe<Scalars['String']>;
  SerialNumber?: Maybe<Scalars['Int']>;
  ShipToAccountCountry?: Maybe<Scalars['String']>;
  ShipToAccountNumber?: Maybe<Scalars['String']>;
  ShipToAccountState?: Maybe<Scalars['String']>;
  SoldByDescription?: Maybe<Scalars['String']>;
  UOM?: Maybe<Scalars['String']>;
  UnitPrice: Scalars['String'];
  UnitWeightInPounds: Scalars['Int'];
  Url: Scalars['String'];
  WebOrderNumber?: Maybe<Scalars['String']>;
  pendingReturn?: Maybe<Scalars['Boolean']>;
};

export type ReturnReason = {
  __typename?: 'ReturnReason';
  Code: Scalars['String'];
  Meaning: Scalars['String'];
};

export type RingSizeSelect = {
  __typename?: 'RingSizeSelect';
  Key: Scalars['Int'];
  Value: Scalars['String'];
};

export type SaveCardParams = {
  allowedMethods: Array<Scalars['String']>;
  creditCard: CreditCardParams;
  setAsDefault?: Maybe<Scalars['Boolean']>;
};

export type SaveCardResponse = {
  __typename?: 'SaveCardResponse';
  creditCard?: Maybe<CreditCard>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success: Scalars['Boolean'];
};

export type SaveDataFeedResponse = {
  __typename?: 'SaveDataFeedResponse';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SaveDefaultPaymentMethodParams = {
  paymentMethod: Scalars['String'];
  paymentMethodId?: Maybe<Scalars['String']>;
};

export type SaveDefaultPaymentMethodResponse = {
  __typename?: 'SaveDefaultPaymentMethodResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success: Scalars['Boolean'];
};

export type SaveNewBankAccountParams = {
  bankAccount?: Maybe<BankAccountInput>;
};

export type SaveNewBankAccountResponse = {
  __typename?: 'SaveNewBankAccountResponse';
  bankAccount?: Maybe<BankAccount>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success: Scalars['Boolean'];
};

export type SaveSeriesParams = {
  ProductDataFeedId?: Maybe<Scalars['Int']>;
  Series?: Maybe<Scalars['String']>;
};

export type SaveSkuParams = {
  ProductDataFeedId?: Maybe<Scalars['Int']>;
  Sku?: Maybe<Scalars['String']>;
};

export type SearchByStoneSizeViewModel = {
  __typename?: 'SearchByStoneSizeViewModel';
  Dimension: Scalars['String'];
  MetalColors: Array<TupleString2>;
  ProductType: Scalars['String'];
  ProductTypes: Array<TupleString2>;
  ProngCount: Scalars['String'];
  ProngCounts: Array<TupleString2>;
  SelectedMetalColors: Array<Maybe<Scalars['String']>>;
  SelectedProductTypes: Array<Maybe<Scalars['String']>>;
  Shape: Scalars['String'];
  StoneShapes: Array<StoneShapeViewModel>;
  StringDimensions: Array<TupleString2>;
  Style: Scalars['String'];
  Styles: Array<TupleString2>;
};

export type SearchFilters = {
  __typename?: 'SearchFilters';
  AdditionalFirstString?: Maybe<Scalars['String']>;
  Filter?: Maybe<Array<Maybe<Scalars['String']>>>;
  Label?: Maybe<Scalars['String']>;
  Name?: Maybe<Scalars['String']>;
};

export { SearchPresentationContext };

export type SearchResult = {
  __typename?: 'SearchResult';
  ClickLoggingPayload?: Maybe<Scalars['String']>;
  Code: Scalars['String'];
  CountryOfOrigin?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  DiscountIsFlashSaleAndStullerFirst: Scalars['Boolean'];
  DisplayPrice?: Maybe<Scalars['String']>;
  FeaturedSearchAttribute?: Maybe<Scalars['String']>;
  FeaturedSearchAttributeValue?: Maybe<Scalars['String']>;
  FeaturedSearchAttributeValues?: Maybe<Array<ProductSearchAttribute>>;
  GeographicalOrigin?: Maybe<Scalars['String']>;
  GroupDetailsUrl?: Maybe<Scalars['String']>;
  Id: Scalars['Int'];
  ImageUrls?: Maybe<ImageUrlsDto>;
  ImageUrlsSide?: Maybe<ImageUrlsDto>;
  IsDiscounted: Scalars['Boolean'];
  IsMadeWithCycledMaterials: Scalars['Boolean'];
  IsPrincipledSourcing: Scalars['Boolean'];
  IsSCSCertified: Scalars['Boolean'];
  IsValidFor3CBadge: Scalars['Boolean'];
  IsValidForBestSellerBadge: Scalars['Boolean'];
  IsValidForCoinedBadge: Scalars['Boolean'];
  IsValidForDieStruckBadge: Scalars['Boolean'];
  IsValidForDigitalImprintingBadge: Scalars['Boolean'];
  IsValidForEverAndEverBadge: Scalars['Boolean'];
  IsValidForHotStampingBadge: Scalars['Boolean'];
  IsValidForLabGrownBadge: Scalars['Boolean'];
  IsValidForLimitedTimeOnlyBadge: Scalars['Boolean'];
  IsValidForMachinedBadge: Scalars['Boolean'];
  IsValidForMetalMoldBadge: Scalars['Boolean'];
  IsValidForNewDealBadge: Scalars['Boolean'];
  IsValidForNewItemBadge: Scalars['Boolean'];
  IsValidForNotableGemsBadge: Scalars['Boolean'];
  KnownOrigin?: Maybe<Scalars['Boolean']>;
  MaxDiscount?: Maybe<Scalars['Int']>;
  MinDiscount?: Maybe<Scalars['Int']>;
  OverrideItemId?: Maybe<Scalars['Int']>;
  ParentCode?: Maybe<Scalars['String']>;
  ProductState?: Maybe<Scalars['String']>;
  ProductTracking: Scalars['JSON'];
  Rank?: Maybe<Scalars['String']>;
  SearchId?: Maybe<Scalars['String']>;
  SerialNumber?: Maybe<Scalars['Int']>;
  TemplatePage?: Maybe<Scalars['String']>;
  WholeGroupIsDiscounted?: Maybe<Scalars['Boolean']>;
};

export type SearchScaffoldViewModel = {
  __typename?: 'SearchScaffoldViewModel';
  bestSellers?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Scalars['String']>;
  centerStone?: Maybe<Scalars['String']>;
  facetValues?: Maybe<Array<FacetValue>>;
  featured?: Maybe<Scalars['String']>;
  originalQuery?: Maybe<Scalars['String']>;
  overrideSpellingSuggestion?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  pageTitle?: Maybe<Scalars['String']>;
  query: Scalars['String'];
  sanitizedCategoryNames: Array<Scalars['String']>;
  searchType?: Maybe<Scalars['String']>;
  showfeaturedForDev?: Maybe<Scalars['Boolean']>;
  sortby?: Maybe<Scalars['String']>;
  suggested?: Maybe<Scalars['Boolean']>;
  suggestionRank?: Maybe<Scalars['Int']>;
};

export type SearchSuggestion = {
  __typename?: 'SearchSuggestion';
  ClickLoggingPayload?: Maybe<Scalars['String']>;
  Rank?: Maybe<Scalars['String']>;
  Suggestion?: Maybe<Scalars['String']>;
};

export type SelectListItem = {
  __typename?: 'SelectListItem';
  Disabled: Scalars['Boolean'];
  Group?: Maybe<Scalars['String']>;
  Selected: Scalars['Boolean'];
  Text?: Maybe<Scalars['String']>;
  Value?: Maybe<Scalars['String']>;
};

export type SelectedContactViewModel = {
  BusinessPhoneNumber: Scalars['String'];
  CadCamAcceptAllModFees?: Maybe<Scalars['Boolean']>;
  EmailAddress: Scalars['String'];
  FirstName: Scalars['String'];
  LastName: Scalars['String'];
  MobilePhoneNumber?: Maybe<Scalars['String']>;
};

export type SelectedFacet = {
  __typename?: 'SelectedFacet';
  FromSection?: Maybe<Scalars['String']>;
  Name: Scalars['String'];
  SearchField: Scalars['String'];
  Url: Scalars['String'];
  Value: Scalars['String'];
};

export type SendPasswordLinkParams = {
  key: Scalars['String'];
};

export type SendPasswordLinkResponse = {
  __typename?: 'SendPasswordLinkResponse';
  success: Scalars['Boolean'];
};

export enum ShapeType {
  AntiqueCushion = 'AntiqueCushion',
  AntiqueSquare = 'AntiqueSquare',
  Asscher = 'Asscher',
  Baguettes = 'Baguettes',
  Cushion = 'Cushion',
  Emerald = 'Emerald',
  HalfMoon = 'HalfMoon',
  Heart = 'Heart',
  Hexagon = 'Hexagon',
  Kite = 'Kite',
  Marquise = 'Marquise',
  Oval = 'Oval',
  Pear = 'Pear',
  Princess = 'Princess',
  Radiant = 'Radiant',
  Round = 'Round',
  Square = 'Square',
  StraightBaguette = 'StraightBaguette',
  TaperedBaguette = 'TaperedBaguette',
  Trapezoid = 'Trapezoid',
  Triangle = 'Triangle',
  Trillion = 'Trillion'
}

/** ShipToAccount object for Stuller.com */
export type ShipToAccount = {
  __typename?: 'ShipToAccount';
  HtmlFormattedAddress: Scalars['String'];
  InlineFormattedAddress: Scalars['String'];
  IsActive: Scalars['Boolean'];
  ShipToAccountNumber: Scalars['String'];
};

export type ShipToAccountNumber = {
  __typename?: 'ShipToAccountNumber';
  label: Scalars['String'];
  value: Scalars['String'];
};

/** Response for ShipToAccount/ActiveShipToAccounts */
export type ShipToAccounts = {
  __typename?: 'ShipToAccounts';
  shipToAccounts: Array<ShipToAccount>;
};

export type ShipmentTracking = {
  __typename?: 'ShipmentTracking';
  Delivered: Scalars['Boolean'];
  DeliveryDate?: Maybe<Scalars['Date']>;
  EstDeliveryDate?: Maybe<Scalars['Date']>;
  FromCity?: Maybe<Scalars['String']>;
  FromState?: Maybe<Scalars['String']>;
  Message?: Maybe<Scalars['String']>;
  PickedUpByCarrier: Scalars['Boolean'];
  ShipmentMethod: Scalars['String'];
  SignedForBy?: Maybe<Scalars['String']>;
  Status: Scalars['String'];
  Success: Scalars['Boolean'];
  ToCity?: Maybe<Scalars['String']>;
  ToState?: Maybe<Scalars['String']>;
  TrackingNumber: Scalars['String'];
  TransitDetails?: Maybe<Array<Maybe<ShipmentTrackingStep>>>;
};

export type ShipmentTrackingStep = {
  __typename?: 'ShipmentTrackingStep';
  City?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  Location?: Maybe<Scalars['String']>;
  State?: Maybe<Scalars['String']>;
  TimeStamp: Scalars['Date'];
};

export type ShippingCountdownResults = {
  __typename?: 'ShippingCountdownResults';
  countdownType?: Maybe<CountdownType>;
  cutoff?: Maybe<Scalars['Date']>;
  showCountdown?: Maybe<Scalars['Boolean']>;
};

export type SourceList = {
  __typename?: 'SourceList';
  Key: Scalars['String'];
  Value: Scalars['String'];
};

export type StatementDates = {
  __typename?: 'StatementDates';
  MaxDate?: Maybe<Scalars['Int']>;
  MinDate?: Maybe<Scalars['Int']>;
};

export type StoneForViewAvailableMountingsViewModel = {
  __typename?: 'StoneForViewAvailableMountingsViewModel';
  Category?: Maybe<Scalars['String']>;
  Color: Scalars['String'];
  Cut: Scalars['String'];
  DetailsUrl: Scalars['String'];
  HexColor: Scalars['String'];
  ID: Scalars['Int'];
  Image: ImageUrlsDto;
  IsDiamond: Scalars['Boolean'];
  Price: Scalars['String'];
  PriceWithoutDiscount: Scalars['String'];
  SerialNumber: Scalars['Int'];
  Shape: Scalars['String'];
  SizeCt?: Maybe<Scalars['String']>;
  SizeMm: Scalars['String'];
  StoneQuality: Scalars['String'];
  Type: Scalars['String'];
  Uniqueness: Scalars['String'];
  Variety: Scalars['String'];
};

export type StoneShapeViewModel = {
  __typename?: 'StoneShapeViewModel';
  CssClassName: Scalars['String'];
  DisplayName: Scalars['String'];
  PostValue: Scalars['String'];
  ShapeType: ShapeType;
  VectorId: Scalars['String'];
};

export enum StoneType {
  Diamond = 'Diamond',
  Gemstone = 'Gemstone',
  MountingLocation = 'MountingLocation',
  Unknown = 'Unknown'
}

export type StullerPayAddToCartParams = {
  addToCart: AddToCartDtoInput;
};

export type StullerPayParams = {
  productId: Scalars['Int'];
  quantity: Scalars['Int'];
  shipToAccountNumber?: Maybe<Scalars['String']>;
  shippingMethod?: Maybe<Scalars['String']>;
};

export type StullerPayResponse = {
  __typename?: 'StullerPayResponse';
  Eligible: Scalars['Boolean'];
  Errors?: Maybe<Array<Scalars['String']>>;
  IsOracleDown: Scalars['Boolean'];
  SessionId?: Maybe<Scalars['ID']>;
  TermOptions: Array<TermOption>;
};

export type SubmitContactRequestParams = {
  CadCamProfileViewModel: CadCamProfileViewModel;
};

export type SubmitContactResponse = {
  __typename?: 'SubmitContactResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SubmitPaymentParams = {
  accountId: Scalars['String'];
  amount: Scalars['Float'];
  amountType: Scalars['String'];
  currentStatementOnly?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['Date']>;
  nonPastDueCODTransactionIds?: Maybe<Array<Scalars['Int']>>;
  pastDueOnly?: Maybe<Scalars['Boolean']>;
  paymentComment?: Maybe<Scalars['String']>;
  paymentType: Scalars['String'];
  shipToAccount?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  transactionIds?: Maybe<Array<Scalars['Int']>>;
  transactionListType?: Maybe<Scalars['String']>;
};

export type SubmitPaymentResult = {
  __typename?: 'SubmitPaymentResult';
  PaymentId: Scalars['Int'];
};

export type SuggestedAddress = {
  __typename?: 'SuggestedAddress';
  City: Scalars['String'];
  CountyName?: Maybe<Scalars['String']>;
  PlusFour?: Maybe<Scalars['String']>;
  State: Scalars['String'];
  Street1: Scalars['String'];
  Street2?: Maybe<Scalars['String']>;
  Street3?: Maybe<Scalars['String']>;
  Zip: Scalars['String'];
};

export type SuperColliderObject = {
  __typename?: 'SuperColliderObject';
  Setting: ColliderData;
  Shank: ColliderData;
  Views: Array<Scalars['String']>;
};

export type SystemSettingResponse = {
  __typename?: 'SystemSettingResponse';
  value?: Maybe<Scalars['String']>;
};

export type TermOption = {
  __typename?: 'TermOption';
  FeeAmount: Scalars['Float'];
  FeePercentDecimal: Scalars['Float'];
  Id: Scalars['String'];
  MinimumPrice: Scalars['Float'];
  MonthlyPrice: Scalars['Float'];
  Option: Scalars['String'];
  Price: Scalars['Float'];
  ShippingCost?: Maybe<Scalars['Float']>;
  TermDisplay: Scalars['String'];
  TermValue: Scalars['Int'];
  TotalPrice: Scalars['Float'];
};

export type TokenizedPaymentMethodNumber = {
  __typename?: 'TokenizedPaymentMethodNumber';
  LastFour: Scalars['String'];
  TokenizedNumber: Scalars['String'];
};

export type TransactionFilter = {
  currentStatementOnly?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['Date']>;
  nonPastDueCODTransactionIds?: Maybe<Array<Scalars['Int']>>;
  pastDueOnly?: Maybe<Scalars['Boolean']>;
  shipToAccount?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  transactionIds?: Maybe<Array<Scalars['Int']>>;
  transactionListType?: Maybe<Scalars['String']>;
  transactionNumber?: Maybe<Scalars['String']>;
};

export type TupleString2 = {
  __typename?: 'TupleString2';
  Item1: Scalars['String'];
  Item2: Scalars['String'];
};

export type UpdateAutomaticPaymentParams = {
  AccountId?: Maybe<Scalars['String']>;
  AutomaticPaymentId: Scalars['Int'];
  DayOfMonth?: Maybe<Scalars['Int']>;
  DayOfWeek?: Maybe<Scalars['String']>;
  Frequency: Scalars['String'];
  Name: Scalars['String'];
  PaymentType?: Maybe<Scalars['String']>;
  ResetFailedState: Scalars['Boolean'];
};

export type UpdateAutomaticPaymentResult = {
  __typename?: 'UpdateAutomaticPaymentResult';
  AutomaticPaymentId: Scalars['Int'];
};

export type ValidateReturnShippingAddressParams = {
  ShipFromAddressLine1: Scalars['String'];
  ShipFromAddressLine2?: Maybe<Scalars['String']>;
  ShipFromCity: Scalars['String'];
  ShipFromCountry: Scalars['String'];
  ShipFromState: Scalars['String'];
  ShipFromZip: Scalars['String'];
};

export type ValidateReturnShippingAddressResponse = {
  __typename?: 'ValidateReturnShippingAddressResponse';
  shipFromErrorFound?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
  suggestedAddress?: Maybe<SuggestedAddress>;
};

export type ValidatedCadCamRequestViewModel = {
  __typename?: 'ValidatedCadCamRequestViewModel';
  CustomerReference?: Maybe<Scalars['String']>;
  ImageUrl?: Maybe<Scalars['String']>;
  MetalQuality?: Maybe<Scalars['String']>;
  Success: Scalars['Boolean'];
};

export type VignetteEngravingInfoInput = {
  EngravingText: Scalars['String'];
  HexColorValue?: Maybe<Scalars['String']>;
  LocationName: Scalars['String'];
  MeteorFont?: Maybe<Scalars['String']>;
  MeteorFontSizeScalingFactor?: Maybe<Scalars['Float']>;
};

export type VignetteStoneInfoInput = {
  Color: Scalars['String'];
  Cut: Scalars['String'];
  HexColorOverrideGemstone: Scalars['String'];
  Opacity?: Maybe<Scalars['Int']>;
  StoneLocationGroupName: Scalars['String'];
  Uniqueness: Scalars['String'];
  Variety: Scalars['String'];
};

export type GetAddAHeadFacetsAndResultsQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type GetAddAHeadFacetsAndResultsQuery = { __typename?: 'Query', getAddAHeadFacetsAndResults?: Maybe<{ __typename?: 'AddAHeadFacetsAndResults', Total?: Maybe<number>, QueryTimeMs?: Maybe<number>, Facets?: Maybe<{ __typename?: 'AddAHeadFacets', attr_string_Quality?: Maybe<Array<string>>, attr_string_Stone_Shape?: Maybe<Array<string>>, attr_string_Stone_Size?: Maybe<Array<string>>, attr_string_Product_State?: Maybe<Array<string>>, attr_string_Prong_Count?: Maybe<Array<string>>, series?: Maybe<Array<string>> }>, Items?: Maybe<Array<Maybe<{ __typename?: 'AddAHeadResult', DetailsUrl?: Maybe<string>, Product: { __typename?: 'AddAHeadProductDocument', id?: Maybe<string>, quickshop_id?: Maybe<number>, product_id: number, is_valid?: Maybe<boolean>, is_new?: Maybe<boolean>, image_angles?: Maybe<Array<Maybe<string>>>, group_by?: Maybe<string>, item_number?: Maybe<string>, group_ids?: Maybe<Array<Maybe<number>>>, default_group_id: number, filtered_group_ids?: Maybe<Array<Maybe<number>>>, category_ids?: Maybe<Array<Maybe<string>>>, categories?: Maybe<Array<Maybe<string>>>, filtered_category_ids?: Maybe<Array<Maybe<string>>>, filtered_categories?: Maybe<Array<Maybe<string>>>, serial_number: number, in_stock?: Maybe<boolean>, pricelist_ids?: Maybe<Array<Maybe<number>>>, attr_string_Quality: string, attr_string_Stone_Shape: string, attr_string_Stone_Size?: Maybe<string>, attr_string_Product_State?: Maybe<string>, attr_string_Prong_Count?: Maybe<string>, attr_string_Title?: Maybe<string>, attrs_string_Related_Shank_Product_Id?: Maybe<Array<Maybe<string>>>, attrs_string_Parent_ATO_Model_Number: Array<Maybe<string>>, series?: Maybe<Array<Maybe<string>>>, attr_string_Secondary_Stone_Type?: Maybe<string>, attr_string_Secondary_Stone_Origin?: Maybe<string>, attrs_string_img_A?: Maybe<{ __typename?: 'ImageUrlsDto', RawUrl?: Maybe<string>, FullSizeUrl?: Maybe<string>, Thumb75Url?: Maybe<string>, Thumb125Url?: Maybe<string>, Thumb150Url?: Maybe<string>, Thumb165Url: string, Thumb100Url?: Maybe<string>, Thumb40Url?: Maybe<string>, Size640Url?: Maybe<string>, Size430Url?: Maybe<string>, Size350Url?: Maybe<string>, Size250Url: string, Size190Url?: Maybe<string>, ZoomUrl?: Maybe<string>, Height?: Maybe<number>, Width?: Maybe<number>, Format?: Maybe<string>, IsZoomable?: Maybe<boolean>, IsSuperZoomable?: Maybe<boolean>, SortOrder?: Maybe<number>, IsNotFoundImage?: Maybe<boolean>, MediaType?: Maybe<string>, Video1024x768Html?: Maybe<string>, Video640x480Html?: Maybe<string>, Preview360PDP?: Maybe<string>, Preview360Compare?: Maybe<string>, Preview360Zoom?: Maybe<string>, Video360CompareHtml?: Maybe<string>, Video360PDPHtml?: Maybe<string>, Video360ZoomHtml?: Maybe<string>, VideoDynamicHtml?: Maybe<string>, ImageId: number, Angle?: Maybe<string> }>, attrs_string_img_AngleA?: Maybe<{ __typename?: 'ImageUrlsDto', RawUrl?: Maybe<string>, FullSizeUrl?: Maybe<string>, Thumb75Url?: Maybe<string>, Thumb125Url?: Maybe<string>, Thumb150Url?: Maybe<string>, Thumb165Url: string, Thumb100Url?: Maybe<string>, Thumb40Url?: Maybe<string>, Size640Url?: Maybe<string>, Size430Url?: Maybe<string>, Size350Url?: Maybe<string>, Size250Url: string, Size190Url?: Maybe<string>, ZoomUrl?: Maybe<string>, Height?: Maybe<number>, Width?: Maybe<number>, Format?: Maybe<string>, IsZoomable?: Maybe<boolean>, IsSuperZoomable?: Maybe<boolean>, SortOrder?: Maybe<number>, IsNotFoundImage?: Maybe<boolean>, MediaType?: Maybe<string>, Video1024x768Html?: Maybe<string>, Video640x480Html?: Maybe<string>, Preview360PDP?: Maybe<string>, Preview360Compare?: Maybe<string>, Preview360Zoom?: Maybe<string>, Video360CompareHtml?: Maybe<string>, Video360PDPHtml?: Maybe<string>, Video360ZoomHtml?: Maybe<string>, VideoDynamicHtml?: Maybe<string>, ImageId: number, Angle?: Maybe<string> }>, attrs_string_img_B?: Maybe<{ __typename?: 'ImageUrlsDto', RawUrl?: Maybe<string>, FullSizeUrl?: Maybe<string>, Thumb75Url?: Maybe<string>, Thumb125Url?: Maybe<string>, Thumb150Url?: Maybe<string>, Thumb165Url: string, Thumb100Url?: Maybe<string>, Thumb40Url?: Maybe<string>, Size640Url?: Maybe<string>, Size430Url?: Maybe<string>, Size350Url?: Maybe<string>, Size250Url: string, Size190Url?: Maybe<string>, ZoomUrl?: Maybe<string>, Height?: Maybe<number>, Width?: Maybe<number>, Format?: Maybe<string>, IsZoomable?: Maybe<boolean>, IsSuperZoomable?: Maybe<boolean>, SortOrder?: Maybe<number>, IsNotFoundImage?: Maybe<boolean>, MediaType?: Maybe<string>, Video1024x768Html?: Maybe<string>, Video640x480Html?: Maybe<string>, Preview360PDP?: Maybe<string>, Preview360Compare?: Maybe<string>, Preview360Zoom?: Maybe<string>, Video360CompareHtml?: Maybe<string>, Video360PDPHtml?: Maybe<string>, Video360ZoomHtml?: Maybe<string>, VideoDynamicHtml?: Maybe<string>, ImageId: number, Angle?: Maybe<string> }>, attrs_string_img_ViewE?: Maybe<{ __typename?: 'ImageUrlsDto', RawUrl?: Maybe<string>, FullSizeUrl?: Maybe<string>, Thumb75Url?: Maybe<string>, Thumb125Url?: Maybe<string>, Thumb150Url?: Maybe<string>, Thumb165Url: string, Thumb100Url?: Maybe<string>, Thumb40Url?: Maybe<string>, Size640Url?: Maybe<string>, Size430Url?: Maybe<string>, Size350Url?: Maybe<string>, Size250Url: string, Size190Url?: Maybe<string>, ZoomUrl?: Maybe<string>, Height?: Maybe<number>, Width?: Maybe<number>, Format?: Maybe<string>, IsZoomable?: Maybe<boolean>, IsSuperZoomable?: Maybe<boolean>, SortOrder?: Maybe<number>, IsNotFoundImage?: Maybe<boolean>, MediaType?: Maybe<string>, Video1024x768Html?: Maybe<string>, Video640x480Html?: Maybe<string>, Preview360PDP?: Maybe<string>, Preview360Compare?: Maybe<string>, Preview360Zoom?: Maybe<string>, Video360CompareHtml?: Maybe<string>, Video360PDPHtml?: Maybe<string>, Video360ZoomHtml?: Maybe<string>, VideoDynamicHtml?: Maybe<string>, ImageId: number, Angle?: Maybe<string> }>, image: { __typename?: 'ImageUrlsDto', RawUrl?: Maybe<string>, FullSizeUrl?: Maybe<string>, Thumb75Url?: Maybe<string>, Thumb125Url?: Maybe<string>, Thumb150Url?: Maybe<string>, Thumb165Url: string, Thumb100Url?: Maybe<string>, Thumb40Url?: Maybe<string>, Size640Url?: Maybe<string>, Size430Url?: Maybe<string>, Size350Url?: Maybe<string>, Size250Url: string, Size190Url?: Maybe<string>, ZoomUrl?: Maybe<string>, Height?: Maybe<number>, Width?: Maybe<number>, Format?: Maybe<string>, IsZoomable?: Maybe<boolean>, IsSuperZoomable?: Maybe<boolean>, SortOrder?: Maybe<number>, IsNotFoundImage?: Maybe<boolean>, MediaType?: Maybe<string>, Video1024x768Html?: Maybe<string>, Video640x480Html?: Maybe<string>, Preview360PDP?: Maybe<string>, Preview360Compare?: Maybe<string>, Preview360Zoom?: Maybe<string>, Video360CompareHtml?: Maybe<string>, Video360PDPHtml?: Maybe<string>, Video360ZoomHtml?: Maybe<string>, VideoDynamicHtml?: Maybe<string>, ImageId: number, Angle?: Maybe<string> }, price?: Maybe<{ __typename?: 'JsonPrice', DiscountPercent?: Maybe<number>, EligibleAdditionalStullerFirstDiscountPercent?: Maybe<number>, DiscountType: string, CurrentPrice: { __typename?: 'JsonPriceUnit', HtmlFormattedPrice: string, ValueInUSD: number, ValueAtCurrency: number }, OriginalPrice: { __typename?: 'JsonPriceUnit', HtmlFormattedPrice: string, ValueInUSD: number, ValueAtCurrency: number }, ValueSaved: { __typename?: 'JsonPriceUnit', HtmlFormattedPrice: string, ValueInUSD: number, ValueAtCurrency: number } }>, price_percarat?: Maybe<{ __typename?: 'JsonPrice', DiscountPercent?: Maybe<number>, EligibleAdditionalStullerFirstDiscountPercent?: Maybe<number>, DiscountType: string, CurrentPrice: { __typename?: 'JsonPriceUnit', HtmlFormattedPrice: string, ValueInUSD: number, ValueAtCurrency: number }, OriginalPrice: { __typename?: 'JsonPriceUnit', HtmlFormattedPrice: string, ValueInUSD: number, ValueAtCurrency: number }, ValueSaved: { __typename?: 'JsonPriceUnit', HtmlFormattedPrice: string, ValueInUSD: number, ValueAtCurrency: number } }> }, AddToCartViewModel: { __typename?: 'AddToCartViewModel', Product?: Maybe<{ __typename?: 'AddToCartProduct', JsonPrice?: Maybe<{ __typename?: 'JsonPrice', DiscountPercent?: Maybe<number>, EligibleAdditionalStullerFirstDiscountPercent?: Maybe<number>, DiscountType: string, CurrentPrice: { __typename?: 'JsonPriceUnit', HtmlFormattedPrice: string, ValueInUSD: number, ValueAtCurrency: number }, OriginalPrice: { __typename?: 'JsonPriceUnit', HtmlFormattedPrice: string, ValueInUSD: number, ValueAtCurrency: number }, ValueSaved: { __typename?: 'JsonPriceUnit', HtmlFormattedPrice: string, ValueInUSD: number, ValueAtCurrency: number } }> }> } }>>> }> };

export type GetDataExportFeedsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDataExportFeedsQuery = { __typename?: 'Query', getDataExportFeeds?: Maybe<{ __typename?: 'ProductDataFeedResults', SavedExports: Array<{ __typename?: 'ProductDataFeed', Id?: Maybe<number>, Name?: Maybe<string>, Description?: Maybe<string>, Properties?: Maybe<string>, ProductRequest?: Maybe<string>, LoginId?: Maybe<string>, CreationDate?: Maybe<any>, Process?: Maybe<boolean>, ProcessComplete?: Maybe<boolean>, ProcessCount?: Maybe<number>, FileName?: Maybe<string> }> }> };

export type SaveSkuMutationVariables = Exact<{
  input?: Maybe<SaveSkuParams>;
}>;


export type SaveSkuMutation = { __typename?: 'Mutation', saveSku?: Maybe<{ __typename?: 'SaveDataFeedResponse', success?: Maybe<boolean>, message?: Maybe<string> }> };

export type SaveSeriesMutationVariables = Exact<{
  input?: Maybe<SaveSeriesParams>;
}>;


export type SaveSeriesMutation = { __typename?: 'Mutation', saveSeries?: Maybe<{ __typename?: 'SaveDataFeedResponse', success?: Maybe<boolean>, message?: Maybe<string> }> };

export type CreateProductDataFeedMutationVariables = Exact<{
  input?: Maybe<CreateDataFeedParams>;
}>;


export type CreateProductDataFeedMutation = { __typename?: 'Mutation', createProductDataFeed?: Maybe<{ __typename?: 'SaveDataFeedResponse', success?: Maybe<boolean>, message?: Maybe<string> }> };

export type GetContactsFromShipToAccountQueryVariables = Exact<{
  params: GetContactsFromShipToAccountParams;
}>;


export type GetContactsFromShipToAccountQuery = { __typename?: 'Query', getContactsFromShipToAccount: Array<{ __typename?: 'ContactViewModel', AllowDuplicate: boolean, DuplicateEmail: string, IsEmailAddressRequired: boolean, ColumnCount: string, IsMinimal: boolean, OptIn302SMSNotifications: boolean, OptInEverAndEverSMSNotifications: boolean, UseTextInputForEmailAddresses: boolean, IsCheckoutDefault: boolean, IsAssignedToUser: boolean, BadEmailAddress: string, IsSingleContactForCurrentUser: boolean, CadCamAcceptAllModFees: boolean, CadCamHasLogoOnFile: boolean, Unsubscribed: boolean, IsBadEmail: boolean, RenderMinimalWithMobilePhoneUpdate: boolean, ShowPreferredMethodOfContact: boolean, Id?: Maybe<number>, Salutation: string, FirstName: string, LastName: string, PreferredName: string, FullName: string, ModificationDate: any, CreationDate: any, ContactIsDeletable: boolean, Suffix: string, Active: boolean, JobTitle: string, EmailAddress: string, DirectPhoneNumber: string, MobilePhoneNumber: string, BusinessPhoneNumber: string, PreferredMethodOfContact: string, OraclePartyId?: Maybe<number> }> };

export type GetProductQueryVariables = Exact<{
  params: GetProductParams;
}>;


export type GetProductQuery = { __typename?: 'Query', getProduct?: Maybe<{ __typename?: 'GetProductResponse', isModifiable: boolean, isRing: boolean, cannotModifyStyleReason?: Maybe<string>, customerSpecificSku?: Maybe<string>, product?: Maybe<{ __typename?: 'Product', ItemNumber: string, Title: string, DefaultCDNImagePath: string, ProductUrl: string }> }> };

export type GetValidatedCadCamRequestSummaryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetValidatedCadCamRequestSummaryQuery = { __typename?: 'Query', getValidatedCadCamRequestSummary: { __typename?: 'ValidatedCadCamRequestViewModel', Success: boolean, ImageUrl?: Maybe<string>, CustomerReference?: Maybe<string>, MetalQuality?: Maybe<string> } };

export type ValidateReturnShippingAddressMutationVariables = Exact<{
  params: ValidateReturnShippingAddressParams;
}>;


export type ValidateReturnShippingAddressMutation = { __typename?: 'Mutation', validateReturnShippingAddress: { __typename?: 'ValidateReturnShippingAddressResponse', success?: Maybe<boolean>, shipFromErrorFound?: Maybe<boolean>, suggestedAddress?: Maybe<{ __typename?: 'SuggestedAddress', Street1: string, Street2?: Maybe<string>, Street3?: Maybe<string>, City: string, State: string, Zip: string, CountyName?: Maybe<string>, PlusFour?: Maybe<string> }> } };

export type StullerPayAddToCartMutationVariables = Exact<{
  input: StullerPayAddToCartParams;
}>;


export type StullerPayAddToCartMutation = { __typename?: 'Mutation', stullerPayAddToCart?: Maybe<{ __typename?: 'StullerPayResponse', SessionId?: Maybe<string>, Errors?: Maybe<Array<string>> }> };

export type GetCmsContentByIdQueryVariables = Exact<{
  contentContainerId: Scalars['Int'];
  params?: Maybe<Scalars['JSON']>;
}>;


export type GetCmsContentByIdQuery = { __typename?: 'Query', cmsContent?: Maybe<string> };

export type GetCmsContentByNameQueryVariables = Exact<{
  contentContainerName: Scalars['String'];
  params?: Maybe<Scalars['JSON']>;
}>;


export type GetCmsContentByNameQuery = { __typename?: 'Query', cmsContent?: Maybe<string> };

export type GetCmsNavContentContainerIdQueryVariables = Exact<{
  input: CmsNavContentContainerIdInput;
}>;


export type GetCmsNavContentContainerIdQuery = { __typename?: 'Query', cmsNavContentContainerId?: Maybe<number> };

export type GetConfigItemSummaryQueryVariables = Exact<{
  params: GetConfigItemSummaryParams;
}>;


export type GetConfigItemSummaryQuery = { __typename?: 'Query', getConfigItemSummary?: Maybe<{ __typename?: 'ConfigResponse', configDetails?: Maybe<Array<Array<{ __typename?: 'ConfigDetails', Title?: Maybe<string>, Description?: Maybe<string>, TemplateName: string, TemplateData: Array<Maybe<any>> }>>> }> };

export type GetHasMissingLogoOnConfigQueryVariables = Exact<{
  params: GetConfigItemSummaryParams;
}>;


export type GetHasMissingLogoOnConfigQuery = { __typename?: 'Query', getHasMissingLogoOnConfig?: Maybe<{ __typename?: 'LogoResponse', hasMissingLogo?: Maybe<boolean> }> };

export type GetContextMinimalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContextMinimalQuery = { __typename?: 'Query', darkMode: boolean, context: { __typename?: 'Context', AccountCountry?: Maybe<string>, AccountCurrencyCode?: Maybe<string>, ActionName?: Maybe<string>, AllowIframeHostApi: boolean, AllowIframeHostApiDomainsCsvList?: Maybe<string>, AllowUniqueRequests: boolean, CanCheckout: boolean, CanManageRevenueCycle: boolean, CanPromoteShowcase: boolean, CanPromoteStullerFirst: boolean, IsEligibleForStullerFirst: boolean, CartCount: number, ControllerName?: Maybe<string>, CurrentCultureName: string, DefaultShipToAccountNumber?: Maybe<string>, HasJewelerShowcase: boolean, HasScheduledOrder: boolean, HideAddToCart: boolean, HideBreadcrumbs: boolean, HideCartLinkInHeader: boolean, HidePrices: boolean, HideShipDatesAndItemStatuses: boolean, IsArtisanAccount: boolean, IsDev: boolean, IsEcommMerchandisingMode: boolean, IsEmployee: boolean, IsFoundryAndShowcase: boolean, IsGroupCodeViewer: boolean, IsInCmsMode: boolean, IsInConsultantMode: boolean, IsInJewelerShowcase: boolean, IsInMetalsClub: boolean, IsInShowcase: boolean, IsInStullerFirst: boolean, IsInStullerFirstTrial: boolean, IsJaredStudioLogin: boolean, IsOrderApprovalByPassCheckout: boolean, IsOrderApprover: boolean, IsRJOAccount: boolean, IsRJOMasterAccount: boolean, IsSalesPerformanceViewer: boolean, IsSterling: boolean, IsToolsOnly: boolean, LoginId?: Maybe<string>, MadeByStullerViewer: boolean, PunchOutTheme: string, RecaptchaSiteKey: string, RequiresPanPad: boolean, ScheduledOrderCutoffTime?: Maybe<any>, SearchEngine?: Maybe<string>, SessionId: string, ShouldShowShipDateImmediately: boolean, ShowcaseCanShowSendAQuote: boolean, ShowcaseEmailAddress?: Maybe<string>, ShowcasePhoneNumber?: Maybe<string>, ShowcaseTitle?: Maybe<string>, ShowDGLauncher: boolean, ShowEstimatedShipDatesOverride: boolean, ShowPricePerCt: boolean, ShowShowcaseSalePrice: boolean, StullerFirstPromotionalShippingCost?: Maybe<string>, StullerFirstPromotionalShippingMethod?: Maybe<string>, TurnToKey: string, UseClientACHTokenization?: Maybe<boolean>, UserFirstName?: Maybe<string>, UserIsAssignedContact: boolean, UserMemberId?: Maybe<string>, UserNeedsToAgreeToTermsForReview: boolean, Currency: { __typename?: 'ContextCurrency', Currency: string, Symbol: string, SymbolIsPrefix: boolean, DecimalSeparator: string, DecimalDigits: number, GroupSeparator: string }, DefaultShipToAddress?: Maybe<{ __typename?: 'DefaultShipToAddress', AddressLine1?: Maybe<string>, AddressLine2?: Maybe<string>, City?: Maybe<string>, State?: Maybe<string>, Zip?: Maybe<string>, Province?: Maybe<string>, Country?: Maybe<string>, IsResidential?: Maybe<boolean> }> } };

export type GetDiscountedProductsQueryVariables = Exact<{
  groupuid: Scalars['Int'];
  searchsource?: Maybe<Scalars['String']>;
}>;


export type GetDiscountedProductsQuery = { __typename?: 'Query', getDiscountedProducts: { __typename?: 'DiscountedProductResultsResponse', results: Array<{ __typename?: 'DiscountedProductResult', Id: number, Description?: Maybe<string>, DisplayPrice?: Maybe<string>, OriginalPrice?: Maybe<string>, MinDiscount?: Maybe<number>, MaxDiscount?: Maybe<number>, IsDiscounted?: Maybe<boolean>, IsExcessBadge?: Maybe<boolean>, IsAlmostGoneBadge?: Maybe<boolean>, IsOutOfStockBadge?: Maybe<boolean>, ImageUrls?: Maybe<{ __typename?: 'ImageUrlsDto', RawUrl?: Maybe<string>, FullSizeUrl?: Maybe<string>, Thumb75Url?: Maybe<string>, Thumb125Url?: Maybe<string>, Thumb150Url?: Maybe<string>, Thumb165Url: string, Thumb100Url?: Maybe<string>, Thumb40Url?: Maybe<string>, Size640Url?: Maybe<string>, Size430Url?: Maybe<string>, Size350Url?: Maybe<string>, Size250Url: string, Size190Url?: Maybe<string>, ZoomUrl?: Maybe<string>, Height?: Maybe<number>, Width?: Maybe<number>, Format?: Maybe<string>, IsZoomable?: Maybe<boolean>, IsSuperZoomable?: Maybe<boolean>, SortOrder?: Maybe<number>, IsNotFoundImage?: Maybe<boolean>, MediaType?: Maybe<string>, Video1024x768Html?: Maybe<string>, Video640x480Html?: Maybe<string>, Preview360PDP?: Maybe<string>, Preview360Compare?: Maybe<string>, Preview360Zoom?: Maybe<string>, Video360CompareHtml?: Maybe<string>, Video360PDPHtml?: Maybe<string>, Video360ZoomHtml?: Maybe<string>, VideoDynamicHtml?: Maybe<string>, ImageId: number, Angle?: Maybe<string> }> }> } };

export type GetFavoritesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFavoritesListQuery = { __typename?: 'Query', addToFavoritesOptions?: Maybe<{ __typename?: 'FavoritesOptions', DefaultList?: Maybe<number>, Lists: Array<{ __typename?: 'FavoritesList', name: string, value: number }> }> };

export type AddToFavoritesMutationVariables = Exact<{
  params: AddToFavoritesParams;
}>;


export type AddToFavoritesMutation = { __typename?: 'Mutation', addToFavorites?: Maybe<{ __typename?: 'AddToFavorites', success: boolean, favoriteListName: string, favoriteListId: number, nameAlreadyExists?: Maybe<boolean> }> };

export type ImageAssetResponseFragment = { __typename?: 'ImageAsset', id: string, type: string, source: string };

export type NavigationItemResponseFragment = { __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> };

export type ImageUrlsResponseFragment = { __typename?: 'ImageUrlsDto', RawUrl?: Maybe<string>, FullSizeUrl?: Maybe<string>, Thumb75Url?: Maybe<string>, Thumb125Url?: Maybe<string>, Thumb150Url?: Maybe<string>, Thumb165Url: string, Thumb100Url?: Maybe<string>, Thumb40Url?: Maybe<string>, Size640Url?: Maybe<string>, Size430Url?: Maybe<string>, Size350Url?: Maybe<string>, Size250Url: string, Size190Url?: Maybe<string>, ZoomUrl?: Maybe<string>, Height?: Maybe<number>, Width?: Maybe<number>, Format?: Maybe<string>, IsZoomable?: Maybe<boolean>, IsSuperZoomable?: Maybe<boolean>, SortOrder?: Maybe<number>, IsNotFoundImage?: Maybe<boolean>, MediaType?: Maybe<string>, Video1024x768Html?: Maybe<string>, Video640x480Html?: Maybe<string>, Preview360PDP?: Maybe<string>, Preview360Compare?: Maybe<string>, Preview360Zoom?: Maybe<string>, Video360CompareHtml?: Maybe<string>, Video360PDPHtml?: Maybe<string>, Video360ZoomHtml?: Maybe<string>, VideoDynamicHtml?: Maybe<string>, ImageId: number, Angle?: Maybe<string> };

export type ChildCategoryResponseFragment = { __typename?: 'CategoryViewModel', Id: number, PageTitle: string, ShowcasePageTitle: string, Name: string, PageMetaDescription: string, PageHeader: string, ContentId?: Maybe<number>, IsAShopCategory: boolean, HideCategory: boolean, ShowInShowcase: boolean, BottomContentId?: Maybe<number>, ShowcaseDisplayName: string, StandardDisplayName: string, ShowImages: boolean, SanitizedName: string, OverrideUrl: string, CDNImageName: string, ShowGrandChildren: boolean, SortOrder: number, SanitizedPath: string };

export type NavigationSectionResponseFragment = { __typename?: 'NavigationSection', Title: string, SearchField: string, TopLabel: string, LoggedInOnly: boolean, UseDecorationForLink: boolean, DecorationText?: Maybe<string>, CssClass?: Maybe<string>, HideForSterling: boolean, SortOrder?: Maybe<number>, IsMultiSelect: boolean, IsSingleSelect: boolean, IsPivot: boolean, UseIcon: boolean, NavPosition: string, Layout: string, SelectedNavigationItem?: Maybe<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, Children?: Maybe<Array<Maybe<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>>>, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>, DefaultImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> };

export type CategoryOrSearchQueryResponseFragment = { __typename?: 'CategoryOrSearchViewModel', PresentationContext: SearchPresentationContext, RedirectUrl?: Maybe<string>, BottomNavigationSectionContentId?: Maybe<number>, UnderCategorySectionContentId?: Maybe<number>, ShowCenterStoneColors: boolean, ClearAllUrl?: Maybe<string>, HideSideNav: boolean, PageHeader: string, PageTitle: string, ArticlesCount: number, ShowDiscounts: boolean, SearchSource?: Maybe<string>, ShowSeriesAboveImage: boolean, Query?: Maybe<string>, QueryId?: Maybe<string>, Category?: Maybe<string>, CategoryId?: Maybe<number>, CategoryPermalinkUrl?: Maybe<string>, TopAcrossPageContentId?: Maybe<number>, ContentId?: Maybe<number>, AllowNewContentBlockCreation: boolean, NewContentBlockName: string, ContentBlockLocation: number, CmsContentType: number, IsContentOnlyDisplayTemplate: boolean, OriginalQuery?: Maybe<string>, CorrectedQuery?: Maybe<string>, TopRowInResultsContentID?: Maybe<number>, ImpressionListName?: Maybe<string>, ShowPageSize: boolean, MerchandisingMode: boolean, BreadCrumbs?: Maybe<Array<{ __typename?: 'Breadcrumb', EncodedText: string, Url?: Maybe<string> }>>, CenterStoneColors?: Maybe<Array<{ __typename?: 'CenterStoneColor', HexCode: string, Name: string, IsSelected: boolean }>>, ChildCategories?: Maybe<Array<{ __typename?: 'CategoryViewModel', Id: number, PageTitle: string, ShowcasePageTitle: string, Name: string, PageMetaDescription: string, PageHeader: string, ContentId?: Maybe<number>, IsAShopCategory: boolean, HideCategory: boolean, ShowInShowcase: boolean, BottomContentId?: Maybe<number>, ShowcaseDisplayName: string, StandardDisplayName: string, ShowImages: boolean, SanitizedName: string, OverrideUrl: string, CDNImageName: string, ShowGrandChildren: boolean, SortOrder: number, SanitizedPath: string, ChildCategories?: Maybe<Array<Maybe<{ __typename?: 'CategoryViewModel', Id: number, PageTitle: string, ShowcasePageTitle: string, Name: string, PageMetaDescription: string, PageHeader: string, ContentId?: Maybe<number>, IsAShopCategory: boolean, HideCategory: boolean, ShowInShowcase: boolean, BottomContentId?: Maybe<number>, ShowcaseDisplayName: string, StandardDisplayName: string, ShowImages: boolean, SanitizedName: string, OverrideUrl: string, CDNImageName: string, ShowGrandChildren: boolean, SortOrder: number, SanitizedPath: string }>>> }>>, FacetValues?: Maybe<Array<{ __typename?: 'FacetValue', First: string, Second: string }>>, NavigationSections?: Maybe<Array<{ __typename?: 'NavigationSection', Title: string, SearchField: string, TopLabel: string, LoggedInOnly: boolean, UseDecorationForLink: boolean, DecorationText?: Maybe<string>, CssClass?: Maybe<string>, HideForSterling: boolean, SortOrder?: Maybe<number>, IsMultiSelect: boolean, IsSingleSelect: boolean, IsPivot: boolean, UseIcon: boolean, NavPosition: string, Layout: string, NavigationItems: Array<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, Children?: Maybe<Array<Maybe<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>>>, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>, SelectedNavigationItem?: Maybe<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, Children?: Maybe<Array<Maybe<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>>>, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>, DefaultImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>>, TopNavigationSections?: Maybe<Array<{ __typename?: 'NavigationSection', Title: string, SearchField: string, TopLabel: string, LoggedInOnly: boolean, UseDecorationForLink: boolean, DecorationText?: Maybe<string>, CssClass?: Maybe<string>, HideForSterling: boolean, SortOrder?: Maybe<number>, IsMultiSelect: boolean, IsSingleSelect: boolean, IsPivot: boolean, UseIcon: boolean, NavPosition: string, Layout: string, NavigationItems: Array<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, Children?: Maybe<Array<Maybe<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, Children?: Maybe<Array<Maybe<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>>>, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>>>, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>, SelectedNavigationItem?: Maybe<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, Children?: Maybe<Array<Maybe<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>>>, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>, DefaultImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>>, SelectedFacets?: Maybe<Array<{ __typename?: 'SelectedFacet', Name: string, Value: string, SearchField: string, Url: string, FromSection?: Maybe<string> }>>, SearchResults?: Maybe<Array<{ __typename?: 'SearchResult', Id: number, Code: string, ParentCode?: Maybe<string>, Rank?: Maybe<string>, Description?: Maybe<string>, TemplatePage?: Maybe<string>, DisplayPrice?: Maybe<string>, GroupDetailsUrl?: Maybe<string>, OverrideItemId?: Maybe<number>, IsValidFor3CBadge: boolean, IsValidForNewItemBadge: boolean, IsValidForBestSellerBadge: boolean, IsValidForNewDealBadge: boolean, IsValidForDieStruckBadge: boolean, IsValidForMetalMoldBadge: boolean, IsValidForCoinedBadge: boolean, IsValidForMachinedBadge: boolean, IsValidForDigitalImprintingBadge: boolean, IsValidForHotStampingBadge: boolean, IsValidForLimitedTimeOnlyBadge: boolean, IsSCSCertified: boolean, IsMadeWithCycledMaterials: boolean, IsPrincipledSourcing: boolean, IsValidForEverAndEverBadge: boolean, IsValidForLabGrownBadge: boolean, IsValidForNotableGemsBadge: boolean, ClickLoggingPayload?: Maybe<string>, SearchId?: Maybe<string>, MinDiscount?: Maybe<number>, MaxDiscount?: Maybe<number>, DiscountIsFlashSaleAndStullerFirst: boolean, WholeGroupIsDiscounted?: Maybe<boolean>, IsDiscounted: boolean, ProductState?: Maybe<string>, SerialNumber?: Maybe<number>, GeographicalOrigin?: Maybe<string>, CountryOfOrigin?: Maybe<string>, KnownOrigin?: Maybe<boolean>, FeaturedSearchAttribute?: Maybe<string>, FeaturedSearchAttributeValue?: Maybe<string>, ProductTracking: any, ImageUrls?: Maybe<{ __typename?: 'ImageUrlsDto', RawUrl?: Maybe<string>, FullSizeUrl?: Maybe<string>, Thumb75Url?: Maybe<string>, Thumb125Url?: Maybe<string>, Thumb150Url?: Maybe<string>, Thumb165Url: string, Thumb100Url?: Maybe<string>, Thumb40Url?: Maybe<string>, Size640Url?: Maybe<string>, Size430Url?: Maybe<string>, Size350Url?: Maybe<string>, Size250Url: string, Size190Url?: Maybe<string>, ZoomUrl?: Maybe<string>, Height?: Maybe<number>, Width?: Maybe<number>, Format?: Maybe<string>, IsZoomable?: Maybe<boolean>, IsSuperZoomable?: Maybe<boolean>, SortOrder?: Maybe<number>, IsNotFoundImage?: Maybe<boolean>, MediaType?: Maybe<string>, Video1024x768Html?: Maybe<string>, Video640x480Html?: Maybe<string>, Preview360PDP?: Maybe<string>, Preview360Compare?: Maybe<string>, Preview360Zoom?: Maybe<string>, Video360CompareHtml?: Maybe<string>, Video360PDPHtml?: Maybe<string>, Video360ZoomHtml?: Maybe<string>, VideoDynamicHtml?: Maybe<string>, ImageId: number, Angle?: Maybe<string> }>, ImageUrlsSide?: Maybe<{ __typename?: 'ImageUrlsDto', RawUrl?: Maybe<string>, FullSizeUrl?: Maybe<string>, Thumb75Url?: Maybe<string>, Thumb125Url?: Maybe<string>, Thumb150Url?: Maybe<string>, Thumb165Url: string, Thumb100Url?: Maybe<string>, Thumb40Url?: Maybe<string>, Size640Url?: Maybe<string>, Size430Url?: Maybe<string>, Size350Url?: Maybe<string>, Size250Url: string, Size190Url?: Maybe<string>, ZoomUrl?: Maybe<string>, Height?: Maybe<number>, Width?: Maybe<number>, Format?: Maybe<string>, IsZoomable?: Maybe<boolean>, IsSuperZoomable?: Maybe<boolean>, SortOrder?: Maybe<number>, IsNotFoundImage?: Maybe<boolean>, MediaType?: Maybe<string>, Video1024x768Html?: Maybe<string>, Video640x480Html?: Maybe<string>, Preview360PDP?: Maybe<string>, Preview360Compare?: Maybe<string>, Preview360Zoom?: Maybe<string>, Video360CompareHtml?: Maybe<string>, Video360PDPHtml?: Maybe<string>, Video360ZoomHtml?: Maybe<string>, VideoDynamicHtml?: Maybe<string>, ImageId: number, Angle?: Maybe<string> }>, FeaturedSearchAttributeValues?: Maybe<Array<{ __typename?: 'ProductSearchAttribute', AttributeValue: string, ItemId: number, ItemDetailsUrl: string, AttributeImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }>, ImageUrls?: Maybe<{ __typename?: 'ImageUrlsDto', RawUrl?: Maybe<string>, FullSizeUrl?: Maybe<string>, Thumb75Url?: Maybe<string>, Thumb125Url?: Maybe<string>, Thumb150Url?: Maybe<string>, Thumb165Url: string, Thumb100Url?: Maybe<string>, Thumb40Url?: Maybe<string>, Size640Url?: Maybe<string>, Size430Url?: Maybe<string>, Size350Url?: Maybe<string>, Size250Url: string, Size190Url?: Maybe<string>, ZoomUrl?: Maybe<string>, Height?: Maybe<number>, Width?: Maybe<number>, Format?: Maybe<string>, IsZoomable?: Maybe<boolean>, IsSuperZoomable?: Maybe<boolean>, SortOrder?: Maybe<number>, IsNotFoundImage?: Maybe<boolean>, MediaType?: Maybe<string>, Video1024x768Html?: Maybe<string>, Video640x480Html?: Maybe<string>, Preview360PDP?: Maybe<string>, Preview360Compare?: Maybe<string>, Preview360Zoom?: Maybe<string>, Video360CompareHtml?: Maybe<string>, Video360PDPHtml?: Maybe<string>, Video360ZoomHtml?: Maybe<string>, VideoDynamicHtml?: Maybe<string>, ImageId: number, Angle?: Maybe<string> }> }>> }>>, RelatedSearchTerms?: Maybe<Array<Maybe<{ __typename?: 'SearchSuggestion', Rank?: Maybe<string>, Suggestion?: Maybe<string>, ClickLoggingPayload?: Maybe<string> }>>>, Pager?: Maybe<{ __typename?: 'Pager', TotalPages: number, CurrentPage: number, TotalRecords: number, FirstDisplayPage: number, LastDisplayPage: number, HidePagerWhenOnlyOnePageIsAvailable: boolean, ChangePageIsJavascript?: Maybe<boolean>, ShowingText: string, RecordsPerPage: number }>, Filters?: Maybe<Array<Maybe<{ __typename?: 'SearchFilters', Label?: Maybe<string>, Name?: Maybe<string>, Filter?: Maybe<Array<Maybe<string>>>, AdditionalFirstString?: Maybe<string> }>>>, SortByFilter: Array<{ __typename?: 'SelectListItem', Disabled: boolean, Group?: Maybe<string>, Selected: boolean, Text?: Maybe<string>, Value?: Maybe<string> }>, PageSizeFilter: Array<{ __typename?: 'SelectListItem', Disabled: boolean, Group?: Maybe<string>, Selected: boolean, Text?: Maybe<string>, Value?: Maybe<string> }>, StoneForViewAvailableMountings?: Maybe<{ __typename?: 'StoneForViewAvailableMountingsViewModel', ID: number, SerialNumber: number, Cut: string, Color: string, Shape: string, SizeCt?: Maybe<string>, SizeMm: string, Category?: Maybe<string>, Type: string, Variety: string, StoneQuality: string, Uniqueness: string, IsDiamond: boolean, HexColor: string, Price: string, PriceWithoutDiscount: string, DetailsUrl: string, Image: { __typename?: 'ImageUrlsDto', RawUrl?: Maybe<string>, FullSizeUrl?: Maybe<string>, Thumb75Url?: Maybe<string>, Thumb125Url?: Maybe<string>, Thumb150Url?: Maybe<string>, Thumb165Url: string, Thumb100Url?: Maybe<string>, Thumb40Url?: Maybe<string>, Size640Url?: Maybe<string>, Size430Url?: Maybe<string>, Size350Url?: Maybe<string>, Size250Url: string, Size190Url?: Maybe<string>, ZoomUrl?: Maybe<string>, Height?: Maybe<number>, Width?: Maybe<number>, Format?: Maybe<string>, IsZoomable?: Maybe<boolean>, IsSuperZoomable?: Maybe<boolean>, SortOrder?: Maybe<number>, IsNotFoundImage?: Maybe<boolean>, MediaType?: Maybe<string>, Video1024x768Html?: Maybe<string>, Video640x480Html?: Maybe<string>, Preview360PDP?: Maybe<string>, Preview360Compare?: Maybe<string>, Preview360Zoom?: Maybe<string>, Video360CompareHtml?: Maybe<string>, Video360PDPHtml?: Maybe<string>, Video360ZoomHtml?: Maybe<string>, VideoDynamicHtml?: Maybe<string>, ImageId: number, Angle?: Maybe<string> } }>, SearchByStoneSize?: Maybe<{ __typename?: 'SearchByStoneSizeViewModel', Shape: string, Dimension: string, ProductType: string, SelectedProductTypes: Array<Maybe<string>>, SelectedMetalColors: Array<Maybe<string>>, Style: string, ProngCount: string, StoneShapes: Array<{ __typename?: 'StoneShapeViewModel', CssClassName: string, DisplayName: string, PostValue: string, VectorId: string, ShapeType: ShapeType }>, StringDimensions: Array<{ __typename?: 'TupleString2', Item1: string, Item2: string }>, ProductTypes: Array<{ __typename?: 'TupleString2', Item1: string, Item2: string }>, MetalColors: Array<{ __typename?: 'TupleString2', Item1: string, Item2: string }>, Styles: Array<{ __typename?: 'TupleString2', Item1: string, Item2: string }>, ProngCounts: Array<{ __typename?: 'TupleString2', Item1: string, Item2: string }> }> };

export type GetRequestAQuoteViewModelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRequestAQuoteViewModelQuery = { __typename?: 'Query', getRequestAQuoteViewModel?: Maybe<{ __typename?: 'RequestAQuoteViewModel', CompanyName?: Maybe<string>, FirstName?: Maybe<string>, LastName?: Maybe<string>, Email?: Maybe<string>, ConfirmationEmail?: Maybe<string>, PhoneNumber?: Maybe<string>, MessageToJeweler?: Maybe<string> }> };

export type SubmitRequestAQuoteMutationVariables = Exact<{
  input: Scalars['JSON'];
}>;


export type SubmitRequestAQuoteMutation = { __typename?: 'Mutation', submitRequestAQuote?: Maybe<{ __typename?: 'RequestAQuoteResponse', success?: Maybe<boolean>, messages?: Maybe<Array<string>> }> };

export type GetShippingCountdownQueryVariables = Exact<{
  input?: Maybe<GetShippingCountdownInput>;
}>;


export type GetShippingCountdownQuery = { __typename?: 'Query', getShippingCountdown?: Maybe<{ __typename?: 'ShippingCountdownResults', showCountdown?: Maybe<boolean>, countdownType?: Maybe<CountdownType>, cutoff?: Maybe<any> }> };

export type GetLookupsByTypeQueryVariables = Exact<{
  type: Scalars['String'];
}>;


export type GetLookupsByTypeQuery = { __typename?: 'Query', getLookupsByType: Array<{ __typename?: 'Lookup', ID: number, Type: string, Code: string, Order?: Maybe<number>, Value: string, Value2?: Maybe<string>, Value3?: Maybe<string>, Value4?: Maybe<string>, Value5?: Maybe<string>, Value6?: Maybe<string>, Value7?: Maybe<string>, Value8?: Maybe<string>, Value9?: Maybe<string>, Value10?: Maybe<string> }> };

export type GetNewAuthTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewAuthTokenQuery = { __typename?: 'Query', getNewAuthToken: string };

export type IsOracleUpQueryVariables = Exact<{ [key: string]: never; }>;


export type IsOracleUpQuery = { __typename?: 'Query', isOracleUp: boolean };

export type GetOrdersQueryVariables = Exact<{
  params: GetOrdersParams;
}>;


export type GetOrdersQuery = { __typename?: 'Query', getOrders?: Maybe<{ __typename?: 'Orders', totalRecords?: Maybe<number>, errors?: Maybe<Array<Maybe<string>>>, orders?: Maybe<Array<{ __typename?: 'OrderListingViewModel', BillToAccountNumber: string, ShipToAccountNumber: string, OracleOrderNumber?: Maybe<string>, WebOrderNumber?: Maybe<string>, OrderPONumber?: Maybe<string>, OrderDate?: Maybe<any>, OrderDateString?: Maybe<string>, OrderStatus?: Maybe<string>, OrderTotal?: Maybe<number>, OrderTotalString?: Maybe<string>, HasReturnableOrderLines: boolean, IsExpanded?: Maybe<boolean>, IsApprovalOrder: boolean, LoginId?: Maybe<string>, OrderLines: Array<{ __typename?: 'OrderListingLineViewModel', ShipToAccountNumber?: Maybe<string>, ShipToAccountState?: Maybe<string>, ShipToAccountCountry?: Maybe<string>, OracleOrderNumber?: Maybe<string>, WebOrderNumber?: Maybe<string>, OracleOrderHeaderId?: Maybe<number>, OracleOrderLineId: number, ItemNumber: string, SerialNumber?: Maybe<number>, Image: string, Description?: Maybe<string>, Url: string, QuantityShipped: number, UnitPrice: string, ExtendedPrice?: Maybe<string>, IsConfigItem: boolean, ConfigHeaderId?: Maybe<number>, ItemTypeCode?: Maybe<string>, IsReturnable: boolean, IsMetal: boolean, MetalsDetailString?: Maybe<string>, UOM?: Maybe<string>, SoldByDescription?: Maybe<string>, IsBulkChain: boolean, IsMemo: boolean, IsHeavy: boolean, IsHazardous: boolean, IsGroundShippingOnly: boolean, UnitWeightInPounds: number, IsFiltered: boolean, pendingReturn?: Maybe<boolean>, ReturnQuantity?: Maybe<number>, ReturnReason?: Maybe<string>, ReturnNote?: Maybe<string> }> }>> }> };

export type GetApprovalOrderQueryVariables = Exact<{
  params: GetApprovalOrderParams;
}>;


export type GetApprovalOrderQuery = { __typename?: 'Query', getApprovalOrder?: Maybe<string> };

export type GetOrderDetailsQueryVariables = Exact<{
  params: GetOrderDetailsParams;
}>;


export type GetOrderDetailsQuery = { __typename?: 'Query', getOrderDetails?: Maybe<{ __typename?: 'Order', order?: Maybe<{ __typename?: 'OracleOrderViewModel', OrderNumber: number, WebOrderNumber: string, DropShipNumber: string, IsDropShip: boolean, OrderStatus: string, PaymentMethod: string, ShippingCarrier: string, ShippingMethod: string, ShippingMethodDescription: string, CustomerPoNumber: string, OrderDate: any, OrderDateToShortString: string, ShippingCharge: number, TaxTotal: number, SubTotal: number, OrderTotal: number, MaskedCreditCardNumber: string, LastFourOfCreditCard: string, ShipToAccountNumber: string, ShipToCompanyName: string, ShipToOrigSysRef: string, ShipToLocation: string, ShipToAddress1: string, ShipToAddress2: string, ShipToAddress3: string, ShipToAddress4: string, ShipToCity: string, ShipToState: string, ShipToProvince: string, ShipToZip: string, ShipToCountry: string, ShipToCounty: string, ShipToTimeZone: string, ShipToFormatted: string, BillToAccountNumber: string, BillToCompanyName: string, BillToOrigSysRef: string, BillToAddress1: string, BillToAddress2: string, BillToAddress3: string, BillToAddress4: string, BillToCity: string, BillToState: string, BillToProvince: string, BillToZip: string, BillToCountry: string, BillToCounty: string, BillToFormatted: string, CurrencyCode: number, IsCancelled: boolean, IsCancellable: boolean, IsInConsultantMode: boolean, CanAddComments: boolean, CreatedBy: string, ExistsInWebTable: boolean, ExportLink: string, AllItemsHaveShipped: boolean, OrderDetails: Array<{ __typename?: 'OracleOrderDetailViewModel', OrderNumber: number, ItemNumber: string, IsCancelled: boolean, IsCancellable: boolean, Image: string, ItemURL: string, SpecialInstructions: string, SpecialServiceCode: string, InventoryItemId: number, CancelledQuantity: number, SerialNumber: number, Description: string, AdditionalDescription: string, ShipSetCode: string, EstShipDate?: Maybe<any>, RevisedShipDate?: Maybe<any>, UnitSellingPrice: number, PrettyStatus: string, WMSStatus: string, ConfigHeaderId: number, ConfigOnWebNotOracle: boolean, ValidatedWebConfigId?: Maybe<number>, WebConfigId?: Maybe<number>, CamJobID?: Maybe<number>, IsCadCam?: Maybe<boolean>, WebConfigIsInvalid: boolean, LineId: number, ConfigurationIsMonogram: boolean, IsTopModelLine: boolean, TopModelLineId?: Maybe<number>, ConfigurationImage: string, ConfigurationInventoryItemId?: Maybe<number>, ConfigurationTitle: string, ConfigurationUrl: string, ItemTypeCode: string, ConfigurationItemNumber?: Maybe<string>, OrderedQuantity: number, FulfilledQuantity: number, ExtendedSellingPrice: number, CanAddToCart: boolean, CanShowConfigurationSummary: boolean, ShowFakeConfigurationLine: boolean, ShowActions: boolean, IsPartOfConfiguration: boolean, IsFirstLineOfConfiguration: boolean, IsLastLineOfConfiguration: boolean, ConfigurationPrice: number, ConfigurationBaseProductUrl: string, ProductTracking?: Maybe<any>, Report: string, CertUrl: string, CancellationReasons: Array<{ __typename?: 'CancellationReasonViewModel', Value: string, Display: string }> }>, OracleInvoices: Array<{ __typename?: 'OracleInvoiceViewModel', InvoiceNumber: number, InvoiceUrl: string, InvoiceDate: any, InvoiceDateShortString: string, TrackingNumber: string, TrackingLink: string, InvoiceTotalString: string, CodTotalAmt: number, CodTotalAmtString: string, ShippingCarrier?: Maybe<string>, ShippingCarrierTrackingSupported: boolean, IsPickUp: boolean, ReadyForPickUpDate?: Maybe<any>, PickedUpDate?: Maybe<any>, SalesTax: number, InvoiceTotal: number, ShipmentTracking?: Maybe<{ __typename?: 'ShipmentTracking', Success: boolean, TrackingNumber: string, Status: string, EstDeliveryDate?: Maybe<any>, DeliveryDate?: Maybe<any>, Delivered: boolean, PickedUpByCarrier: boolean, SignedForBy?: Maybe<string>, ShipmentMethod: string, FromCity?: Maybe<string>, FromState?: Maybe<string>, ToCity?: Maybe<string>, ToState?: Maybe<string>, Message?: Maybe<string>, TransitDetails?: Maybe<Array<Maybe<{ __typename?: 'ShipmentTrackingStep', TimeStamp: any, Description?: Maybe<string>, City?: Maybe<string>, State?: Maybe<string>, Location?: Maybe<string> }>>> }> }>, OracleAttachments: Array<{ __typename?: 'OracleAttachmentViewModel', Text: string, CategoryText: string }> }> }> };

export type GetContainsCustomsDocumentsQueryVariables = Exact<{
  params: GetCustomsDocumentsParams;
}>;


export type GetContainsCustomsDocumentsQuery = { __typename?: 'Query', getContainsCustomsDocuments?: Maybe<{ __typename?: 'GetContainsCustomsDocumentsResponse', containsCustomsDocuments: boolean }> };

export type GetCustomsDocumentsForInvoiceQueryVariables = Exact<{
  params: GetCustomsDocumentsParams;
}>;


export type GetCustomsDocumentsForInvoiceQuery = { __typename?: 'Query', getCustomsDocumentsForInvoice?: Maybe<{ __typename?: 'GetCustomsDocumentsForInvoiceResponse', success: boolean, fileData: string, fileName: string, contentType: string }> };

export type AddOrderCommentsMutationVariables = Exact<{
  params: AddOrderCommentsParams;
}>;


export type AddOrderCommentsMutation = { __typename?: 'Mutation', addOrderComments?: Maybe<{ __typename?: 'AddOrderComment', success: boolean }> };

export type CancelOrderMutationVariables = Exact<{
  params: CancelOrderParams;
}>;


export type CancelOrderMutation = { __typename?: 'Mutation', cancelOrder?: Maybe<boolean> };

export type CancelLineMutationVariables = Exact<{
  params: CancelLineParams;
}>;


export type CancelLineMutation = { __typename?: 'Mutation', cancelLine?: Maybe<boolean> };

export type GetPaymentMethodsAndOptionsQueryVariables = Exact<{
  overridePath: Scalars['String'];
}>;


export type GetPaymentMethodsAndOptionsQuery = { __typename?: 'Query', getPaymentMethodsAndOptions?: Maybe<{ __typename?: 'PaymentMethodResponse', AllowedMethods: Array<PaymentMethodType>, AllowedMethodsForConsultantOnly: Array<PaymentMethodType>, UserCanUseTerms: boolean, UserCanUseCOD: boolean, UserCanUseCreditCards: boolean, UserCanUseDebitCards: boolean, UserCanUseACH: boolean, NoneSelected: boolean, IsLoggedIn: boolean, AllowedCreditCardTypes: Array<{ __typename?: 'CreditCardType', Id?: Maybe<string>, Description?: Maybe<string>, CssClassName?: Maybe<string> }>, PaymentMethods: Array<{ __typename?: 'PaymentMethod', Method: string, DisplayName: string, UniqueKey: string, IsSelected: boolean, OnlyShowInConsultantMode: boolean, SelectableValue: string, CreditCard?: Maybe<{ __typename?: 'CreditCard', Id: string, CardType: string, CardNumber: string, CardHolderName: string, ExpirationMonth: number, ExpirationYear: number, Zip: string, Cvv?: Maybe<string>, IsExpired: boolean, IsDebit: boolean, InstrumentId: string, DataSource: string }>, BankAccount?: Maybe<{ __typename?: 'BankAccount', Id: string, BankName: string, AccountNumber: string, AccountNumberConfirmation: string, RoutingNumber: string, Tokenized?: Maybe<boolean> }> }> }> };

export type TokenizeCardQueryVariables = Exact<{
  endpoint?: Maybe<Scalars['String']>;
  overridePath: Scalars['String'];
}>;


export type TokenizeCardQuery = { __typename?: 'Query', tokenizeCard: string };

export type StullerPayQueryVariables = Exact<{
  params?: Maybe<StullerPayParams>;
}>;


export type StullerPayQuery = { __typename?: 'Query', stullerPay?: Maybe<{ __typename?: 'StullerPayResponse', IsOracleDown: boolean, Eligible: boolean, TermOptions: Array<{ __typename?: 'TermOption', Option: string, Id: string, TermDisplay: string, TermValue: number, MonthlyPrice: number, Price: number, FeePercentDecimal: number, ShippingCost?: Maybe<number>, FeeAmount: number, TotalPrice: number, MinimumPrice: number }> }> };

export type FindAllActiveAutorenewalsByCreditCardIdQueryVariables = Exact<{
  params: FindAllActiveAutorenewalsByCreditCardIdParams;
}>;


export type FindAllActiveAutorenewalsByCreditCardIdQuery = { __typename?: 'Query', findAllActiveAutorenewalsByCreditCardId?: Maybe<{ __typename?: 'LoyaltyProgramDetails', Renewals?: Maybe<Array<Maybe<{ __typename?: 'Renewals', DateForAutoRenewal?: Maybe<string>, IsStullerFirst?: Maybe<boolean>, Name?: Maybe<string> }>>> }> };

export type SaveDefaultPaymentMethodMutationVariables = Exact<{
  input?: Maybe<SaveDefaultPaymentMethodParams>;
}>;


export type SaveDefaultPaymentMethodMutation = { __typename?: 'Mutation', saveDefaultPaymentMethod?: Maybe<{ __typename?: 'SaveDefaultPaymentMethodResponse', success: boolean, errors?: Maybe<Array<Maybe<string>>> }> };

export type DeleteCredtCardMutationVariables = Exact<{
  input?: Maybe<DeleteCredtCardParams>;
}>;


export type DeleteCredtCardMutation = { __typename?: 'Mutation', deleteCreditCard?: Maybe<{ __typename?: 'DeleteCredtCardResponse', success: boolean }> };

export type DeleteBankAccountMutationVariables = Exact<{
  input?: Maybe<DeleteBankAccountParams>;
}>;


export type DeleteBankAccountMutation = { __typename?: 'Mutation', deleteBankAccount?: Maybe<{ __typename?: 'DeleteBankAccountResponse', success: boolean }> };

export type SaveCardMutationVariables = Exact<{
  input?: Maybe<SaveCardParams>;
}>;


export type SaveCardMutation = { __typename?: 'Mutation', saveCard?: Maybe<{ __typename?: 'SaveCardResponse', success: boolean, errors?: Maybe<Array<Maybe<string>>>, creditCard?: Maybe<{ __typename?: 'CreditCard', Id: string, CardType: string, CardNumber: string, CardHolderName: string, ExpirationMonth: number, ExpirationYear: number, ExpirationDate?: Maybe<string>, Zip: string, Cvv?: Maybe<string>, IsExpired: boolean, IsDebit: boolean, InstrumentId: string, DataSource: string, Schema?: Maybe<string> }> }> };

export type SaveNewBankAccountMutationVariables = Exact<{
  input?: Maybe<SaveNewBankAccountParams>;
}>;


export type SaveNewBankAccountMutation = { __typename?: 'Mutation', saveNewBankAccount?: Maybe<{ __typename?: 'SaveNewBankAccountResponse', success: boolean, errors?: Maybe<Array<Maybe<string>>>, bankAccount?: Maybe<{ __typename?: 'BankAccount', Id: string, BankName: string, AccountNumber: string, AccountNumberConfirmation: string, RoutingNumber: string, Tokenized?: Maybe<boolean> }> }> };

export type GetMetalQualitiesQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type GetMetalQualitiesQuery = { __typename?: 'Query', getMetalQualities?: Maybe<Array<Maybe<{ __typename?: 'MetalQuality', DisplayName?: Maybe<string>, SubGroup?: Maybe<string>, Name?: Maybe<string>, IconPath?: Maybe<string>, ColorName?: Maybe<string>, ColorNameLower?: Maybe<string>, Karat?: Maybe<string>, BaseMetal?: Maybe<string>, Code?: Maybe<string>, ColorHexValue?: Maybe<string>, CounterSketchMetalMaterialCode?: Maybe<string>, RelatedContentContainerId?: Maybe<string>, IsMultiTone?: Maybe<boolean> }>>> };

export type GetInvoicesQueryVariables = Exact<{
  params: GetInvoicesParams;
}>;


export type GetInvoicesQuery = { __typename?: 'Query', getInvoices?: Maybe<{ __typename?: 'InvoiceSearchResults', TotalRecords: number, Errors: Array<string>, ReceivableTransactions: Array<{ __typename?: 'ReceivableTransaction', TransactionNumber: number, OrderNumber: string, Total: number, TotalDue: number, TransactionDate: any, AccountNumber: string, TransactionType: string, CurrencyCode: string, ShipmentMethodCode: string, TrackingNumber: string, Status: string, PONumber?: Maybe<string> }> }> };

export type MonthlyStatementEligibilityQueryVariables = Exact<{ [key: string]: never; }>;


export type MonthlyStatementEligibilityQuery = { __typename?: 'Query', monthlyStatementEligibility?: Maybe<{ __typename?: 'MonthlyStatementEligibilityResult', IsEligible: boolean }> };

export type StatementDatesQueryVariables = Exact<{ [key: string]: never; }>;


export type StatementDatesQuery = { __typename?: 'Query', getStatementDates?: Maybe<{ __typename?: 'StatementDates', MinDate?: Maybe<number>, MaxDate?: Maybe<number> }> };

export type AutomaticPaymentsQueryVariables = Exact<{
  params?: Maybe<AutomaticPaymentParams>;
}>;


export type AutomaticPaymentsQuery = { __typename?: 'Query', getAutomaticPayments: Array<{ __typename?: 'AutomaticPayment', Id: number, CustomerAccountId: number, CreationDate: any, LastUpdatedDate: any, Nickname: string, DayOfMonth?: Maybe<number>, DayOfWeek?: Maybe<string>, NumberOfInstallments: number, NextPaymentDate?: Maybe<any>, TransactionCount: number, OrderNumber: number, TotalAmount?: Maybe<number>, CurrencyCode: string, InstrumentId: number, CardType?: Maybe<string>, IsDebitCard?: Maybe<boolean>, CardExpirationDate?: Maybe<any>, BankName?: Maybe<string>, PaymentFailedCount?: Maybe<number>, PaymentFailedReason?: Maybe<string>, TransactionErrorMessage?: Maybe<string>, AmountDue?: Maybe<number>, NextPaymentDueAmount: number, PastDuePaymentAmount: number, Title?: Maybe<string>, ImageUrl?: Maybe<string>, SKU?: Maybe<string>, IsPending?: Maybe<boolean>, Type: { __typename?: 'AutomaticPaymentType', Name: string, Value: string }, Frequency: { __typename?: 'FrequencyType', Name: string, Value: string }, TokenizedCardNumber?: Maybe<{ __typename?: 'TokenizedPaymentMethodNumber', TokenizedNumber: string, LastFour: string }>, TokenizedBankAccountNumber?: Maybe<{ __typename?: 'TokenizedPaymentMethodNumber', TokenizedNumber: string, LastFour: string }> }> };

export type CreateAutomaticPaymentForStatementMutationVariables = Exact<{
  input: CreateAutomaticPaymentForStatementParams;
}>;


export type CreateAutomaticPaymentForStatementMutation = { __typename?: 'Mutation', createAutomaticPaymentForStatement?: Maybe<{ __typename?: 'CreateAutomaticPaymentForStatementResult', AutomaticPaymentId?: Maybe<number>, ErrorMessage?: Maybe<string> }> };

export type CreateAutomaticPaymentForOrderMutationVariables = Exact<{
  input: CreateAutomaticPaymentForOrderParams;
}>;


export type CreateAutomaticPaymentForOrderMutation = { __typename?: 'Mutation', createAutomaticPaymentForOrder?: Maybe<{ __typename?: 'CreateAutomaticPaymentForOrderResult', AutomaticPaymentId?: Maybe<number>, ErrorMessage?: Maybe<string> }> };

export type CreateAutomaticPaymentForTransactionsMutationVariables = Exact<{
  input: CreateAutomaticPaymentForTransactionsParams;
}>;


export type CreateAutomaticPaymentForTransactionsMutation = { __typename?: 'Mutation', createAutomaticPaymentForTransactions?: Maybe<{ __typename?: 'CreateAutomaticPaymentForTransactionsResult', AutomaticPaymentId?: Maybe<number>, ErrorMessage?: Maybe<string> }> };

export type FinalizeAutomaticPaymentMutationVariables = Exact<{
  input: FinalizeAutomaticPaymentParams;
}>;


export type FinalizeAutomaticPaymentMutation = { __typename?: 'Mutation', finalizeAutomaticPayment?: Maybe<{ __typename?: 'FinalizeAutomaticPaymentResult', AutomaticPaymentId: number }> };

export type CancelAutomaticPaymentMutationVariables = Exact<{
  input: CancelAutomaticPaymentParams;
}>;


export type CancelAutomaticPaymentMutation = { __typename?: 'Mutation', cancelAutomaticPayment?: Maybe<{ __typename?: 'CancelAutomaticPaymentResult', AutomaticPaymentId: number }> };

export type UpdateAutomaticPaymentMutationVariables = Exact<{
  input: UpdateAutomaticPaymentParams;
}>;


export type UpdateAutomaticPaymentMutation = { __typename?: 'Mutation', updateAutomaticPayment?: Maybe<{ __typename?: 'UpdateAutomaticPaymentResult', AutomaticPaymentId: number }> };

export type GetReceivableTransactionsQueryVariables = Exact<{
  params: GetReceivableTransactionsParams;
}>;


export type GetReceivableTransactionsQuery = { __typename?: 'Query', getReceivableTransactions?: Maybe<{ __typename?: 'ReceivableTransactionResults', Page: number, PageSize: number, TotalTransactions: number, Transactions: Array<{ __typename?: 'ReceivableTransactionRollup', TransactionId: number, TransactionNumber: string, ShipToAccountNumber: string, TransactionDate: any, DueDate: any, Type: string, Terms: string, Status: string, PONumber: string, OrderNumber: string, Pending: boolean, IsInAutomaticPayment: boolean, TotalAmount: { __typename?: 'Currency', Value: number, CurrencyCode: string }, AmountDue: { __typename?: 'Currency', Value: number, CurrencyCode: string }, Installments: Array<{ __typename?: 'ReceivableInstallment', TransactionId: number, TransactionNumber: string, TransactionDate: any, DueDate: any, Type: string, Terms: string, Status: string, PONumber: string, OrderNumber: string, Sequence: number, Pending: boolean, IsInAutomaticPayment: boolean, TotalAmount: { __typename?: 'Currency', Value: number, CurrencyCode: string }, AmountDue: { __typename?: 'Currency', Value: number, CurrencyCode: string } }> }> }> };

export type GetNonPastDueCodTransactionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNonPastDueCodTransactionsQuery = { __typename?: 'Query', getNonPastDueCODTransactions?: Maybe<{ __typename?: 'NonPastDueCODReceivableTransactionResults', NonPastDueCODTransactions: Array<{ __typename?: 'ReceivableTransactionRollup', TransactionId: number, TransactionNumber: string, ShipToAccountNumber: string, TransactionDate: any, DueDate: any, Type: string, Terms: string, Status: string, PONumber: string, OrderNumber: string, Pending: boolean, IsInAutomaticPayment: boolean, TotalAmount: { __typename?: 'Currency', Value: number, CurrencyCode: string }, AmountDue: { __typename?: 'Currency', Value: number, CurrencyCode: string }, Installments: Array<{ __typename?: 'ReceivableInstallment', TransactionId: number, TransactionNumber: string, TransactionDate: any, DueDate: any, Type: string, Terms: string, Status: string, PONumber: string, OrderNumber: string, Sequence: number, Pending: boolean, IsInAutomaticPayment: boolean, TotalAmount: { __typename?: 'Currency', Value: number, CurrencyCode: string }, AmountDue: { __typename?: 'Currency', Value: number, CurrencyCode: string } }> }> }> };

export type GetFilteredTransactionAccountSummaryQueryVariables = Exact<{
  filter: TransactionFilter;
}>;


export type GetFilteredTransactionAccountSummaryQuery = { __typename?: 'Query', getTransactionsAccountSummary?: Maybe<{ __typename?: 'ReceivableTransactionBillToAccountSummary', TransactionCount: number, StatementIssueDate?: Maybe<any>, IncludesAutomaticPaymentTransaction?: Maybe<boolean>, Balance: { __typename?: 'Currency', Value: number, CurrencyCode: string } }> };

export type GetCurrentBalanceAccountSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentBalanceAccountSummaryQuery = { __typename?: 'Query', getCurrentBalanceAccountSummary?: Maybe<{ __typename?: 'ReceivableTransactionBillToAccountSummary', TransactionCount: number, StatementIssueDate?: Maybe<any>, IncludesAutomaticPaymentTransaction?: Maybe<boolean>, Balance: { __typename?: 'Currency', Value: number, CurrencyCode: string } }> };

export type GetPastDueBalanceAccountSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPastDueBalanceAccountSummaryQuery = { __typename?: 'Query', getPastDueBalanceAccountSummary?: Maybe<{ __typename?: 'ReceivableTransactionBillToAccountSummary', TransactionCount: number, StatementIssueDate?: Maybe<any>, IncludesAutomaticPaymentTransaction?: Maybe<boolean>, Balance: { __typename?: 'Currency', Value: number, CurrencyCode: string } }> };

export type GetCurrentStatementAccountSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentStatementAccountSummaryQuery = { __typename?: 'Query', getCurrentStatementAccountSummary?: Maybe<{ __typename?: 'ReceivableTransactionBillToAccountSummary', TransactionCount: number, StatementIssueDate?: Maybe<any>, IncludesAutomaticPaymentTransaction?: Maybe<boolean>, Balance: { __typename?: 'Currency', Value: number, CurrencyCode: string } }> };

export type GetPendingPaymentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendingPaymentsQuery = { __typename?: 'Query', getPendingPayments: Array<{ __typename?: 'PaymentOnAccount', Id: number, BillToAccountNumber?: Maybe<string>, Status?: Maybe<string>, ProcessingStatus?: Maybe<string>, PaymentType: string, AccountId: string, PaymentDate: any, PaymentAuthorizationCode?: Maybe<string>, PaymentCreditCardType?: Maybe<string>, PaymentLabel: string, Amount: { __typename?: 'Currency', Value: number, CurrencyCode: string } }> };

export type GetPaymentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetPaymentQuery = { __typename?: 'Query', getPayment?: Maybe<{ __typename?: 'PaymentOnAccount', Id: number, BillToAccountNumber?: Maybe<string>, Status?: Maybe<string>, ProcessingStatus?: Maybe<string>, PaymentType: string, AccountId: string, PaymentDate: any, PaymentAuthorizationCode?: Maybe<string>, PaymentLabel: string, PaymentCreditCardType?: Maybe<string>, Amount: { __typename?: 'Currency', Value: number, CurrencyCode: string } }> };

export type GetPaymentInvoicesQueryVariables = Exact<{
  id: Scalars['Int'];
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
}>;


export type GetPaymentInvoicesQuery = { __typename?: 'Query', getPaymentInvoices?: Maybe<{ __typename?: 'PaymentInvoicesResults', Page: number, PageSize: number, TotalInvoices: number, Invoices: Array<{ __typename?: 'PaymentInvoice', Id: number, PaymentId: number, InvoiceNumber: string, InvoiceId: number, SequenceNumber?: Maybe<number>, Installment?: Maybe<number>, TransactionType?: Maybe<string>, TransactionTypeDisplay?: Maybe<string>, Amount: { __typename?: 'Currency', Value: number, CurrencyCode: string } }> }> };

export type SubmitPaymentsMutationVariables = Exact<{
  input: SubmitPaymentParams;
}>;


export type SubmitPaymentsMutation = { __typename?: 'Mutation', submitPayments?: Maybe<{ __typename?: 'SubmitPaymentResult', PaymentId: number }> };

export type GetReturnsQueryVariables = Exact<{
  params: ReturnHistoryParams;
}>;


export type GetReturnsQuery = { __typename?: 'Query', returnHistory?: Maybe<{ __typename?: 'ReturnHistory', totalRecords?: Maybe<number>, returns?: Maybe<Array<{ __typename?: 'ReturnHistoryItem', AccountNumber: string, OrderDate: string, OrderDateString: string, OrderLineCount: number, OrderNumber: number, Status: string, TotalPrice: number, TrackingNumber?: Maybe<string>, TrackingUrl?: Maybe<string>, WebNumber?: Maybe<number> }>> }> };

export type GetReturnReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReturnReasonsQuery = { __typename?: 'Query', getReturnReasons: Array<{ __typename?: 'ReturnReason', Code: string, Meaning: string }> };

export type CreateRmaMutationVariables = Exact<{
  input?: Maybe<CreateRmaInput>;
}>;


export type CreateRmaMutation = { __typename?: 'Mutation', createRMA?: Maybe<{ __typename?: 'CreateRMAResult', success: boolean, errors?: Maybe<Array<string>>, orderNumber?: Maybe<string> }> };

export type GetSearchNavigationQueryVariables = Exact<{
  pathname: Scalars['String'];
  search: Scalars['String'];
}>;


export type GetSearchNavigationQuery = { __typename?: 'Query', getSearchNavigation: { __typename?: 'CategoryOrSearchViewModel', PresentationContext: SearchPresentationContext, RedirectUrl?: Maybe<string>, BottomNavigationSectionContentId?: Maybe<number>, UnderCategorySectionContentId?: Maybe<number>, ShowCenterStoneColors: boolean, ClearAllUrl?: Maybe<string>, HideSideNav: boolean, PageHeader: string, PageTitle: string, ArticlesCount: number, ShowDiscounts: boolean, SearchSource?: Maybe<string>, ShowSeriesAboveImage: boolean, Query?: Maybe<string>, QueryId?: Maybe<string>, Category?: Maybe<string>, CategoryId?: Maybe<number>, CategoryPermalinkUrl?: Maybe<string>, TopAcrossPageContentId?: Maybe<number>, ContentId?: Maybe<number>, AllowNewContentBlockCreation: boolean, NewContentBlockName: string, ContentBlockLocation: number, CmsContentType: number, IsContentOnlyDisplayTemplate: boolean, OriginalQuery?: Maybe<string>, CorrectedQuery?: Maybe<string>, TopRowInResultsContentID?: Maybe<number>, ImpressionListName?: Maybe<string>, ShowPageSize: boolean, MerchandisingMode: boolean, BreadCrumbs?: Maybe<Array<{ __typename?: 'Breadcrumb', EncodedText: string, Url?: Maybe<string> }>>, CenterStoneColors?: Maybe<Array<{ __typename?: 'CenterStoneColor', HexCode: string, Name: string, IsSelected: boolean }>>, ChildCategories?: Maybe<Array<{ __typename?: 'CategoryViewModel', Id: number, PageTitle: string, ShowcasePageTitle: string, Name: string, PageMetaDescription: string, PageHeader: string, ContentId?: Maybe<number>, IsAShopCategory: boolean, HideCategory: boolean, ShowInShowcase: boolean, BottomContentId?: Maybe<number>, ShowcaseDisplayName: string, StandardDisplayName: string, ShowImages: boolean, SanitizedName: string, OverrideUrl: string, CDNImageName: string, ShowGrandChildren: boolean, SortOrder: number, SanitizedPath: string, ChildCategories?: Maybe<Array<Maybe<{ __typename?: 'CategoryViewModel', Id: number, PageTitle: string, ShowcasePageTitle: string, Name: string, PageMetaDescription: string, PageHeader: string, ContentId?: Maybe<number>, IsAShopCategory: boolean, HideCategory: boolean, ShowInShowcase: boolean, BottomContentId?: Maybe<number>, ShowcaseDisplayName: string, StandardDisplayName: string, ShowImages: boolean, SanitizedName: string, OverrideUrl: string, CDNImageName: string, ShowGrandChildren: boolean, SortOrder: number, SanitizedPath: string }>>> }>>, FacetValues?: Maybe<Array<{ __typename?: 'FacetValue', First: string, Second: string }>>, NavigationSections?: Maybe<Array<{ __typename?: 'NavigationSection', Title: string, SearchField: string, TopLabel: string, LoggedInOnly: boolean, UseDecorationForLink: boolean, DecorationText?: Maybe<string>, CssClass?: Maybe<string>, HideForSterling: boolean, SortOrder?: Maybe<number>, IsMultiSelect: boolean, IsSingleSelect: boolean, IsPivot: boolean, UseIcon: boolean, NavPosition: string, Layout: string, NavigationItems: Array<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, Children?: Maybe<Array<Maybe<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>>>, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>, SelectedNavigationItem?: Maybe<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, Children?: Maybe<Array<Maybe<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>>>, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>, DefaultImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>>, TopNavigationSections?: Maybe<Array<{ __typename?: 'NavigationSection', Title: string, SearchField: string, TopLabel: string, LoggedInOnly: boolean, UseDecorationForLink: boolean, DecorationText?: Maybe<string>, CssClass?: Maybe<string>, HideForSterling: boolean, SortOrder?: Maybe<number>, IsMultiSelect: boolean, IsSingleSelect: boolean, IsPivot: boolean, UseIcon: boolean, NavPosition: string, Layout: string, NavigationItems: Array<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, Children?: Maybe<Array<Maybe<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, Children?: Maybe<Array<Maybe<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>>>, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>>>, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>, SelectedNavigationItem?: Maybe<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, Children?: Maybe<Array<Maybe<{ __typename?: 'NavigationItem', LinkText: string, TrackingName: string, LinkUrl: string, Value: string, CssClass?: Maybe<string>, FromSectionTitle?: Maybe<string>, IsSelected: boolean, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>>>, ImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>, DefaultImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }> }>>, SelectedFacets?: Maybe<Array<{ __typename?: 'SelectedFacet', Name: string, Value: string, SearchField: string, Url: string, FromSection?: Maybe<string> }>>, SearchResults?: Maybe<Array<{ __typename?: 'SearchResult', Id: number, Code: string, ParentCode?: Maybe<string>, Rank?: Maybe<string>, Description?: Maybe<string>, TemplatePage?: Maybe<string>, DisplayPrice?: Maybe<string>, GroupDetailsUrl?: Maybe<string>, OverrideItemId?: Maybe<number>, IsValidFor3CBadge: boolean, IsValidForNewItemBadge: boolean, IsValidForBestSellerBadge: boolean, IsValidForNewDealBadge: boolean, IsValidForDieStruckBadge: boolean, IsValidForMetalMoldBadge: boolean, IsValidForCoinedBadge: boolean, IsValidForMachinedBadge: boolean, IsValidForDigitalImprintingBadge: boolean, IsValidForHotStampingBadge: boolean, IsValidForLimitedTimeOnlyBadge: boolean, IsSCSCertified: boolean, IsMadeWithCycledMaterials: boolean, IsPrincipledSourcing: boolean, IsValidForEverAndEverBadge: boolean, IsValidForLabGrownBadge: boolean, IsValidForNotableGemsBadge: boolean, ClickLoggingPayload?: Maybe<string>, SearchId?: Maybe<string>, MinDiscount?: Maybe<number>, MaxDiscount?: Maybe<number>, DiscountIsFlashSaleAndStullerFirst: boolean, WholeGroupIsDiscounted?: Maybe<boolean>, IsDiscounted: boolean, ProductState?: Maybe<string>, SerialNumber?: Maybe<number>, GeographicalOrigin?: Maybe<string>, CountryOfOrigin?: Maybe<string>, KnownOrigin?: Maybe<boolean>, FeaturedSearchAttribute?: Maybe<string>, FeaturedSearchAttributeValue?: Maybe<string>, ProductTracking: any, ImageUrls?: Maybe<{ __typename?: 'ImageUrlsDto', RawUrl?: Maybe<string>, FullSizeUrl?: Maybe<string>, Thumb75Url?: Maybe<string>, Thumb125Url?: Maybe<string>, Thumb150Url?: Maybe<string>, Thumb165Url: string, Thumb100Url?: Maybe<string>, Thumb40Url?: Maybe<string>, Size640Url?: Maybe<string>, Size430Url?: Maybe<string>, Size350Url?: Maybe<string>, Size250Url: string, Size190Url?: Maybe<string>, ZoomUrl?: Maybe<string>, Height?: Maybe<number>, Width?: Maybe<number>, Format?: Maybe<string>, IsZoomable?: Maybe<boolean>, IsSuperZoomable?: Maybe<boolean>, SortOrder?: Maybe<number>, IsNotFoundImage?: Maybe<boolean>, MediaType?: Maybe<string>, Video1024x768Html?: Maybe<string>, Video640x480Html?: Maybe<string>, Preview360PDP?: Maybe<string>, Preview360Compare?: Maybe<string>, Preview360Zoom?: Maybe<string>, Video360CompareHtml?: Maybe<string>, Video360PDPHtml?: Maybe<string>, Video360ZoomHtml?: Maybe<string>, VideoDynamicHtml?: Maybe<string>, ImageId: number, Angle?: Maybe<string> }>, ImageUrlsSide?: Maybe<{ __typename?: 'ImageUrlsDto', RawUrl?: Maybe<string>, FullSizeUrl?: Maybe<string>, Thumb75Url?: Maybe<string>, Thumb125Url?: Maybe<string>, Thumb150Url?: Maybe<string>, Thumb165Url: string, Thumb100Url?: Maybe<string>, Thumb40Url?: Maybe<string>, Size640Url?: Maybe<string>, Size430Url?: Maybe<string>, Size350Url?: Maybe<string>, Size250Url: string, Size190Url?: Maybe<string>, ZoomUrl?: Maybe<string>, Height?: Maybe<number>, Width?: Maybe<number>, Format?: Maybe<string>, IsZoomable?: Maybe<boolean>, IsSuperZoomable?: Maybe<boolean>, SortOrder?: Maybe<number>, IsNotFoundImage?: Maybe<boolean>, MediaType?: Maybe<string>, Video1024x768Html?: Maybe<string>, Video640x480Html?: Maybe<string>, Preview360PDP?: Maybe<string>, Preview360Compare?: Maybe<string>, Preview360Zoom?: Maybe<string>, Video360CompareHtml?: Maybe<string>, Video360PDPHtml?: Maybe<string>, Video360ZoomHtml?: Maybe<string>, VideoDynamicHtml?: Maybe<string>, ImageId: number, Angle?: Maybe<string> }>, FeaturedSearchAttributeValues?: Maybe<Array<{ __typename?: 'ProductSearchAttribute', AttributeValue: string, ItemId: number, ItemDetailsUrl: string, AttributeImageAsset?: Maybe<{ __typename?: 'ImageAsset', id: string, type: string, source: string }>, ImageUrls?: Maybe<{ __typename?: 'ImageUrlsDto', RawUrl?: Maybe<string>, FullSizeUrl?: Maybe<string>, Thumb75Url?: Maybe<string>, Thumb125Url?: Maybe<string>, Thumb150Url?: Maybe<string>, Thumb165Url: string, Thumb100Url?: Maybe<string>, Thumb40Url?: Maybe<string>, Size640Url?: Maybe<string>, Size430Url?: Maybe<string>, Size350Url?: Maybe<string>, Size250Url: string, Size190Url?: Maybe<string>, ZoomUrl?: Maybe<string>, Height?: Maybe<number>, Width?: Maybe<number>, Format?: Maybe<string>, IsZoomable?: Maybe<boolean>, IsSuperZoomable?: Maybe<boolean>, SortOrder?: Maybe<number>, IsNotFoundImage?: Maybe<boolean>, MediaType?: Maybe<string>, Video1024x768Html?: Maybe<string>, Video640x480Html?: Maybe<string>, Preview360PDP?: Maybe<string>, Preview360Compare?: Maybe<string>, Preview360Zoom?: Maybe<string>, Video360CompareHtml?: Maybe<string>, Video360PDPHtml?: Maybe<string>, Video360ZoomHtml?: Maybe<string>, VideoDynamicHtml?: Maybe<string>, ImageId: number, Angle?: Maybe<string> }> }>> }>>, RelatedSearchTerms?: Maybe<Array<Maybe<{ __typename?: 'SearchSuggestion', Rank?: Maybe<string>, Suggestion?: Maybe<string>, ClickLoggingPayload?: Maybe<string> }>>>, Pager?: Maybe<{ __typename?: 'Pager', TotalPages: number, CurrentPage: number, TotalRecords: number, FirstDisplayPage: number, LastDisplayPage: number, HidePagerWhenOnlyOnePageIsAvailable: boolean, ChangePageIsJavascript?: Maybe<boolean>, ShowingText: string, RecordsPerPage: number }>, Filters?: Maybe<Array<Maybe<{ __typename?: 'SearchFilters', Label?: Maybe<string>, Name?: Maybe<string>, Filter?: Maybe<Array<Maybe<string>>>, AdditionalFirstString?: Maybe<string> }>>>, SortByFilter: Array<{ __typename?: 'SelectListItem', Disabled: boolean, Group?: Maybe<string>, Selected: boolean, Text?: Maybe<string>, Value?: Maybe<string> }>, PageSizeFilter: Array<{ __typename?: 'SelectListItem', Disabled: boolean, Group?: Maybe<string>, Selected: boolean, Text?: Maybe<string>, Value?: Maybe<string> }>, StoneForViewAvailableMountings?: Maybe<{ __typename?: 'StoneForViewAvailableMountingsViewModel', ID: number, SerialNumber: number, Cut: string, Color: string, Shape: string, SizeCt?: Maybe<string>, SizeMm: string, Category?: Maybe<string>, Type: string, Variety: string, StoneQuality: string, Uniqueness: string, IsDiamond: boolean, HexColor: string, Price: string, PriceWithoutDiscount: string, DetailsUrl: string, Image: { __typename?: 'ImageUrlsDto', RawUrl?: Maybe<string>, FullSizeUrl?: Maybe<string>, Thumb75Url?: Maybe<string>, Thumb125Url?: Maybe<string>, Thumb150Url?: Maybe<string>, Thumb165Url: string, Thumb100Url?: Maybe<string>, Thumb40Url?: Maybe<string>, Size640Url?: Maybe<string>, Size430Url?: Maybe<string>, Size350Url?: Maybe<string>, Size250Url: string, Size190Url?: Maybe<string>, ZoomUrl?: Maybe<string>, Height?: Maybe<number>, Width?: Maybe<number>, Format?: Maybe<string>, IsZoomable?: Maybe<boolean>, IsSuperZoomable?: Maybe<boolean>, SortOrder?: Maybe<number>, IsNotFoundImage?: Maybe<boolean>, MediaType?: Maybe<string>, Video1024x768Html?: Maybe<string>, Video640x480Html?: Maybe<string>, Preview360PDP?: Maybe<string>, Preview360Compare?: Maybe<string>, Preview360Zoom?: Maybe<string>, Video360CompareHtml?: Maybe<string>, Video360PDPHtml?: Maybe<string>, Video360ZoomHtml?: Maybe<string>, VideoDynamicHtml?: Maybe<string>, ImageId: number, Angle?: Maybe<string> } }>, SearchByStoneSize?: Maybe<{ __typename?: 'SearchByStoneSizeViewModel', Shape: string, Dimension: string, ProductType: string, SelectedProductTypes: Array<Maybe<string>>, SelectedMetalColors: Array<Maybe<string>>, Style: string, ProngCount: string, StoneShapes: Array<{ __typename?: 'StoneShapeViewModel', CssClassName: string, DisplayName: string, PostValue: string, VectorId: string, ShapeType: ShapeType }>, StringDimensions: Array<{ __typename?: 'TupleString2', Item1: string, Item2: string }>, ProductTypes: Array<{ __typename?: 'TupleString2', Item1: string, Item2: string }>, MetalColors: Array<{ __typename?: 'TupleString2', Item1: string, Item2: string }>, Styles: Array<{ __typename?: 'TupleString2', Item1: string, Item2: string }>, ProngCounts: Array<{ __typename?: 'TupleString2', Item1: string, Item2: string }> }> } };

export type GetArticleResultsQueryVariables = Exact<{
  params?: Maybe<ArticleResultsParams>;
}>;


export type GetArticleResultsQuery = { __typename?: 'Query', getArticleResults: { __typename?: 'ArticleResultsResponse', Query: string, SortBy: Array<{ __typename?: 'SelectListItem', Disabled: boolean, Group?: Maybe<string>, Selected: boolean, Text?: Maybe<string>, Value?: Maybe<string> }>, Pager: { __typename?: 'Pager', TotalPages: number, CurrentPage: number, TotalRecords: number, FirstDisplayPage: number, LastDisplayPage: number, HidePagerWhenOnlyOnePageIsAvailable: boolean, ChangePageIsJavascript?: Maybe<boolean>, ShowingText: string, RecordsPerPage: number }, SearchResults?: Maybe<Array<{ __typename?: 'ArticleResult', CreationDate: string, Title: string, Url: string, Teaser: string, ContentType: string }>> } };

export type MerchandiseSubmissionShippingRatesQueryVariables = Exact<{
  input?: Maybe<MerchandiseSubmissionShippingRatesInput>;
}>;


export type MerchandiseSubmissionShippingRatesQuery = { __typename?: 'Query', merchandiseSubmissionShippingRates?: Maybe<Array<{ __typename?: 'MerchandiseSubmissionShippingRatesResults', Carrier: string, Description: string, FreightPrice: number, InsurancePrice: number, ReplacementValue: number, TotalShippingPrice: number, ShippingMethodCode: string }>> };

export type GetAvailableShipToAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableShipToAccountsQuery = { __typename?: 'Query', availableShipToAccounts: { __typename?: 'ShipToAccounts', shipToAccounts: Array<{ __typename?: 'ShipToAccount', ShipToAccountNumber: string, IsActive: boolean, HtmlFormattedAddress: string, InlineFormattedAddress: string }> } };

export type FindShipToAccountNumbersQueryVariables = Exact<{
  params: FindShipToAccountNumbersParams;
}>;


export type FindShipToAccountNumbersQuery = { __typename?: 'Query', findShipToAccountNumbers: Array<{ __typename?: 'ShipToAccountNumber', value: string, label: string }> };

export type GetSystemSettingValueQueryVariables = Exact<{
  settingName: Scalars['String'];
  appendSearch?: Maybe<Scalars['String']>;
}>;


export type GetSystemSettingValueQuery = { __typename?: 'Query', systemSettingValue?: Maybe<{ __typename?: 'SystemSettingResponse', value?: Maybe<string> }> };

export type GetFakePaymentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetFakePaymentQuery = { __typename?: 'Query', getFakePayment?: Maybe<{ __typename?: 'FakePayment', Id: number, Amount: number, From: string, Comment?: Maybe<string> }> };

export type GetFakePaymentIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFakePaymentIdsQuery = { __typename?: 'Query', getFakePaymentIds?: Maybe<Array<number>> };

export type CreateFakePaymentMutationVariables = Exact<{
  input: CreateFakePaymentParams;
}>;


export type CreateFakePaymentMutation = { __typename?: 'Mutation', createFakePayment?: Maybe<{ __typename?: 'CreateFakePaymentResult', Id: number }> };

export type CancelFakePaymentMutationVariables = Exact<{
  input: CancelFakePaymentParams;
}>;


export type CancelFakePaymentMutation = { __typename?: 'Mutation', cancelFakePayment?: Maybe<{ __typename?: 'CancelFakePaymentResult', CanceledPaymentId: number }> };

export type SendPasswordLinkMutationVariables = Exact<{
  input: SendPasswordLinkParams;
}>;


export type SendPasswordLinkMutation = { __typename?: 'Mutation', sendPasswordLink?: Maybe<{ __typename?: 'SendPasswordLinkResponse', success: boolean }> };

export const ChildCategoryResponseFragmentDoc = gql`
    fragment ChildCategoryResponse on CategoryViewModel {
  Id
  PageTitle
  ShowcasePageTitle
  Name
  PageMetaDescription
  PageHeader
  ContentId
  IsAShopCategory
  HideCategory
  ShowInShowcase
  BottomContentId
  ShowcaseDisplayName
  StandardDisplayName
  ShowImages
  SanitizedName
  OverrideUrl
  CDNImageName
  ShowGrandChildren
  SortOrder
  SanitizedPath
}
    `;
export const ImageAssetResponseFragmentDoc = gql`
    fragment ImageAssetResponse on ImageAsset {
  id
  type
  source
}
    `;
export const NavigationItemResponseFragmentDoc = gql`
    fragment NavigationItemResponse on NavigationItem {
  LinkText
  TrackingName
  LinkUrl
  Value
  CssClass
  FromSectionTitle
  IsSelected
  ImageAsset @type(name: "ImageAsset") {
    ...ImageAssetResponse
  }
}
    ${ImageAssetResponseFragmentDoc}`;
export const NavigationSectionResponseFragmentDoc = gql`
    fragment NavigationSectionResponse on NavigationSection {
  Title
  SearchField
  TopLabel
  LoggedInOnly
  UseDecorationForLink
  DecorationText
  CssClass
  HideForSterling
  SortOrder
  IsMultiSelect
  IsSingleSelect
  IsPivot
  UseIcon
  NavPosition
  Layout
  SelectedNavigationItem @type(name: "NavigationItem") {
    ...NavigationItemResponse
    Children @type(name: "NavigationItem") {
      ...NavigationItemResponse
    }
  }
  DefaultImageAsset @type(name: "ImageAsset") {
    ...ImageAssetResponse
  }
}
    ${NavigationItemResponseFragmentDoc}
${ImageAssetResponseFragmentDoc}`;
export const ImageUrlsResponseFragmentDoc = gql`
    fragment ImageUrlsResponse on ImageUrlsDto {
  RawUrl
  FullSizeUrl
  Thumb75Url
  Thumb125Url
  Thumb150Url
  Thumb165Url
  Thumb100Url
  Thumb40Url
  Size640Url
  Size430Url
  Size350Url
  Size250Url
  Size190Url
  ZoomUrl
  Height
  Width
  Format
  IsZoomable
  IsSuperZoomable
  SortOrder
  IsNotFoundImage
  MediaType
  Video1024x768Html
  Video640x480Html
  Preview360PDP
  Preview360Compare
  Preview360Zoom
  Video360CompareHtml
  Video360PDPHtml
  Video360ZoomHtml
  VideoDynamicHtml
  ImageId
  Angle
}
    `;
export const CategoryOrSearchQueryResponseFragmentDoc = gql`
    fragment CategoryOrSearchQueryResponse on CategoryOrSearchViewModel {
  PresentationContext
  RedirectUrl
  BottomNavigationSectionContentId
  UnderCategorySectionContentId
  ShowCenterStoneColors
  ClearAllUrl
  HideSideNav
  PageHeader
  PageTitle
  ArticlesCount
  BreadCrumbs {
    EncodedText
    Url
  }
  CenterStoneColors {
    HexCode
    Name
    IsSelected
  }
  ShowDiscounts
  SearchSource
  ShowSeriesAboveImage
  Query
  QueryId
  Category
  CategoryId
  CategoryPermalinkUrl
  TopAcrossPageContentId
  ContentId
  AllowNewContentBlockCreation
  NewContentBlockName
  ContentBlockLocation
  CmsContentType
  IsContentOnlyDisplayTemplate
  ChildCategories @type(name: "CategoryViewModel") {
    ...ChildCategoryResponse
    ChildCategories @type(name: "CategoryViewModel") {
      ...ChildCategoryResponse
    }
  }
  OriginalQuery
  CorrectedQuery
  TopRowInResultsContentID
  ImpressionListName
  FacetValues {
    First
    Second
  }
  NavigationSections @type(name: "NavigationSection") {
    ...NavigationSectionResponse
    NavigationItems @type(name: "NavigationItem") {
      ...NavigationItemResponse
      Children @type(name: "NavigationItem") {
        ...NavigationItemResponse
      }
    }
  }
  TopNavigationSections @type(name: "NavigationSection") {
    ...NavigationSectionResponse
    NavigationItems @type(name: "NavigationItem") {
      ...NavigationItemResponse
      Children @type(name: "NavigationItem") {
        ...NavigationItemResponse
        Children @type(name: "NavigationItem") {
          ...NavigationItemResponse
        }
      }
    }
  }
  SelectedFacets {
    Name
    Value
    SearchField
    Url
    FromSection
  }
  SearchResults {
    Id
    Code
    ParentCode
    Rank
    Description
    TemplatePage
    DisplayPrice
    GroupDetailsUrl
    OverrideItemId
    IsValidFor3CBadge
    IsValidForNewItemBadge
    IsValidForBestSellerBadge
    IsValidForNewDealBadge
    IsValidForDieStruckBadge
    IsValidForMetalMoldBadge
    IsValidForCoinedBadge
    IsValidForMachinedBadge
    IsValidForDigitalImprintingBadge
    IsValidForHotStampingBadge
    IsValidForLimitedTimeOnlyBadge
    IsSCSCertified
    IsMadeWithCycledMaterials
    IsPrincipledSourcing
    IsValidForEverAndEverBadge
    IsValidForLabGrownBadge
    IsValidForNotableGemsBadge
    ClickLoggingPayload
    SearchId
    MinDiscount
    MaxDiscount
    DiscountIsFlashSaleAndStullerFirst
    WholeGroupIsDiscounted
    IsDiscounted
    ProductState
    SerialNumber
    GeographicalOrigin
    CountryOfOrigin
    KnownOrigin
    ImageUrls @type(name: "ImageUrlsDto") {
      ...ImageUrlsResponse
    }
    ImageUrlsSide @type(name: "ImageUrlsDto") {
      ...ImageUrlsResponse
    }
    FeaturedSearchAttribute
    FeaturedSearchAttributeValue
    FeaturedSearchAttributeValues {
      AttributeValue
      AttributeImageAsset @type(name: "ImageAsset") {
        ...ImageAssetResponse
      }
      ItemId
      ItemDetailsUrl
      ImageUrls @type(name: "ImageUrlsDto") {
        ...ImageUrlsResponse
      }
    }
    ProductTracking
  }
  RelatedSearchTerms {
    Rank
    Suggestion
    ClickLoggingPayload
  }
  Pager {
    TotalPages
    CurrentPage
    TotalRecords
    FirstDisplayPage
    LastDisplayPage
    HidePagerWhenOnlyOnePageIsAvailable
    ChangePageIsJavascript
    ShowingText
    RecordsPerPage
  }
  Filters {
    Label
    Name
    Filter
    AdditionalFirstString
  }
  ShowPageSize
  SortByFilter {
    Disabled
    Group
    Selected
    Text
    Value
  }
  PageSizeFilter {
    Disabled
    Group
    Selected
    Text
    Value
  }
  MerchandisingMode
  StoneForViewAvailableMountings {
    ID
    SerialNumber
    Image @type(name: "ImageUrlsDto") {
      ...ImageUrlsResponse
    }
    Cut
    Color
    Shape
    SizeCt
    SizeMm
    Category
    Type
    Variety
    StoneQuality
    Uniqueness
    IsDiamond
    HexColor
    Price
    PriceWithoutDiscount
    DetailsUrl
  }
  SearchByStoneSize {
    StoneShapes {
      CssClassName
      DisplayName
      PostValue
      VectorId
      ShapeType
    }
    StringDimensions {
      Item1
      Item2
    }
    ProductTypes {
      Item1
      Item2
    }
    MetalColors {
      Item1
      Item2
    }
    Styles {
      Item1
      Item2
    }
    ProngCounts {
      Item1
      Item2
    }
    Shape
    Dimension
    ProductType
    SelectedProductTypes
    SelectedMetalColors
    Style
    ProngCount
  }
}
    ${ChildCategoryResponseFragmentDoc}
${NavigationSectionResponseFragmentDoc}
${NavigationItemResponseFragmentDoc}
${ImageUrlsResponseFragmentDoc}
${ImageAssetResponseFragmentDoc}`;
export const GetAddAHeadFacetsAndResultsDocument = gql`
    query GetAddAHeadFacetsAndResults($query: String!) {
  getAddAHeadFacetsAndResults(query: $query) @rest(endpoint: "stullercom", path: "cms/searchable-index/add-a-head?query={args.query}", type: "AddAHeadViewModel") {
    Total
    QueryTimeMs
    Facets {
      attr_string_Quality
      attr_string_Stone_Shape
      attr_string_Stone_Size
      attr_string_Product_State
      attr_string_Prong_Count
      series
    }
    Items {
      DetailsUrl
      Product {
        id
        quickshop_id
        product_id
        is_valid
        is_new
        image_angles
        group_by
        item_number
        group_ids
        default_group_id
        filtered_group_ids
        category_ids
        categories
        filtered_category_ids
        filtered_categories
        serial_number
        in_stock
        pricelist_ids
        attr_string_Quality
        attr_string_Stone_Shape
        attr_string_Stone_Size
        attr_string_Product_State
        attr_string_Prong_Count
        attr_string_Title
        attrs_string_Related_Shank_Product_Id
        attrs_string_Parent_ATO_Model_Number
        series
        attr_string_Secondary_Stone_Type
        attr_string_Secondary_Stone_Origin
        attrs_string_img_A @type(name: "ImageUrlsDto") {
          ...ImageUrlsResponse
        }
        attrs_string_img_AngleA @type(name: "ImageUrlsDto") {
          ...ImageUrlsResponse
        }
        attrs_string_img_B @type(name: "ImageUrlsDto") {
          ...ImageUrlsResponse
        }
        attrs_string_img_ViewE @type(name: "ImageUrlsDto") {
          ...ImageUrlsResponse
        }
        image @type(name: "ImageUrlsDto") {
          ...ImageUrlsResponse
        }
        price {
          CurrentPrice {
            HtmlFormattedPrice
            ValueInUSD
            ValueAtCurrency
          }
          OriginalPrice {
            HtmlFormattedPrice
            ValueInUSD
            ValueAtCurrency
          }
          DiscountPercent
          EligibleAdditionalStullerFirstDiscountPercent
          DiscountType
          ValueSaved {
            HtmlFormattedPrice
            ValueInUSD
            ValueAtCurrency
          }
        }
        price_percarat {
          CurrentPrice {
            HtmlFormattedPrice
            ValueInUSD
            ValueAtCurrency
          }
          OriginalPrice {
            HtmlFormattedPrice
            ValueInUSD
            ValueAtCurrency
          }
          DiscountPercent
          EligibleAdditionalStullerFirstDiscountPercent
          DiscountType
          ValueSaved {
            HtmlFormattedPrice
            ValueInUSD
            ValueAtCurrency
          }
        }
      }
      AddToCartViewModel {
        Product {
          JsonPrice {
            CurrentPrice {
              HtmlFormattedPrice
              ValueInUSD
              ValueAtCurrency
            }
            OriginalPrice {
              HtmlFormattedPrice
              ValueInUSD
              ValueAtCurrency
            }
            DiscountPercent
            EligibleAdditionalStullerFirstDiscountPercent
            DiscountType
            ValueSaved {
              HtmlFormattedPrice
              ValueInUSD
              ValueAtCurrency
            }
          }
        }
      }
    }
  }
}
    ${ImageUrlsResponseFragmentDoc}`;

/**
 * __useGetAddAHeadFacetsAndResultsQuery__
 *
 * To run a query within a React component, call `useGetAddAHeadFacetsAndResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddAHeadFacetsAndResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddAHeadFacetsAndResultsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetAddAHeadFacetsAndResultsQuery(baseOptions: Apollo.QueryHookOptions<GetAddAHeadFacetsAndResultsQuery, GetAddAHeadFacetsAndResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddAHeadFacetsAndResultsQuery, GetAddAHeadFacetsAndResultsQueryVariables>(GetAddAHeadFacetsAndResultsDocument, options);
      }
export function useGetAddAHeadFacetsAndResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddAHeadFacetsAndResultsQuery, GetAddAHeadFacetsAndResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddAHeadFacetsAndResultsQuery, GetAddAHeadFacetsAndResultsQueryVariables>(GetAddAHeadFacetsAndResultsDocument, options);
        }
export type GetAddAHeadFacetsAndResultsQueryHookResult = ReturnType<typeof useGetAddAHeadFacetsAndResultsQuery>;
export type GetAddAHeadFacetsAndResultsLazyQueryHookResult = ReturnType<typeof useGetAddAHeadFacetsAndResultsLazyQuery>;
export type GetAddAHeadFacetsAndResultsQueryResult = Apollo.QueryResult<GetAddAHeadFacetsAndResultsQuery, GetAddAHeadFacetsAndResultsQueryVariables>;
export const GetDataExportFeedsDocument = gql`
    query GetDataExportFeeds {
  getDataExportFeeds @rest(endpoint: "stullercom", path: "myaccount/ecommerceselfservice/exportfeeds", type: "ProductDataFeedResults") {
    SavedExports {
      Id
      Name
      Description
      Properties
      ProductRequest
      LoginId
      CreationDate
      Process
      ProcessComplete
      ProcessCount
      FileName
    }
  }
}
    `;

/**
 * __useGetDataExportFeedsQuery__
 *
 * To run a query within a React component, call `useGetDataExportFeedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataExportFeedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataExportFeedsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDataExportFeedsQuery(baseOptions?: Apollo.QueryHookOptions<GetDataExportFeedsQuery, GetDataExportFeedsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataExportFeedsQuery, GetDataExportFeedsQueryVariables>(GetDataExportFeedsDocument, options);
      }
export function useGetDataExportFeedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataExportFeedsQuery, GetDataExportFeedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataExportFeedsQuery, GetDataExportFeedsQueryVariables>(GetDataExportFeedsDocument, options);
        }
export type GetDataExportFeedsQueryHookResult = ReturnType<typeof useGetDataExportFeedsQuery>;
export type GetDataExportFeedsLazyQueryHookResult = ReturnType<typeof useGetDataExportFeedsLazyQuery>;
export type GetDataExportFeedsQueryResult = Apollo.QueryResult<GetDataExportFeedsQuery, GetDataExportFeedsQueryVariables>;
export const SaveSkuDocument = gql`
    mutation SaveSku($input: SaveSkuParams) {
  saveSku(input: $input) @rest(endpoint: "stullercom", method: "POST", path: "myaccount/ecommerceselfservice/savesku", type: "SaveDataFeedResponse") {
    success
    message
  }
}
    `;
export type SaveSkuMutationFn = Apollo.MutationFunction<SaveSkuMutation, SaveSkuMutationVariables>;

/**
 * __useSaveSkuMutation__
 *
 * To run a mutation, you first call `useSaveSkuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSkuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSkuMutation, { data, loading, error }] = useSaveSkuMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSkuMutation(baseOptions?: Apollo.MutationHookOptions<SaveSkuMutation, SaveSkuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSkuMutation, SaveSkuMutationVariables>(SaveSkuDocument, options);
      }
export type SaveSkuMutationHookResult = ReturnType<typeof useSaveSkuMutation>;
export type SaveSkuMutationResult = Apollo.MutationResult<SaveSkuMutation>;
export type SaveSkuMutationOptions = Apollo.BaseMutationOptions<SaveSkuMutation, SaveSkuMutationVariables>;
export const SaveSeriesDocument = gql`
    mutation SaveSeries($input: SaveSeriesParams) {
  saveSeries(input: $input) @rest(endpoint: "stullercom", method: "POST", path: "myaccount/ecommerceselfservice/saveseries", type: "SaveDataFeedResponse") {
    success
    message
  }
}
    `;
export type SaveSeriesMutationFn = Apollo.MutationFunction<SaveSeriesMutation, SaveSeriesMutationVariables>;

/**
 * __useSaveSeriesMutation__
 *
 * To run a mutation, you first call `useSaveSeriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSeriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSeriesMutation, { data, loading, error }] = useSaveSeriesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSeriesMutation(baseOptions?: Apollo.MutationHookOptions<SaveSeriesMutation, SaveSeriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSeriesMutation, SaveSeriesMutationVariables>(SaveSeriesDocument, options);
      }
export type SaveSeriesMutationHookResult = ReturnType<typeof useSaveSeriesMutation>;
export type SaveSeriesMutationResult = Apollo.MutationResult<SaveSeriesMutation>;
export type SaveSeriesMutationOptions = Apollo.BaseMutationOptions<SaveSeriesMutation, SaveSeriesMutationVariables>;
export const CreateProductDataFeedDocument = gql`
    mutation CreateProductDataFeed($input: CreateDataFeedParams) {
  createProductDataFeed(input: $input) @rest(endpoint: "stullercom", method: "POST", path: "myaccount/ecommerceselfservice/CreateProductDataFeed", type: "saveDataFeedResponse") {
    success
    message
  }
}
    `;
export type CreateProductDataFeedMutationFn = Apollo.MutationFunction<CreateProductDataFeedMutation, CreateProductDataFeedMutationVariables>;

/**
 * __useCreateProductDataFeedMutation__
 *
 * To run a mutation, you first call `useCreateProductDataFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductDataFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductDataFeedMutation, { data, loading, error }] = useCreateProductDataFeedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductDataFeedMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductDataFeedMutation, CreateProductDataFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductDataFeedMutation, CreateProductDataFeedMutationVariables>(CreateProductDataFeedDocument, options);
      }
export type CreateProductDataFeedMutationHookResult = ReturnType<typeof useCreateProductDataFeedMutation>;
export type CreateProductDataFeedMutationResult = Apollo.MutationResult<CreateProductDataFeedMutation>;
export type CreateProductDataFeedMutationOptions = Apollo.BaseMutationOptions<CreateProductDataFeedMutation, CreateProductDataFeedMutationVariables>;
export const GetContactsFromShipToAccountDocument = gql`
    query GetContactsFromShipToAccount($params: GetContactsFromShipToAccountParams!) {
  getContactsFromShipToAccount(params: $params) @rest(endpoint: "stullercom", path: "cadcamservices/GetContactsFromShipToAccount?{args.params}", type: "[ContactViewModel!]!") {
    AllowDuplicate
    DuplicateEmail
    IsEmailAddressRequired
    ColumnCount
    IsMinimal
    OptIn302SMSNotifications
    OptInEverAndEverSMSNotifications
    UseTextInputForEmailAddresses
    IsCheckoutDefault
    IsAssignedToUser
    BadEmailAddress
    IsSingleContactForCurrentUser
    CadCamAcceptAllModFees
    CadCamHasLogoOnFile
    Unsubscribed
    IsBadEmail
    RenderMinimalWithMobilePhoneUpdate
    ShowPreferredMethodOfContact
    Id
    Salutation
    FirstName
    LastName
    PreferredName
    FullName
    ModificationDate
    CreationDate
    ContactIsDeletable
    Suffix
    Active
    JobTitle
    EmailAddress
    DirectPhoneNumber
    MobilePhoneNumber
    BusinessPhoneNumber
    PreferredMethodOfContact
    OraclePartyId
  }
}
    `;

/**
 * __useGetContactsFromShipToAccountQuery__
 *
 * To run a query within a React component, call `useGetContactsFromShipToAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsFromShipToAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsFromShipToAccountQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetContactsFromShipToAccountQuery(baseOptions: Apollo.QueryHookOptions<GetContactsFromShipToAccountQuery, GetContactsFromShipToAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactsFromShipToAccountQuery, GetContactsFromShipToAccountQueryVariables>(GetContactsFromShipToAccountDocument, options);
      }
export function useGetContactsFromShipToAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactsFromShipToAccountQuery, GetContactsFromShipToAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactsFromShipToAccountQuery, GetContactsFromShipToAccountQueryVariables>(GetContactsFromShipToAccountDocument, options);
        }
export type GetContactsFromShipToAccountQueryHookResult = ReturnType<typeof useGetContactsFromShipToAccountQuery>;
export type GetContactsFromShipToAccountLazyQueryHookResult = ReturnType<typeof useGetContactsFromShipToAccountLazyQuery>;
export type GetContactsFromShipToAccountQueryResult = Apollo.QueryResult<GetContactsFromShipToAccountQuery, GetContactsFromShipToAccountQueryVariables>;
export const GetProductDocument = gql`
    query GetProduct($params: GetProductParams!) {
  getProduct(params: $params) @rest(endpoint: "stullercom", path: "cadcamservices/GetProduct?{args.params}", type: "GetProductResponse") {
    isModifiable
    isRing
    cannotModifyStyleReason
    customerSpecificSku
    product {
      ItemNumber
      Title
      DefaultCDNImagePath
      ProductUrl
    }
  }
}
    `;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const GetValidatedCadCamRequestSummaryDocument = gql`
    query GetValidatedCadCamRequestSummary($id: Int!) {
  getValidatedCadCamRequestSummary(id: $id) @rest(endpoint: "stullercom", path: "cadcamservices/validatecadcamid/{args.id}", type: "GetCadCamIdMatchingBandResponse") {
    Success
    ImageUrl
    CustomerReference
    MetalQuality
  }
}
    `;

/**
 * __useGetValidatedCadCamRequestSummaryQuery__
 *
 * To run a query within a React component, call `useGetValidatedCadCamRequestSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValidatedCadCamRequestSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValidatedCadCamRequestSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetValidatedCadCamRequestSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetValidatedCadCamRequestSummaryQuery, GetValidatedCadCamRequestSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValidatedCadCamRequestSummaryQuery, GetValidatedCadCamRequestSummaryQueryVariables>(GetValidatedCadCamRequestSummaryDocument, options);
      }
export function useGetValidatedCadCamRequestSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValidatedCadCamRequestSummaryQuery, GetValidatedCadCamRequestSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValidatedCadCamRequestSummaryQuery, GetValidatedCadCamRequestSummaryQueryVariables>(GetValidatedCadCamRequestSummaryDocument, options);
        }
export type GetValidatedCadCamRequestSummaryQueryHookResult = ReturnType<typeof useGetValidatedCadCamRequestSummaryQuery>;
export type GetValidatedCadCamRequestSummaryLazyQueryHookResult = ReturnType<typeof useGetValidatedCadCamRequestSummaryLazyQuery>;
export type GetValidatedCadCamRequestSummaryQueryResult = Apollo.QueryResult<GetValidatedCadCamRequestSummaryQuery, GetValidatedCadCamRequestSummaryQueryVariables>;
export const ValidateReturnShippingAddressDocument = gql`
    mutation ValidateReturnShippingAddress($params: ValidateReturnShippingAddressParams!) {
  validateReturnShippingAddress(params: $params) @rest(endpoint: "stullercom", method: "POST", path: "cadcamservices/validatereturnshippingaddressforcadcamrequest", type: "ValidateReturnShippingAddressResponse", bodyKey: "params") {
    success
    shipFromErrorFound
    suggestedAddress {
      Street1
      Street2
      Street3
      City
      State
      Zip
      CountyName
      PlusFour
    }
  }
}
    `;
export type ValidateReturnShippingAddressMutationFn = Apollo.MutationFunction<ValidateReturnShippingAddressMutation, ValidateReturnShippingAddressMutationVariables>;

/**
 * __useValidateReturnShippingAddressMutation__
 *
 * To run a mutation, you first call `useValidateReturnShippingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateReturnShippingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateReturnShippingAddressMutation, { data, loading, error }] = useValidateReturnShippingAddressMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useValidateReturnShippingAddressMutation(baseOptions?: Apollo.MutationHookOptions<ValidateReturnShippingAddressMutation, ValidateReturnShippingAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateReturnShippingAddressMutation, ValidateReturnShippingAddressMutationVariables>(ValidateReturnShippingAddressDocument, options);
      }
export type ValidateReturnShippingAddressMutationHookResult = ReturnType<typeof useValidateReturnShippingAddressMutation>;
export type ValidateReturnShippingAddressMutationResult = Apollo.MutationResult<ValidateReturnShippingAddressMutation>;
export type ValidateReturnShippingAddressMutationOptions = Apollo.BaseMutationOptions<ValidateReturnShippingAddressMutation, ValidateReturnShippingAddressMutationVariables>;
export const StullerPayAddToCartDocument = gql`
    mutation StullerPayAddToCart($input: StullerPayAddToCartParams!) {
  stullerPayAddToCart(input: $input) @rest(endpoint: "stullercom", method: "POST", path: "cart/stullerpay", type: "StullerPayResponse") {
    SessionId
    Errors
  }
}
    `;
export type StullerPayAddToCartMutationFn = Apollo.MutationFunction<StullerPayAddToCartMutation, StullerPayAddToCartMutationVariables>;

/**
 * __useStullerPayAddToCartMutation__
 *
 * To run a mutation, you first call `useStullerPayAddToCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStullerPayAddToCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stullerPayAddToCartMutation, { data, loading, error }] = useStullerPayAddToCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStullerPayAddToCartMutation(baseOptions?: Apollo.MutationHookOptions<StullerPayAddToCartMutation, StullerPayAddToCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StullerPayAddToCartMutation, StullerPayAddToCartMutationVariables>(StullerPayAddToCartDocument, options);
      }
export type StullerPayAddToCartMutationHookResult = ReturnType<typeof useStullerPayAddToCartMutation>;
export type StullerPayAddToCartMutationResult = Apollo.MutationResult<StullerPayAddToCartMutation>;
export type StullerPayAddToCartMutationOptions = Apollo.BaseMutationOptions<StullerPayAddToCartMutation, StullerPayAddToCartMutationVariables>;
export const GetCmsContentByIdDocument = gql`
    query GetCmsContentById($contentContainerId: Int!, $params: JSON = {}) {
  cmsContent(contentContainerId: $contentContainerId, params: $params) @rest(endpoint: "stullercom", path: "cms/public/section/?id={args.contentContainerId}&{args.params}", type: "String")
}
    `;

/**
 * __useGetCmsContentByIdQuery__
 *
 * To run a query within a React component, call `useGetCmsContentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmsContentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmsContentByIdQuery({
 *   variables: {
 *      contentContainerId: // value for 'contentContainerId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetCmsContentByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCmsContentByIdQuery, GetCmsContentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCmsContentByIdQuery, GetCmsContentByIdQueryVariables>(GetCmsContentByIdDocument, options);
      }
export function useGetCmsContentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCmsContentByIdQuery, GetCmsContentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCmsContentByIdQuery, GetCmsContentByIdQueryVariables>(GetCmsContentByIdDocument, options);
        }
export type GetCmsContentByIdQueryHookResult = ReturnType<typeof useGetCmsContentByIdQuery>;
export type GetCmsContentByIdLazyQueryHookResult = ReturnType<typeof useGetCmsContentByIdLazyQuery>;
export type GetCmsContentByIdQueryResult = Apollo.QueryResult<GetCmsContentByIdQuery, GetCmsContentByIdQueryVariables>;
export const GetCmsContentByNameDocument = gql`
    query GetCmsContentByName($contentContainerName: String!, $params: JSON = {}) {
  cmsContent(contentContainerName: $contentContainerName, params: $params) @rest(endpoint: "stullercom", path: "cms/public/section/?name={args.contentContainerName}&{args.params}", type: "String")
}
    `;

/**
 * __useGetCmsContentByNameQuery__
 *
 * To run a query within a React component, call `useGetCmsContentByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmsContentByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmsContentByNameQuery({
 *   variables: {
 *      contentContainerName: // value for 'contentContainerName'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetCmsContentByNameQuery(baseOptions: Apollo.QueryHookOptions<GetCmsContentByNameQuery, GetCmsContentByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCmsContentByNameQuery, GetCmsContentByNameQueryVariables>(GetCmsContentByNameDocument, options);
      }
export function useGetCmsContentByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCmsContentByNameQuery, GetCmsContentByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCmsContentByNameQuery, GetCmsContentByNameQueryVariables>(GetCmsContentByNameDocument, options);
        }
export type GetCmsContentByNameQueryHookResult = ReturnType<typeof useGetCmsContentByNameQuery>;
export type GetCmsContentByNameLazyQueryHookResult = ReturnType<typeof useGetCmsContentByNameLazyQuery>;
export type GetCmsContentByNameQueryResult = Apollo.QueryResult<GetCmsContentByNameQuery, GetCmsContentByNameQueryVariables>;
export const GetCmsNavContentContainerIdDocument = gql`
    query GetCmsNavContentContainerId($input: CmsNavContentContainerIdInput!) {
  cmsNavContentContainerId(input: $input) @rest(endpoint: "stullercom", method: "POST", path: "homes/getcontentcontaineridbynavcategoryjson", type: "Int")
}
    `;

/**
 * __useGetCmsNavContentContainerIdQuery__
 *
 * To run a query within a React component, call `useGetCmsNavContentContainerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCmsNavContentContainerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCmsNavContentContainerIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCmsNavContentContainerIdQuery(baseOptions: Apollo.QueryHookOptions<GetCmsNavContentContainerIdQuery, GetCmsNavContentContainerIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCmsNavContentContainerIdQuery, GetCmsNavContentContainerIdQueryVariables>(GetCmsNavContentContainerIdDocument, options);
      }
export function useGetCmsNavContentContainerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCmsNavContentContainerIdQuery, GetCmsNavContentContainerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCmsNavContentContainerIdQuery, GetCmsNavContentContainerIdQueryVariables>(GetCmsNavContentContainerIdDocument, options);
        }
export type GetCmsNavContentContainerIdQueryHookResult = ReturnType<typeof useGetCmsNavContentContainerIdQuery>;
export type GetCmsNavContentContainerIdLazyQueryHookResult = ReturnType<typeof useGetCmsNavContentContainerIdLazyQuery>;
export type GetCmsNavContentContainerIdQueryResult = Apollo.QueryResult<GetCmsNavContentContainerIdQuery, GetCmsNavContentContainerIdQueryVariables>;
export const GetConfigItemSummaryDocument = gql`
    query GetConfigItemSummary($params: GetConfigItemSummaryParams!) {
  getConfigItemSummary(params: $params) @rest(endpoint: "stullercom", path: "products/getconfigureditemsummary?{args.params}", type: "ConfigResponse") {
    configDetails {
      Title
      Description
      TemplateName
      TemplateData
    }
  }
}
    `;

/**
 * __useGetConfigItemSummaryQuery__
 *
 * To run a query within a React component, call `useGetConfigItemSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigItemSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigItemSummaryQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetConfigItemSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetConfigItemSummaryQuery, GetConfigItemSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfigItemSummaryQuery, GetConfigItemSummaryQueryVariables>(GetConfigItemSummaryDocument, options);
      }
export function useGetConfigItemSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfigItemSummaryQuery, GetConfigItemSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfigItemSummaryQuery, GetConfigItemSummaryQueryVariables>(GetConfigItemSummaryDocument, options);
        }
export type GetConfigItemSummaryQueryHookResult = ReturnType<typeof useGetConfigItemSummaryQuery>;
export type GetConfigItemSummaryLazyQueryHookResult = ReturnType<typeof useGetConfigItemSummaryLazyQuery>;
export type GetConfigItemSummaryQueryResult = Apollo.QueryResult<GetConfigItemSummaryQuery, GetConfigItemSummaryQueryVariables>;
export const GetHasMissingLogoOnConfigDocument = gql`
    query GetHasMissingLogoOnConfig($params: GetConfigItemSummaryParams!) {
  getHasMissingLogoOnConfig(params: $params) @rest(endpoint: "stullercom", path: "products/gethasmissinglogoonconfig?{args.params}", type: "LogoResponse") {
    hasMissingLogo
  }
}
    `;

/**
 * __useGetHasMissingLogoOnConfigQuery__
 *
 * To run a query within a React component, call `useGetHasMissingLogoOnConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHasMissingLogoOnConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHasMissingLogoOnConfigQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetHasMissingLogoOnConfigQuery(baseOptions: Apollo.QueryHookOptions<GetHasMissingLogoOnConfigQuery, GetHasMissingLogoOnConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHasMissingLogoOnConfigQuery, GetHasMissingLogoOnConfigQueryVariables>(GetHasMissingLogoOnConfigDocument, options);
      }
export function useGetHasMissingLogoOnConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHasMissingLogoOnConfigQuery, GetHasMissingLogoOnConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHasMissingLogoOnConfigQuery, GetHasMissingLogoOnConfigQueryVariables>(GetHasMissingLogoOnConfigDocument, options);
        }
export type GetHasMissingLogoOnConfigQueryHookResult = ReturnType<typeof useGetHasMissingLogoOnConfigQuery>;
export type GetHasMissingLogoOnConfigLazyQueryHookResult = ReturnType<typeof useGetHasMissingLogoOnConfigLazyQuery>;
export type GetHasMissingLogoOnConfigQueryResult = Apollo.QueryResult<GetHasMissingLogoOnConfigQuery, GetHasMissingLogoOnConfigQueryVariables>;
export const GetContextMinimalDocument = gql`
    query GetContextMinimal {
  context @rest(endpoint: "stullercom", path: "homes/getjsoncontext", type: "Context") {
    AccountCountry
    AccountCurrencyCode
    ActionName
    AllowIframeHostApi
    AllowIframeHostApiDomainsCsvList
    AllowUniqueRequests
    CanCheckout
    CanManageRevenueCycle
    CanPromoteShowcase
    CanPromoteStullerFirst
    IsEligibleForStullerFirst
    CartCount
    ControllerName
    Currency {
      Currency
      Symbol
      SymbolIsPrefix
      DecimalSeparator
      DecimalDigits
      GroupSeparator
    }
    CurrentCultureName
    DefaultShipToAccountNumber
    DefaultShipToAddress {
      AddressLine1
      AddressLine2
      City
      State
      Zip
      Province
      Country
      IsResidential
    }
    HasJewelerShowcase
    HasScheduledOrder
    HideAddToCart
    HideBreadcrumbs
    HideCartLinkInHeader
    HidePrices
    HideShipDatesAndItemStatuses
    IsArtisanAccount
    IsDev
    IsEcommMerchandisingMode
    IsEmployee
    IsFoundryAndShowcase
    IsGroupCodeViewer
    IsInCmsMode
    IsInConsultantMode
    IsInJewelerShowcase
    IsInMetalsClub
    IsInShowcase
    IsInStullerFirst
    IsInStullerFirstTrial
    IsJaredStudioLogin
    IsOrderApprovalByPassCheckout
    IsOrderApprover
    IsRJOAccount
    IsRJOMasterAccount
    IsSalesPerformanceViewer
    IsSterling
    IsToolsOnly
    LoginId
    MadeByStullerViewer
    PunchOutTheme
    RecaptchaSiteKey
    RequiresPanPad
    ScheduledOrderCutoffTime
    SearchEngine
    SessionId
    ShouldShowShipDateImmediately
    ShowcaseCanShowSendAQuote
    ShowcaseEmailAddress
    ShowcasePhoneNumber
    ShowcaseTitle
    ShowDGLauncher
    ShowEstimatedShipDatesOverride
    ShowPricePerCt
    ShowShowcaseSalePrice
    StullerFirstPromotionalShippingCost
    StullerFirstPromotionalShippingMethod
    TurnToKey
    UseClientACHTokenization
    UserFirstName
    UserIsAssignedContact
    UserMemberId
    UserNeedsToAgreeToTermsForReview
  }
  darkMode @client
}
    `;

/**
 * __useGetContextMinimalQuery__
 *
 * To run a query within a React component, call `useGetContextMinimalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContextMinimalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContextMinimalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContextMinimalQuery(baseOptions?: Apollo.QueryHookOptions<GetContextMinimalQuery, GetContextMinimalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContextMinimalQuery, GetContextMinimalQueryVariables>(GetContextMinimalDocument, options);
      }
export function useGetContextMinimalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContextMinimalQuery, GetContextMinimalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContextMinimalQuery, GetContextMinimalQueryVariables>(GetContextMinimalDocument, options);
        }
export type GetContextMinimalQueryHookResult = ReturnType<typeof useGetContextMinimalQuery>;
export type GetContextMinimalLazyQueryHookResult = ReturnType<typeof useGetContextMinimalLazyQuery>;
export type GetContextMinimalQueryResult = Apollo.QueryResult<GetContextMinimalQuery, GetContextMinimalQueryVariables>;
export const GetDiscountedProductsDocument = gql`
    query GetDiscountedProducts($groupuid: Int!, $searchsource: String) {
  getDiscountedProducts(groupuid: $groupuid, searchsource: $searchsource) @rest(endpoint: "stullercom", path: "deals/discountedproductsingroup?groupid={args.groupuid}&searchSource={args.searchsource}", type: "ProductResultResponse!") {
    results {
      Id
      Description
      DisplayPrice
      OriginalPrice
      MinDiscount
      MaxDiscount
      IsDiscounted
      IsExcessBadge
      IsAlmostGoneBadge
      IsOutOfStockBadge
      ImageUrls @type(name: "ImageUrlsDto") {
        ...ImageUrlsResponse
      }
    }
  }
}
    ${ImageUrlsResponseFragmentDoc}`;

/**
 * __useGetDiscountedProductsQuery__
 *
 * To run a query within a React component, call `useGetDiscountedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountedProductsQuery({
 *   variables: {
 *      groupuid: // value for 'groupuid'
 *      searchsource: // value for 'searchsource'
 *   },
 * });
 */
export function useGetDiscountedProductsQuery(baseOptions: Apollo.QueryHookOptions<GetDiscountedProductsQuery, GetDiscountedProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountedProductsQuery, GetDiscountedProductsQueryVariables>(GetDiscountedProductsDocument, options);
      }
export function useGetDiscountedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountedProductsQuery, GetDiscountedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountedProductsQuery, GetDiscountedProductsQueryVariables>(GetDiscountedProductsDocument, options);
        }
export type GetDiscountedProductsQueryHookResult = ReturnType<typeof useGetDiscountedProductsQuery>;
export type GetDiscountedProductsLazyQueryHookResult = ReturnType<typeof useGetDiscountedProductsLazyQuery>;
export type GetDiscountedProductsQueryResult = Apollo.QueryResult<GetDiscountedProductsQuery, GetDiscountedProductsQueryVariables>;
export const GetFavoritesListDocument = gql`
    query GetFavoritesList {
  addToFavoritesOptions @rest(endpoint: "stullercom", path: "favorite/addtofavoritesoptions", type: "FavoritesOptions") {
    DefaultList
    Lists {
      name
      value
    }
  }
}
    `;

/**
 * __useGetFavoritesListQuery__
 *
 * To run a query within a React component, call `useGetFavoritesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoritesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoritesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFavoritesListQuery(baseOptions?: Apollo.QueryHookOptions<GetFavoritesListQuery, GetFavoritesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavoritesListQuery, GetFavoritesListQueryVariables>(GetFavoritesListDocument, options);
      }
export function useGetFavoritesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavoritesListQuery, GetFavoritesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavoritesListQuery, GetFavoritesListQueryVariables>(GetFavoritesListDocument, options);
        }
export type GetFavoritesListQueryHookResult = ReturnType<typeof useGetFavoritesListQuery>;
export type GetFavoritesListLazyQueryHookResult = ReturnType<typeof useGetFavoritesListLazyQuery>;
export type GetFavoritesListQueryResult = Apollo.QueryResult<GetFavoritesListQuery, GetFavoritesListQueryVariables>;
export const AddToFavoritesDocument = gql`
    mutation AddToFavorites($params: AddToFavoritesParams!) {
  addToFavorites(params: $params) @rest(endpoint: "stullercom", path: "favorite/addtofavorites?{args.params}", type: "AddToFavorites") {
    success
    favoriteListName
    favoriteListId
    nameAlreadyExists
  }
}
    `;
export type AddToFavoritesMutationFn = Apollo.MutationFunction<AddToFavoritesMutation, AddToFavoritesMutationVariables>;

/**
 * __useAddToFavoritesMutation__
 *
 * To run a mutation, you first call `useAddToFavoritesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToFavoritesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToFavoritesMutation, { data, loading, error }] = useAddToFavoritesMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAddToFavoritesMutation(baseOptions?: Apollo.MutationHookOptions<AddToFavoritesMutation, AddToFavoritesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToFavoritesMutation, AddToFavoritesMutationVariables>(AddToFavoritesDocument, options);
      }
export type AddToFavoritesMutationHookResult = ReturnType<typeof useAddToFavoritesMutation>;
export type AddToFavoritesMutationResult = Apollo.MutationResult<AddToFavoritesMutation>;
export type AddToFavoritesMutationOptions = Apollo.BaseMutationOptions<AddToFavoritesMutation, AddToFavoritesMutationVariables>;
export const GetRequestAQuoteViewModelDocument = gql`
    query GetRequestAQuoteViewModel {
  getRequestAQuoteViewModel @rest(endpoint: "stullercom", path: "cart/GetRequestAQuoteViewModelJson", type: "RequestAQuoteViewModel") {
    CompanyName
    FirstName
    LastName
    Email
    ConfirmationEmail
    PhoneNumber
    MessageToJeweler
  }
}
    `;

/**
 * __useGetRequestAQuoteViewModelQuery__
 *
 * To run a query within a React component, call `useGetRequestAQuoteViewModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestAQuoteViewModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestAQuoteViewModelQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequestAQuoteViewModelQuery(baseOptions?: Apollo.QueryHookOptions<GetRequestAQuoteViewModelQuery, GetRequestAQuoteViewModelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestAQuoteViewModelQuery, GetRequestAQuoteViewModelQueryVariables>(GetRequestAQuoteViewModelDocument, options);
      }
export function useGetRequestAQuoteViewModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestAQuoteViewModelQuery, GetRequestAQuoteViewModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestAQuoteViewModelQuery, GetRequestAQuoteViewModelQueryVariables>(GetRequestAQuoteViewModelDocument, options);
        }
export type GetRequestAQuoteViewModelQueryHookResult = ReturnType<typeof useGetRequestAQuoteViewModelQuery>;
export type GetRequestAQuoteViewModelLazyQueryHookResult = ReturnType<typeof useGetRequestAQuoteViewModelLazyQuery>;
export type GetRequestAQuoteViewModelQueryResult = Apollo.QueryResult<GetRequestAQuoteViewModelQuery, GetRequestAQuoteViewModelQueryVariables>;
export const SubmitRequestAQuoteDocument = gql`
    mutation SubmitRequestAQuote($input: JSON!) {
  submitRequestAQuote(input: $input) @rest(endpoint: "stullercom", method: "POST", path: "cart/RequestACallbackWithAddToCart", type: "RequestAQuoteResponse") {
    success
    messages
  }
}
    `;
export type SubmitRequestAQuoteMutationFn = Apollo.MutationFunction<SubmitRequestAQuoteMutation, SubmitRequestAQuoteMutationVariables>;

/**
 * __useSubmitRequestAQuoteMutation__
 *
 * To run a mutation, you first call `useSubmitRequestAQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRequestAQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRequestAQuoteMutation, { data, loading, error }] = useSubmitRequestAQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitRequestAQuoteMutation(baseOptions?: Apollo.MutationHookOptions<SubmitRequestAQuoteMutation, SubmitRequestAQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitRequestAQuoteMutation, SubmitRequestAQuoteMutationVariables>(SubmitRequestAQuoteDocument, options);
      }
export type SubmitRequestAQuoteMutationHookResult = ReturnType<typeof useSubmitRequestAQuoteMutation>;
export type SubmitRequestAQuoteMutationResult = Apollo.MutationResult<SubmitRequestAQuoteMutation>;
export type SubmitRequestAQuoteMutationOptions = Apollo.BaseMutationOptions<SubmitRequestAQuoteMutation, SubmitRequestAQuoteMutationVariables>;
export const GetShippingCountdownDocument = gql`
    query getShippingCountdown($input: GetShippingCountdownInput) {
  getShippingCountdown(input: $input) @rest(endpoint: "stullercom", method: "POST", path: "cart/ShippingCountdown", type: "ShippingCountdownResults") {
    showCountdown
    countdownType
    cutoff
  }
}
    `;

/**
 * __useGetShippingCountdownQuery__
 *
 * To run a query within a React component, call `useGetShippingCountdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShippingCountdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShippingCountdownQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetShippingCountdownQuery(baseOptions?: Apollo.QueryHookOptions<GetShippingCountdownQuery, GetShippingCountdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShippingCountdownQuery, GetShippingCountdownQueryVariables>(GetShippingCountdownDocument, options);
      }
export function useGetShippingCountdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShippingCountdownQuery, GetShippingCountdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShippingCountdownQuery, GetShippingCountdownQueryVariables>(GetShippingCountdownDocument, options);
        }
export type GetShippingCountdownQueryHookResult = ReturnType<typeof useGetShippingCountdownQuery>;
export type GetShippingCountdownLazyQueryHookResult = ReturnType<typeof useGetShippingCountdownLazyQuery>;
export type GetShippingCountdownQueryResult = Apollo.QueryResult<GetShippingCountdownQuery, GetShippingCountdownQueryVariables>;
export const GetLookupsByTypeDocument = gql`
    query GetLookupsByType($type: String!) {
  getLookupsByType(type: $type) @rest(endpoint: "stullercom", path: "lookups?type={args.type}", type: "[Lookup!]!") {
    ID
    Type
    Code
    Order
    Value
    Value2
    Value3
    Value4
    Value5
    Value6
    Value7
    Value8
    Value9
    Value10
  }
}
    `;

/**
 * __useGetLookupsByTypeQuery__
 *
 * To run a query within a React component, call `useGetLookupsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLookupsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLookupsByTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetLookupsByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetLookupsByTypeQuery, GetLookupsByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLookupsByTypeQuery, GetLookupsByTypeQueryVariables>(GetLookupsByTypeDocument, options);
      }
export function useGetLookupsByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLookupsByTypeQuery, GetLookupsByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLookupsByTypeQuery, GetLookupsByTypeQueryVariables>(GetLookupsByTypeDocument, options);
        }
export type GetLookupsByTypeQueryHookResult = ReturnType<typeof useGetLookupsByTypeQuery>;
export type GetLookupsByTypeLazyQueryHookResult = ReturnType<typeof useGetLookupsByTypeLazyQuery>;
export type GetLookupsByTypeQueryResult = Apollo.QueryResult<GetLookupsByTypeQuery, GetLookupsByTypeQueryVariables>;
export const GetNewAuthTokenDocument = gql`
    query GetNewAuthToken {
  getNewAuthToken @rest(endpoint: "stullercom", path: "myaccount/marketplacesolutions/authenticate", type: "String!")
}
    `;

/**
 * __useGetNewAuthTokenQuery__
 *
 * To run a query within a React component, call `useGetNewAuthTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewAuthTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewAuthTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewAuthTokenQuery(baseOptions?: Apollo.QueryHookOptions<GetNewAuthTokenQuery, GetNewAuthTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewAuthTokenQuery, GetNewAuthTokenQueryVariables>(GetNewAuthTokenDocument, options);
      }
export function useGetNewAuthTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewAuthTokenQuery, GetNewAuthTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewAuthTokenQuery, GetNewAuthTokenQueryVariables>(GetNewAuthTokenDocument, options);
        }
export type GetNewAuthTokenQueryHookResult = ReturnType<typeof useGetNewAuthTokenQuery>;
export type GetNewAuthTokenLazyQueryHookResult = ReturnType<typeof useGetNewAuthTokenLazyQuery>;
export type GetNewAuthTokenQueryResult = Apollo.QueryResult<GetNewAuthTokenQuery, GetNewAuthTokenQueryVariables>;
export const IsOracleUpDocument = gql`
    query IsOracleUp {
  isOracleUp @rest(endpoint: "stullercom", path: "orders/isoracleup", type: "Boolean!")
}
    `;

/**
 * __useIsOracleUpQuery__
 *
 * To run a query within a React component, call `useIsOracleUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsOracleUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsOracleUpQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsOracleUpQuery(baseOptions?: Apollo.QueryHookOptions<IsOracleUpQuery, IsOracleUpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsOracleUpQuery, IsOracleUpQueryVariables>(IsOracleUpDocument, options);
      }
export function useIsOracleUpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsOracleUpQuery, IsOracleUpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsOracleUpQuery, IsOracleUpQueryVariables>(IsOracleUpDocument, options);
        }
export type IsOracleUpQueryHookResult = ReturnType<typeof useIsOracleUpQuery>;
export type IsOracleUpLazyQueryHookResult = ReturnType<typeof useIsOracleUpLazyQuery>;
export type IsOracleUpQueryResult = Apollo.QueryResult<IsOracleUpQuery, IsOracleUpQueryVariables>;
export const GetOrdersDocument = gql`
    query GetOrders($params: GetOrdersParams!) {
  getOrders(params: $params) @rest(endpoint: "stullercom", path: "orders/getorders?{args.params}", type: "Orders") {
    orders {
      BillToAccountNumber
      ShipToAccountNumber
      OracleOrderNumber
      WebOrderNumber
      OrderPONumber
      OrderDate
      OrderDateString
      OrderStatus
      OrderTotal
      OrderTotalString
      OrderLines {
        ShipToAccountNumber
        ShipToAccountState
        ShipToAccountCountry
        OracleOrderNumber
        WebOrderNumber
        OracleOrderHeaderId
        OracleOrderLineId
        ItemNumber
        SerialNumber
        Image
        Description
        Url
        QuantityShipped
        UnitPrice
        ExtendedPrice
        IsConfigItem
        ConfigHeaderId
        ItemTypeCode
        IsReturnable
        IsMetal
        MetalsDetailString
        UOM
        SoldByDescription
        IsBulkChain
        IsMemo
        IsHeavy
        IsHazardous
        IsGroundShippingOnly
        UnitWeightInPounds
        IsFiltered
        pendingReturn
        ReturnQuantity
        ReturnReason
        ReturnNote
      }
      HasReturnableOrderLines
      IsExpanded
      IsApprovalOrder
      LoginId
    }
    totalRecords
    errors
  }
}
    `;

/**
 * __useGetOrdersQuery__
 *
 * To run a query within a React component, call `useGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
      }
export function useGetOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
export type GetOrdersQueryHookResult = ReturnType<typeof useGetOrdersQuery>;
export type GetOrdersLazyQueryHookResult = ReturnType<typeof useGetOrdersLazyQuery>;
export type GetOrdersQueryResult = Apollo.QueryResult<GetOrdersQuery, GetOrdersQueryVariables>;
export const GetApprovalOrderDocument = gql`
    query GetApprovalOrder($params: GetApprovalOrderParams!) {
  getApprovalOrder(params: $params) @rest(endpoint: "stullercom", path: "orders/GetApprovalOrder?{args.params}", type: "String")
}
    `;

/**
 * __useGetApprovalOrderQuery__
 *
 * To run a query within a React component, call `useGetApprovalOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalOrderQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetApprovalOrderQuery(baseOptions: Apollo.QueryHookOptions<GetApprovalOrderQuery, GetApprovalOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovalOrderQuery, GetApprovalOrderQueryVariables>(GetApprovalOrderDocument, options);
      }
export function useGetApprovalOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovalOrderQuery, GetApprovalOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovalOrderQuery, GetApprovalOrderQueryVariables>(GetApprovalOrderDocument, options);
        }
export type GetApprovalOrderQueryHookResult = ReturnType<typeof useGetApprovalOrderQuery>;
export type GetApprovalOrderLazyQueryHookResult = ReturnType<typeof useGetApprovalOrderLazyQuery>;
export type GetApprovalOrderQueryResult = Apollo.QueryResult<GetApprovalOrderQuery, GetApprovalOrderQueryVariables>;
export const GetOrderDetailsDocument = gql`
    query GetOrderDetails($params: GetOrderDetailsParams!) {
  getOrderDetails(params: $params) @rest(endpoint: "stullercom", path: "orders/getorderdetails?{args.params}", type: "Order") {
    order {
      OrderNumber
      WebOrderNumber
      DropShipNumber
      IsDropShip
      OrderStatus
      PaymentMethod
      ShippingCarrier
      ShippingMethod
      ShippingMethodDescription
      CustomerPoNumber
      OrderDate
      OrderDateToShortString
      ShippingCharge
      TaxTotal
      SubTotal
      OrderTotal
      MaskedCreditCardNumber
      LastFourOfCreditCard
      ShipToAccountNumber
      ShipToCompanyName
      ShipToOrigSysRef
      ShipToLocation
      ShipToAddress1
      ShipToAddress2
      ShipToAddress3
      ShipToAddress4
      ShipToCity
      ShipToState
      ShipToProvince
      ShipToZip
      ShipToCountry
      ShipToCounty
      ShipToTimeZone
      ShipToFormatted
      BillToAccountNumber
      BillToCompanyName
      BillToOrigSysRef
      BillToAddress1
      BillToAddress2
      BillToAddress3
      BillToAddress4
      BillToCity
      BillToState
      BillToProvince
      BillToZip
      BillToCountry
      BillToCounty
      BillToFormatted
      CurrencyCode
      IsCancelled
      IsCancellable
      IsInConsultantMode
      CanAddComments
      CreatedBy
      ExistsInWebTable
      ExportLink
      AllItemsHaveShipped
      OrderDetails {
        OrderNumber
        ItemNumber
        IsCancelled
        IsCancellable
        Image
        ItemURL
        SpecialInstructions
        SpecialServiceCode
        InventoryItemId
        CancelledQuantity
        SerialNumber
        Description
        AdditionalDescription
        ShipSetCode
        CancelledQuantity
        EstShipDate
        RevisedShipDate
        UnitSellingPrice
        PrettyStatus
        WMSStatus
        ConfigHeaderId
        ConfigOnWebNotOracle
        ValidatedWebConfigId
        WebConfigId
        CamJobID
        IsCadCam
        WebConfigIsInvalid
        CancellationReasons {
          Value
          Display
        }
        LineId
        ConfigurationIsMonogram
        IsTopModelLine
        TopModelLineId
        ConfigurationImage
        ConfigurationInventoryItemId
        ConfigurationTitle
        ConfigurationUrl
        ItemTypeCode
        ConfigurationItemNumber
        OrderedQuantity
        FulfilledQuantity
        ExtendedSellingPrice
        CanAddToCart
        CanShowConfigurationSummary
        ShowFakeConfigurationLine
        ShowActions
        IsPartOfConfiguration
        IsFirstLineOfConfiguration
        IsLastLineOfConfiguration
        ConfigurationPrice
        ConfigurationBaseProductUrl
        ProductTracking
        Report
        CertUrl
      }
      OracleInvoices {
        InvoiceNumber
        InvoiceUrl
        InvoiceDate
        InvoiceDateShortString
        TrackingNumber
        TrackingLink
        InvoiceTotalString
        CodTotalAmt
        CodTotalAmtString
        ShippingCarrier
        ShippingCarrierTrackingSupported
        IsPickUp
        ShipmentTracking {
          Success
          TrackingNumber
          Status
          EstDeliveryDate
          DeliveryDate
          Delivered
          PickedUpByCarrier
          SignedForBy
          ShipmentMethod
          FromCity
          FromState
          ToCity
          ToState
          TransitDetails {
            TimeStamp
            Description
            City
            State
            Location
          }
          Message
        }
        ReadyForPickUpDate
        PickedUpDate
        SalesTax
        InvoiceTotal
      }
      OracleAttachments {
        Text
        CategoryText
      }
    }
  }
}
    `;

/**
 * __useGetOrderDetailsQuery__
 *
 * To run a query within a React component, call `useGetOrderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderDetailsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetOrderDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetOrderDetailsQuery, GetOrderDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderDetailsQuery, GetOrderDetailsQueryVariables>(GetOrderDetailsDocument, options);
      }
export function useGetOrderDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderDetailsQuery, GetOrderDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderDetailsQuery, GetOrderDetailsQueryVariables>(GetOrderDetailsDocument, options);
        }
export type GetOrderDetailsQueryHookResult = ReturnType<typeof useGetOrderDetailsQuery>;
export type GetOrderDetailsLazyQueryHookResult = ReturnType<typeof useGetOrderDetailsLazyQuery>;
export type GetOrderDetailsQueryResult = Apollo.QueryResult<GetOrderDetailsQuery, GetOrderDetailsQueryVariables>;
export const GetContainsCustomsDocumentsDocument = gql`
    query GetContainsCustomsDocuments($params: GetCustomsDocumentsParams!) {
  getContainsCustomsDocuments(params: $params) @rest(endpoint: "stullercom", path: "orders/invoicecontainscustomsdocuments?{args.params}", type: "GetContainsCustomsDocumentsResponse") {
    containsCustomsDocuments
  }
}
    `;

/**
 * __useGetContainsCustomsDocumentsQuery__
 *
 * To run a query within a React component, call `useGetContainsCustomsDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContainsCustomsDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContainsCustomsDocumentsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetContainsCustomsDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetContainsCustomsDocumentsQuery, GetContainsCustomsDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContainsCustomsDocumentsQuery, GetContainsCustomsDocumentsQueryVariables>(GetContainsCustomsDocumentsDocument, options);
      }
export function useGetContainsCustomsDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContainsCustomsDocumentsQuery, GetContainsCustomsDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContainsCustomsDocumentsQuery, GetContainsCustomsDocumentsQueryVariables>(GetContainsCustomsDocumentsDocument, options);
        }
export type GetContainsCustomsDocumentsQueryHookResult = ReturnType<typeof useGetContainsCustomsDocumentsQuery>;
export type GetContainsCustomsDocumentsLazyQueryHookResult = ReturnType<typeof useGetContainsCustomsDocumentsLazyQuery>;
export type GetContainsCustomsDocumentsQueryResult = Apollo.QueryResult<GetContainsCustomsDocumentsQuery, GetContainsCustomsDocumentsQueryVariables>;
export const GetCustomsDocumentsForInvoiceDocument = gql`
    query GetCustomsDocumentsForInvoice($params: GetCustomsDocumentsParams!) {
  getCustomsDocumentsForInvoice(params: $params) @rest(endpoint: "stullercom", path: "orders/downloadcustomsdocuments?{args.params}", type: "GetCustomsDocumentsForInvoiceResponse") {
    success
    fileData
    fileName
    contentType
  }
}
    `;

/**
 * __useGetCustomsDocumentsForInvoiceQuery__
 *
 * To run a query within a React component, call `useGetCustomsDocumentsForInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomsDocumentsForInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomsDocumentsForInvoiceQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetCustomsDocumentsForInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetCustomsDocumentsForInvoiceQuery, GetCustomsDocumentsForInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomsDocumentsForInvoiceQuery, GetCustomsDocumentsForInvoiceQueryVariables>(GetCustomsDocumentsForInvoiceDocument, options);
      }
export function useGetCustomsDocumentsForInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomsDocumentsForInvoiceQuery, GetCustomsDocumentsForInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomsDocumentsForInvoiceQuery, GetCustomsDocumentsForInvoiceQueryVariables>(GetCustomsDocumentsForInvoiceDocument, options);
        }
export type GetCustomsDocumentsForInvoiceQueryHookResult = ReturnType<typeof useGetCustomsDocumentsForInvoiceQuery>;
export type GetCustomsDocumentsForInvoiceLazyQueryHookResult = ReturnType<typeof useGetCustomsDocumentsForInvoiceLazyQuery>;
export type GetCustomsDocumentsForInvoiceQueryResult = Apollo.QueryResult<GetCustomsDocumentsForInvoiceQuery, GetCustomsDocumentsForInvoiceQueryVariables>;
export const AddOrderCommentsDocument = gql`
    mutation AddOrderComments($params: AddOrderCommentsParams!) {
  addOrderComments(params: $params) @rest(endpoint: "stullercom", path: "orders/addordercomments?{args.params}", type: "AddComment") {
    success
  }
}
    `;
export type AddOrderCommentsMutationFn = Apollo.MutationFunction<AddOrderCommentsMutation, AddOrderCommentsMutationVariables>;

/**
 * __useAddOrderCommentsMutation__
 *
 * To run a mutation, you first call `useAddOrderCommentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrderCommentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrderCommentsMutation, { data, loading, error }] = useAddOrderCommentsMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAddOrderCommentsMutation(baseOptions?: Apollo.MutationHookOptions<AddOrderCommentsMutation, AddOrderCommentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrderCommentsMutation, AddOrderCommentsMutationVariables>(AddOrderCommentsDocument, options);
      }
export type AddOrderCommentsMutationHookResult = ReturnType<typeof useAddOrderCommentsMutation>;
export type AddOrderCommentsMutationResult = Apollo.MutationResult<AddOrderCommentsMutation>;
export type AddOrderCommentsMutationOptions = Apollo.BaseMutationOptions<AddOrderCommentsMutation, AddOrderCommentsMutationVariables>;
export const CancelOrderDocument = gql`
    mutation CancelOrder($params: CancelOrderParams!) {
  cancelOrder(params: $params) @rest(endpoint: "stullercom", path: "orders/cancelorder?{args.params}", type: "CancelOrder")
}
    `;
export type CancelOrderMutationFn = Apollo.MutationFunction<CancelOrderMutation, CancelOrderMutationVariables>;

/**
 * __useCancelOrderMutation__
 *
 * To run a mutation, you first call `useCancelOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOrderMutation, { data, loading, error }] = useCancelOrderMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCancelOrderMutation(baseOptions?: Apollo.MutationHookOptions<CancelOrderMutation, CancelOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelOrderMutation, CancelOrderMutationVariables>(CancelOrderDocument, options);
      }
export type CancelOrderMutationHookResult = ReturnType<typeof useCancelOrderMutation>;
export type CancelOrderMutationResult = Apollo.MutationResult<CancelOrderMutation>;
export type CancelOrderMutationOptions = Apollo.BaseMutationOptions<CancelOrderMutation, CancelOrderMutationVariables>;
export const CancelLineDocument = gql`
    mutation CancelLine($params: CancelLineParams!) {
  cancelLine(params: $params) @rest(endpoint: "stullercom", path: "orders/cancelline?{args.params}", type: "CancelLine")
}
    `;
export type CancelLineMutationFn = Apollo.MutationFunction<CancelLineMutation, CancelLineMutationVariables>;

/**
 * __useCancelLineMutation__
 *
 * To run a mutation, you first call `useCancelLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelLineMutation, { data, loading, error }] = useCancelLineMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCancelLineMutation(baseOptions?: Apollo.MutationHookOptions<CancelLineMutation, CancelLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelLineMutation, CancelLineMutationVariables>(CancelLineDocument, options);
      }
export type CancelLineMutationHookResult = ReturnType<typeof useCancelLineMutation>;
export type CancelLineMutationResult = Apollo.MutationResult<CancelLineMutation>;
export type CancelLineMutationOptions = Apollo.BaseMutationOptions<CancelLineMutation, CancelLineMutationVariables>;
export const GetPaymentMethodsAndOptionsDocument = gql`
    query GetPaymentMethodsAndOptions($overridePath: String!) {
  getPaymentMethodsAndOptions @rest(endpoint: "stullercom", path: $overridePath, type: "PaymentMethodResponse") {
    AllowedCreditCardTypes {
      Id
      Description
      CssClassName
    }
    PaymentMethods {
      Method
      DisplayName
      UniqueKey
      IsSelected
      CreditCard {
        Id
        CardType
        CardNumber
        CardHolderName
        ExpirationMonth
        ExpirationYear
        Zip
        Cvv
        IsExpired
        IsDebit
        InstrumentId
        DataSource
      }
      BankAccount {
        Id
        BankName
        AccountNumber
        AccountNumberConfirmation
        RoutingNumber
        Tokenized
      }
      OnlyShowInConsultantMode
      SelectableValue
    }
    AllowedMethods
    AllowedMethodsForConsultantOnly
    UserCanUseTerms
    UserCanUseCOD
    UserCanUseCreditCards
    UserCanUseDebitCards
    UserCanUseACH
    NoneSelected
    IsLoggedIn
  }
}
    `;

/**
 * __useGetPaymentMethodsAndOptionsQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsAndOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsAndOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsAndOptionsQuery({
 *   variables: {
 *      overridePath: // value for 'overridePath'
 *   },
 * });
 */
export function useGetPaymentMethodsAndOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentMethodsAndOptionsQuery, GetPaymentMethodsAndOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodsAndOptionsQuery, GetPaymentMethodsAndOptionsQueryVariables>(GetPaymentMethodsAndOptionsDocument, options);
      }
export function useGetPaymentMethodsAndOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodsAndOptionsQuery, GetPaymentMethodsAndOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodsAndOptionsQuery, GetPaymentMethodsAndOptionsQueryVariables>(GetPaymentMethodsAndOptionsDocument, options);
        }
export type GetPaymentMethodsAndOptionsQueryHookResult = ReturnType<typeof useGetPaymentMethodsAndOptionsQuery>;
export type GetPaymentMethodsAndOptionsLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodsAndOptionsLazyQuery>;
export type GetPaymentMethodsAndOptionsQueryResult = Apollo.QueryResult<GetPaymentMethodsAndOptionsQuery, GetPaymentMethodsAndOptionsQueryVariables>;
export const TokenizeCardDocument = gql`
    query TokenizeCard($endpoint: String = "cardconnect", $overridePath: String!) {
  tokenizeCard @rest(endpoint: $endpoint, path: $overridePath, type: "String!")
}
    `;

/**
 * __useTokenizeCardQuery__
 *
 * To run a query within a React component, call `useTokenizeCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useTokenizeCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTokenizeCardQuery({
 *   variables: {
 *      endpoint: // value for 'endpoint'
 *      overridePath: // value for 'overridePath'
 *   },
 * });
 */
export function useTokenizeCardQuery(baseOptions: Apollo.QueryHookOptions<TokenizeCardQuery, TokenizeCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TokenizeCardQuery, TokenizeCardQueryVariables>(TokenizeCardDocument, options);
      }
export function useTokenizeCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TokenizeCardQuery, TokenizeCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TokenizeCardQuery, TokenizeCardQueryVariables>(TokenizeCardDocument, options);
        }
export type TokenizeCardQueryHookResult = ReturnType<typeof useTokenizeCardQuery>;
export type TokenizeCardLazyQueryHookResult = ReturnType<typeof useTokenizeCardLazyQuery>;
export type TokenizeCardQueryResult = Apollo.QueryResult<TokenizeCardQuery, TokenizeCardQueryVariables>;
export const StullerPayDocument = gql`
    query StullerPay($params: StullerPayParams) {
  stullerPay(params: $params) @rest(endpoint: "stullercom", path: "paymentmethods/stullerpay?{args.params}", type: "StullerPayResponse") {
    IsOracleDown
    Eligible
    TermOptions {
      Option
      Id
      TermDisplay
      TermValue
      MonthlyPrice
      Price
      FeePercentDecimal
      ShippingCost
      FeeAmount
      TotalPrice
      MinimumPrice
    }
  }
}
    `;

/**
 * __useStullerPayQuery__
 *
 * To run a query within a React component, call `useStullerPayQuery` and pass it any options that fit your needs.
 * When your component renders, `useStullerPayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStullerPayQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useStullerPayQuery(baseOptions?: Apollo.QueryHookOptions<StullerPayQuery, StullerPayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StullerPayQuery, StullerPayQueryVariables>(StullerPayDocument, options);
      }
export function useStullerPayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StullerPayQuery, StullerPayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StullerPayQuery, StullerPayQueryVariables>(StullerPayDocument, options);
        }
export type StullerPayQueryHookResult = ReturnType<typeof useStullerPayQuery>;
export type StullerPayLazyQueryHookResult = ReturnType<typeof useStullerPayLazyQuery>;
export type StullerPayQueryResult = Apollo.QueryResult<StullerPayQuery, StullerPayQueryVariables>;
export const FindAllActiveAutorenewalsByCreditCardIdDocument = gql`
    query FindAllActiveAutorenewalsByCreditCardId($params: FindAllActiveAutorenewalsByCreditCardIdParams!) {
  findAllActiveAutorenewalsByCreditCardId(params: $params) @rest(endpoint: "stullercom", path: "loyalty/FindAllActiveAutorenewalsByCreditCardId?{args.params}", type: "LoyaltyProgramDetails") {
    Renewals {
      DateForAutoRenewal
      IsStullerFirst
      Name
    }
  }
}
    `;

/**
 * __useFindAllActiveAutorenewalsByCreditCardIdQuery__
 *
 * To run a query within a React component, call `useFindAllActiveAutorenewalsByCreditCardIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllActiveAutorenewalsByCreditCardIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllActiveAutorenewalsByCreditCardIdQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useFindAllActiveAutorenewalsByCreditCardIdQuery(baseOptions: Apollo.QueryHookOptions<FindAllActiveAutorenewalsByCreditCardIdQuery, FindAllActiveAutorenewalsByCreditCardIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAllActiveAutorenewalsByCreditCardIdQuery, FindAllActiveAutorenewalsByCreditCardIdQueryVariables>(FindAllActiveAutorenewalsByCreditCardIdDocument, options);
      }
export function useFindAllActiveAutorenewalsByCreditCardIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAllActiveAutorenewalsByCreditCardIdQuery, FindAllActiveAutorenewalsByCreditCardIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAllActiveAutorenewalsByCreditCardIdQuery, FindAllActiveAutorenewalsByCreditCardIdQueryVariables>(FindAllActiveAutorenewalsByCreditCardIdDocument, options);
        }
export type FindAllActiveAutorenewalsByCreditCardIdQueryHookResult = ReturnType<typeof useFindAllActiveAutorenewalsByCreditCardIdQuery>;
export type FindAllActiveAutorenewalsByCreditCardIdLazyQueryHookResult = ReturnType<typeof useFindAllActiveAutorenewalsByCreditCardIdLazyQuery>;
export type FindAllActiveAutorenewalsByCreditCardIdQueryResult = Apollo.QueryResult<FindAllActiveAutorenewalsByCreditCardIdQuery, FindAllActiveAutorenewalsByCreditCardIdQueryVariables>;
export const SaveDefaultPaymentMethodDocument = gql`
    mutation SaveDefaultPaymentMethod($input: SaveDefaultPaymentMethodParams) {
  saveDefaultPaymentMethod(input: $input) @rest(endpoint: "stullercom", method: "POST", path: "paymentmethods/savedefaultpaymentmethod", type: "SaveDefaultPaymentMethodResponse") {
    success
    errors
  }
}
    `;
export type SaveDefaultPaymentMethodMutationFn = Apollo.MutationFunction<SaveDefaultPaymentMethodMutation, SaveDefaultPaymentMethodMutationVariables>;

/**
 * __useSaveDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSaveDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDefaultPaymentMethodMutation, { data, loading, error }] = useSaveDefaultPaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDefaultPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SaveDefaultPaymentMethodMutation, SaveDefaultPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDefaultPaymentMethodMutation, SaveDefaultPaymentMethodMutationVariables>(SaveDefaultPaymentMethodDocument, options);
      }
export type SaveDefaultPaymentMethodMutationHookResult = ReturnType<typeof useSaveDefaultPaymentMethodMutation>;
export type SaveDefaultPaymentMethodMutationResult = Apollo.MutationResult<SaveDefaultPaymentMethodMutation>;
export type SaveDefaultPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SaveDefaultPaymentMethodMutation, SaveDefaultPaymentMethodMutationVariables>;
export const DeleteCredtCardDocument = gql`
    mutation DeleteCredtCard($input: DeleteCredtCardParams) {
  deleteCreditCard(input: $input) @rest(endpoint: "stullercom", method: "POST", path: "paymentmethods/deletecreditcard", type: "DeleteCredtCardResponse") {
    success
  }
}
    `;
export type DeleteCredtCardMutationFn = Apollo.MutationFunction<DeleteCredtCardMutation, DeleteCredtCardMutationVariables>;

/**
 * __useDeleteCredtCardMutation__
 *
 * To run a mutation, you first call `useDeleteCredtCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCredtCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCredtCardMutation, { data, loading, error }] = useDeleteCredtCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCredtCardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCredtCardMutation, DeleteCredtCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCredtCardMutation, DeleteCredtCardMutationVariables>(DeleteCredtCardDocument, options);
      }
export type DeleteCredtCardMutationHookResult = ReturnType<typeof useDeleteCredtCardMutation>;
export type DeleteCredtCardMutationResult = Apollo.MutationResult<DeleteCredtCardMutation>;
export type DeleteCredtCardMutationOptions = Apollo.BaseMutationOptions<DeleteCredtCardMutation, DeleteCredtCardMutationVariables>;
export const DeleteBankAccountDocument = gql`
    mutation DeleteBankAccount($input: DeleteBankAccountParams) {
  deleteBankAccount(input: $input) @rest(endpoint: "stullercom", method: "POST", path: "paymentmethods/deletebankaccount", type: "DeleteBankAccountResponse") {
    success
  }
}
    `;
export type DeleteBankAccountMutationFn = Apollo.MutationFunction<DeleteBankAccountMutation, DeleteBankAccountMutationVariables>;

/**
 * __useDeleteBankAccountMutation__
 *
 * To run a mutation, you first call `useDeleteBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBankAccountMutation, { data, loading, error }] = useDeleteBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBankAccountMutation, DeleteBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBankAccountMutation, DeleteBankAccountMutationVariables>(DeleteBankAccountDocument, options);
      }
export type DeleteBankAccountMutationHookResult = ReturnType<typeof useDeleteBankAccountMutation>;
export type DeleteBankAccountMutationResult = Apollo.MutationResult<DeleteBankAccountMutation>;
export type DeleteBankAccountMutationOptions = Apollo.BaseMutationOptions<DeleteBankAccountMutation, DeleteBankAccountMutationVariables>;
export const SaveCardDocument = gql`
    mutation SaveCard($input: SaveCardParams) {
  saveCard(input: $input) @rest(endpoint: "stullercom", method: "POST", path: "paymentmethods/savecreditcard", type: "SaveCardResponse") {
    success
    errors
    creditCard {
      Id
      CardType
      CardNumber
      CardHolderName
      ExpirationMonth
      ExpirationYear
      ExpirationDate
      Zip
      Cvv
      IsExpired
      IsDebit
      InstrumentId
      DataSource
      Schema
    }
  }
}
    `;
export type SaveCardMutationFn = Apollo.MutationFunction<SaveCardMutation, SaveCardMutationVariables>;

/**
 * __useSaveCardMutation__
 *
 * To run a mutation, you first call `useSaveCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCardMutation, { data, loading, error }] = useSaveCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCardMutation(baseOptions?: Apollo.MutationHookOptions<SaveCardMutation, SaveCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCardMutation, SaveCardMutationVariables>(SaveCardDocument, options);
      }
export type SaveCardMutationHookResult = ReturnType<typeof useSaveCardMutation>;
export type SaveCardMutationResult = Apollo.MutationResult<SaveCardMutation>;
export type SaveCardMutationOptions = Apollo.BaseMutationOptions<SaveCardMutation, SaveCardMutationVariables>;
export const SaveNewBankAccountDocument = gql`
    mutation SaveNewBankAccount($input: SaveNewBankAccountParams) {
  saveNewBankAccount(input: $input) @rest(endpoint: "stullercom", method: "POST", path: "paymentmethods/savebankaccount", type: "SaveNewBankAccountResponse") {
    success
    errors
    bankAccount {
      Id
      BankName
      AccountNumber
      AccountNumberConfirmation
      RoutingNumber
      Tokenized
    }
  }
}
    `;
export type SaveNewBankAccountMutationFn = Apollo.MutationFunction<SaveNewBankAccountMutation, SaveNewBankAccountMutationVariables>;

/**
 * __useSaveNewBankAccountMutation__
 *
 * To run a mutation, you first call `useSaveNewBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNewBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNewBankAccountMutation, { data, loading, error }] = useSaveNewBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveNewBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<SaveNewBankAccountMutation, SaveNewBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveNewBankAccountMutation, SaveNewBankAccountMutationVariables>(SaveNewBankAccountDocument, options);
      }
export type SaveNewBankAccountMutationHookResult = ReturnType<typeof useSaveNewBankAccountMutation>;
export type SaveNewBankAccountMutationResult = Apollo.MutationResult<SaveNewBankAccountMutation>;
export type SaveNewBankAccountMutationOptions = Apollo.BaseMutationOptions<SaveNewBankAccountMutation, SaveNewBankAccountMutationVariables>;
export const GetMetalQualitiesDocument = gql`
    query GetMetalQualities($query: String!) {
  getMetalQualities(query: $query) @rest(endpoint: "stullercom", path: "metal-qualities/findbycodes/?{args.query}", type: "[MetalQuality]") {
    DisplayName
    SubGroup
    Name
    IconPath
    ColorName
    ColorNameLower
    Karat
    BaseMetal
    Code
    ColorHexValue
    CounterSketchMetalMaterialCode
    RelatedContentContainerId
    IsMultiTone
  }
}
    `;

/**
 * __useGetMetalQualitiesQuery__
 *
 * To run a query within a React component, call `useGetMetalQualitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetalQualitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetalQualitiesQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetMetalQualitiesQuery(baseOptions: Apollo.QueryHookOptions<GetMetalQualitiesQuery, GetMetalQualitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetalQualitiesQuery, GetMetalQualitiesQueryVariables>(GetMetalQualitiesDocument, options);
      }
export function useGetMetalQualitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetalQualitiesQuery, GetMetalQualitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetalQualitiesQuery, GetMetalQualitiesQueryVariables>(GetMetalQualitiesDocument, options);
        }
export type GetMetalQualitiesQueryHookResult = ReturnType<typeof useGetMetalQualitiesQuery>;
export type GetMetalQualitiesLazyQueryHookResult = ReturnType<typeof useGetMetalQualitiesLazyQuery>;
export type GetMetalQualitiesQueryResult = Apollo.QueryResult<GetMetalQualitiesQuery, GetMetalQualitiesQueryVariables>;
export const GetInvoicesDocument = gql`
    query GetInvoices($params: GetInvoicesParams!) {
  getInvoices(params: $params) @rest(endpoint: "stullercom", path: "receivables/getInvoices?{args.params}", type: "Receivables") {
    TotalRecords
    ReceivableTransactions {
      TransactionNumber
      OrderNumber
      Total
      TotalDue
      TransactionDate
      AccountNumber
      TransactionType
      CurrencyCode
      ShipmentMethodCode
      TrackingNumber
      Status
      PONumber
    }
    Errors
  }
}
    `;

/**
 * __useGetInvoicesQuery__
 *
 * To run a query within a React component, call `useGetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetInvoicesQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
      }
export function useGetInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
        }
export type GetInvoicesQueryHookResult = ReturnType<typeof useGetInvoicesQuery>;
export type GetInvoicesLazyQueryHookResult = ReturnType<typeof useGetInvoicesLazyQuery>;
export type GetInvoicesQueryResult = Apollo.QueryResult<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const MonthlyStatementEligibilityDocument = gql`
    query MonthlyStatementEligibility {
  monthlyStatementEligibility @rest(endpoint: "stullercom", path: "receivables/monthlystatementeligibility", type: "MonthlyStatementEligibilityResult") {
    IsEligible
  }
}
    `;

/**
 * __useMonthlyStatementEligibilityQuery__
 *
 * To run a query within a React component, call `useMonthlyStatementEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonthlyStatementEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonthlyStatementEligibilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useMonthlyStatementEligibilityQuery(baseOptions?: Apollo.QueryHookOptions<MonthlyStatementEligibilityQuery, MonthlyStatementEligibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MonthlyStatementEligibilityQuery, MonthlyStatementEligibilityQueryVariables>(MonthlyStatementEligibilityDocument, options);
      }
export function useMonthlyStatementEligibilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MonthlyStatementEligibilityQuery, MonthlyStatementEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MonthlyStatementEligibilityQuery, MonthlyStatementEligibilityQueryVariables>(MonthlyStatementEligibilityDocument, options);
        }
export type MonthlyStatementEligibilityQueryHookResult = ReturnType<typeof useMonthlyStatementEligibilityQuery>;
export type MonthlyStatementEligibilityLazyQueryHookResult = ReturnType<typeof useMonthlyStatementEligibilityLazyQuery>;
export type MonthlyStatementEligibilityQueryResult = Apollo.QueryResult<MonthlyStatementEligibilityQuery, MonthlyStatementEligibilityQueryVariables>;
export const StatementDatesDocument = gql`
    query StatementDates {
  getStatementDates @rest(endpoint: "stullercom", path: "receivables/statementdates", type: "StatementDates") {
    MinDate
    MaxDate
  }
}
    `;

/**
 * __useStatementDatesQuery__
 *
 * To run a query within a React component, call `useStatementDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatementDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatementDatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useStatementDatesQuery(baseOptions?: Apollo.QueryHookOptions<StatementDatesQuery, StatementDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatementDatesQuery, StatementDatesQueryVariables>(StatementDatesDocument, options);
      }
export function useStatementDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatementDatesQuery, StatementDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatementDatesQuery, StatementDatesQueryVariables>(StatementDatesDocument, options);
        }
export type StatementDatesQueryHookResult = ReturnType<typeof useStatementDatesQuery>;
export type StatementDatesLazyQueryHookResult = ReturnType<typeof useStatementDatesLazyQuery>;
export type StatementDatesQueryResult = Apollo.QueryResult<StatementDatesQuery, StatementDatesQueryVariables>;
export const AutomaticPaymentsDocument = gql`
    query AutomaticPayments($params: AutomaticPaymentParams) {
  getAutomaticPayments(params: $params) @rest(endpoint: "stullercom", path: "receivables/automaticpayments/?{args.params}", type: "[AutomaticPayment!]!") {
    Id
    CustomerAccountId
    CreationDate
    LastUpdatedDate
    Type {
      Name
      Value
    }
    Nickname
    DayOfMonth
    DayOfWeek
    NumberOfInstallments
    Frequency {
      Name
      Value
    }
    NextPaymentDate
    TransactionCount
    OrderNumber
    TotalAmount
    CurrencyCode
    InstrumentId
    CardType
    IsDebitCard
    TokenizedCardNumber {
      TokenizedNumber
      LastFour
    }
    CardExpirationDate
    BankName
    TokenizedBankAccountNumber {
      TokenizedNumber
      LastFour
    }
    PaymentFailedCount
    PaymentFailedReason
    TransactionErrorMessage
    AmountDue
    NextPaymentDueAmount
    PastDuePaymentAmount
    Title
    ImageUrl
    SKU
    IsPending
  }
}
    `;

/**
 * __useAutomaticPaymentsQuery__
 *
 * To run a query within a React component, call `useAutomaticPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomaticPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomaticPaymentsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAutomaticPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<AutomaticPaymentsQuery, AutomaticPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutomaticPaymentsQuery, AutomaticPaymentsQueryVariables>(AutomaticPaymentsDocument, options);
      }
export function useAutomaticPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutomaticPaymentsQuery, AutomaticPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutomaticPaymentsQuery, AutomaticPaymentsQueryVariables>(AutomaticPaymentsDocument, options);
        }
export type AutomaticPaymentsQueryHookResult = ReturnType<typeof useAutomaticPaymentsQuery>;
export type AutomaticPaymentsLazyQueryHookResult = ReturnType<typeof useAutomaticPaymentsLazyQuery>;
export type AutomaticPaymentsQueryResult = Apollo.QueryResult<AutomaticPaymentsQuery, AutomaticPaymentsQueryVariables>;
export const CreateAutomaticPaymentForStatementDocument = gql`
    mutation CreateAutomaticPaymentForStatement($input: CreateAutomaticPaymentForStatementParams!) {
  createAutomaticPaymentForStatement(input: $input) @rest(endpoint: "stullercom", path: "receivables/createautomaticpaymentforstatement", type: "CreateAutomaticPaymentForStatementResult", method: POST) {
    AutomaticPaymentId
    ErrorMessage
  }
}
    `;
export type CreateAutomaticPaymentForStatementMutationFn = Apollo.MutationFunction<CreateAutomaticPaymentForStatementMutation, CreateAutomaticPaymentForStatementMutationVariables>;

/**
 * __useCreateAutomaticPaymentForStatementMutation__
 *
 * To run a mutation, you first call `useCreateAutomaticPaymentForStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutomaticPaymentForStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutomaticPaymentForStatementMutation, { data, loading, error }] = useCreateAutomaticPaymentForStatementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAutomaticPaymentForStatementMutation(baseOptions?: Apollo.MutationHookOptions<CreateAutomaticPaymentForStatementMutation, CreateAutomaticPaymentForStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAutomaticPaymentForStatementMutation, CreateAutomaticPaymentForStatementMutationVariables>(CreateAutomaticPaymentForStatementDocument, options);
      }
export type CreateAutomaticPaymentForStatementMutationHookResult = ReturnType<typeof useCreateAutomaticPaymentForStatementMutation>;
export type CreateAutomaticPaymentForStatementMutationResult = Apollo.MutationResult<CreateAutomaticPaymentForStatementMutation>;
export type CreateAutomaticPaymentForStatementMutationOptions = Apollo.BaseMutationOptions<CreateAutomaticPaymentForStatementMutation, CreateAutomaticPaymentForStatementMutationVariables>;
export const CreateAutomaticPaymentForOrderDocument = gql`
    mutation CreateAutomaticPaymentForOrder($input: CreateAutomaticPaymentForOrderParams!) {
  createAutomaticPaymentForOrder(input: $input) @rest(endpoint: "stullercom", path: "receivables/createautomaticpaymentfororder", type: "CreateAutomaticPaymentForOrderResult", method: POST) {
    AutomaticPaymentId
    ErrorMessage
  }
}
    `;
export type CreateAutomaticPaymentForOrderMutationFn = Apollo.MutationFunction<CreateAutomaticPaymentForOrderMutation, CreateAutomaticPaymentForOrderMutationVariables>;

/**
 * __useCreateAutomaticPaymentForOrderMutation__
 *
 * To run a mutation, you first call `useCreateAutomaticPaymentForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutomaticPaymentForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutomaticPaymentForOrderMutation, { data, loading, error }] = useCreateAutomaticPaymentForOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAutomaticPaymentForOrderMutation(baseOptions?: Apollo.MutationHookOptions<CreateAutomaticPaymentForOrderMutation, CreateAutomaticPaymentForOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAutomaticPaymentForOrderMutation, CreateAutomaticPaymentForOrderMutationVariables>(CreateAutomaticPaymentForOrderDocument, options);
      }
export type CreateAutomaticPaymentForOrderMutationHookResult = ReturnType<typeof useCreateAutomaticPaymentForOrderMutation>;
export type CreateAutomaticPaymentForOrderMutationResult = Apollo.MutationResult<CreateAutomaticPaymentForOrderMutation>;
export type CreateAutomaticPaymentForOrderMutationOptions = Apollo.BaseMutationOptions<CreateAutomaticPaymentForOrderMutation, CreateAutomaticPaymentForOrderMutationVariables>;
export const CreateAutomaticPaymentForTransactionsDocument = gql`
    mutation CreateAutomaticPaymentForTransactions($input: CreateAutomaticPaymentForTransactionsParams!) {
  createAutomaticPaymentForTransactions(input: $input) @rest(endpoint: "stullercom", path: "receivables/createautomaticpaymentfortransactions", type: "CreateAutomaticPaymentForTransactionsResult", method: POST) {
    AutomaticPaymentId
    ErrorMessage
  }
}
    `;
export type CreateAutomaticPaymentForTransactionsMutationFn = Apollo.MutationFunction<CreateAutomaticPaymentForTransactionsMutation, CreateAutomaticPaymentForTransactionsMutationVariables>;

/**
 * __useCreateAutomaticPaymentForTransactionsMutation__
 *
 * To run a mutation, you first call `useCreateAutomaticPaymentForTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutomaticPaymentForTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutomaticPaymentForTransactionsMutation, { data, loading, error }] = useCreateAutomaticPaymentForTransactionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAutomaticPaymentForTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateAutomaticPaymentForTransactionsMutation, CreateAutomaticPaymentForTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAutomaticPaymentForTransactionsMutation, CreateAutomaticPaymentForTransactionsMutationVariables>(CreateAutomaticPaymentForTransactionsDocument, options);
      }
export type CreateAutomaticPaymentForTransactionsMutationHookResult = ReturnType<typeof useCreateAutomaticPaymentForTransactionsMutation>;
export type CreateAutomaticPaymentForTransactionsMutationResult = Apollo.MutationResult<CreateAutomaticPaymentForTransactionsMutation>;
export type CreateAutomaticPaymentForTransactionsMutationOptions = Apollo.BaseMutationOptions<CreateAutomaticPaymentForTransactionsMutation, CreateAutomaticPaymentForTransactionsMutationVariables>;
export const FinalizeAutomaticPaymentDocument = gql`
    mutation FinalizeAutomaticPayment($input: FinalizeAutomaticPaymentParams!) {
  finalizeAutomaticPayment(input: $input) @rest(endpoint: "stullercom", path: "receivables/finalizeautomaticpayment", type: "FinalizeAutomaticPaymentResult", method: POST) {
    AutomaticPaymentId
  }
}
    `;
export type FinalizeAutomaticPaymentMutationFn = Apollo.MutationFunction<FinalizeAutomaticPaymentMutation, FinalizeAutomaticPaymentMutationVariables>;

/**
 * __useFinalizeAutomaticPaymentMutation__
 *
 * To run a mutation, you first call `useFinalizeAutomaticPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeAutomaticPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeAutomaticPaymentMutation, { data, loading, error }] = useFinalizeAutomaticPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinalizeAutomaticPaymentMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeAutomaticPaymentMutation, FinalizeAutomaticPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeAutomaticPaymentMutation, FinalizeAutomaticPaymentMutationVariables>(FinalizeAutomaticPaymentDocument, options);
      }
export type FinalizeAutomaticPaymentMutationHookResult = ReturnType<typeof useFinalizeAutomaticPaymentMutation>;
export type FinalizeAutomaticPaymentMutationResult = Apollo.MutationResult<FinalizeAutomaticPaymentMutation>;
export type FinalizeAutomaticPaymentMutationOptions = Apollo.BaseMutationOptions<FinalizeAutomaticPaymentMutation, FinalizeAutomaticPaymentMutationVariables>;
export const CancelAutomaticPaymentDocument = gql`
    mutation CancelAutomaticPayment($input: CancelAutomaticPaymentParams!) {
  cancelAutomaticPayment(input: $input) @rest(endpoint: "stullercom", path: "receivables/cancelautomaticpayment", type: "CancelAutomaticPaymentResult", method: POST) {
    AutomaticPaymentId
  }
}
    `;
export type CancelAutomaticPaymentMutationFn = Apollo.MutationFunction<CancelAutomaticPaymentMutation, CancelAutomaticPaymentMutationVariables>;

/**
 * __useCancelAutomaticPaymentMutation__
 *
 * To run a mutation, you first call `useCancelAutomaticPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAutomaticPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAutomaticPaymentMutation, { data, loading, error }] = useCancelAutomaticPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelAutomaticPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CancelAutomaticPaymentMutation, CancelAutomaticPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAutomaticPaymentMutation, CancelAutomaticPaymentMutationVariables>(CancelAutomaticPaymentDocument, options);
      }
export type CancelAutomaticPaymentMutationHookResult = ReturnType<typeof useCancelAutomaticPaymentMutation>;
export type CancelAutomaticPaymentMutationResult = Apollo.MutationResult<CancelAutomaticPaymentMutation>;
export type CancelAutomaticPaymentMutationOptions = Apollo.BaseMutationOptions<CancelAutomaticPaymentMutation, CancelAutomaticPaymentMutationVariables>;
export const UpdateAutomaticPaymentDocument = gql`
    mutation UpdateAutomaticPayment($input: UpdateAutomaticPaymentParams!) {
  updateAutomaticPayment(input: $input) @rest(endpoint: "stullercom", path: "receivables/updateautomaticpayment", type: "UpdateAutomaticPaymentResult", method: POST) {
    AutomaticPaymentId
  }
}
    `;
export type UpdateAutomaticPaymentMutationFn = Apollo.MutationFunction<UpdateAutomaticPaymentMutation, UpdateAutomaticPaymentMutationVariables>;

/**
 * __useUpdateAutomaticPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateAutomaticPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomaticPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomaticPaymentMutation, { data, loading, error }] = useUpdateAutomaticPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAutomaticPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutomaticPaymentMutation, UpdateAutomaticPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutomaticPaymentMutation, UpdateAutomaticPaymentMutationVariables>(UpdateAutomaticPaymentDocument, options);
      }
export type UpdateAutomaticPaymentMutationHookResult = ReturnType<typeof useUpdateAutomaticPaymentMutation>;
export type UpdateAutomaticPaymentMutationResult = Apollo.MutationResult<UpdateAutomaticPaymentMutation>;
export type UpdateAutomaticPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateAutomaticPaymentMutation, UpdateAutomaticPaymentMutationVariables>;
export const GetReceivableTransactionsDocument = gql`
    query GetReceivableTransactions($params: GetReceivableTransactionsParams!) {
  getReceivableTransactions(params: $params) @rest(endpoint: "stullercom", path: "receivables/transactions?{args.params}", type: "ReceivableTransactionResults") {
    Page
    PageSize
    TotalTransactions
    Transactions {
      TransactionId
      TransactionNumber
      ShipToAccountNumber
      TotalAmount {
        Value
        CurrencyCode
      }
      AmountDue {
        Value
        CurrencyCode
      }
      TransactionDate
      DueDate
      Type
      Terms
      Status
      PONumber
      OrderNumber
      Pending
      Installments {
        TransactionId
        TransactionNumber
        TotalAmount {
          Value
          CurrencyCode
        }
        AmountDue {
          Value
          CurrencyCode
        }
        TransactionDate
        DueDate
        Type
        Terms
        Status
        PONumber
        OrderNumber
        Sequence
        Pending
        IsInAutomaticPayment
      }
      IsInAutomaticPayment
    }
  }
}
    `;

/**
 * __useGetReceivableTransactionsQuery__
 *
 * To run a query within a React component, call `useGetReceivableTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceivableTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceivableTransactionsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetReceivableTransactionsQuery(baseOptions: Apollo.QueryHookOptions<GetReceivableTransactionsQuery, GetReceivableTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceivableTransactionsQuery, GetReceivableTransactionsQueryVariables>(GetReceivableTransactionsDocument, options);
      }
export function useGetReceivableTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceivableTransactionsQuery, GetReceivableTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceivableTransactionsQuery, GetReceivableTransactionsQueryVariables>(GetReceivableTransactionsDocument, options);
        }
export type GetReceivableTransactionsQueryHookResult = ReturnType<typeof useGetReceivableTransactionsQuery>;
export type GetReceivableTransactionsLazyQueryHookResult = ReturnType<typeof useGetReceivableTransactionsLazyQuery>;
export type GetReceivableTransactionsQueryResult = Apollo.QueryResult<GetReceivableTransactionsQuery, GetReceivableTransactionsQueryVariables>;
export const GetNonPastDueCodTransactionsDocument = gql`
    query GetNonPastDueCODTransactions {
  getNonPastDueCODTransactions @rest(endpoint: "stullercom", path: "receivables/nonpastduecodtransactions", type: "ReceivableTransactionResults") {
    NonPastDueCODTransactions {
      TransactionId
      TransactionNumber
      ShipToAccountNumber
      TotalAmount {
        Value
        CurrencyCode
      }
      AmountDue {
        Value
        CurrencyCode
      }
      TransactionDate
      DueDate
      Type
      Terms
      Status
      PONumber
      OrderNumber
      Pending
      Installments {
        TransactionId
        TransactionNumber
        TotalAmount {
          Value
          CurrencyCode
        }
        AmountDue {
          Value
          CurrencyCode
        }
        TransactionDate
        DueDate
        Type
        Terms
        Status
        PONumber
        OrderNumber
        Sequence
        Pending
        IsInAutomaticPayment
      }
      IsInAutomaticPayment
    }
  }
}
    `;

/**
 * __useGetNonPastDueCodTransactionsQuery__
 *
 * To run a query within a React component, call `useGetNonPastDueCodTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonPastDueCodTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonPastDueCodTransactionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNonPastDueCodTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<GetNonPastDueCodTransactionsQuery, GetNonPastDueCodTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonPastDueCodTransactionsQuery, GetNonPastDueCodTransactionsQueryVariables>(GetNonPastDueCodTransactionsDocument, options);
      }
export function useGetNonPastDueCodTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonPastDueCodTransactionsQuery, GetNonPastDueCodTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonPastDueCodTransactionsQuery, GetNonPastDueCodTransactionsQueryVariables>(GetNonPastDueCodTransactionsDocument, options);
        }
export type GetNonPastDueCodTransactionsQueryHookResult = ReturnType<typeof useGetNonPastDueCodTransactionsQuery>;
export type GetNonPastDueCodTransactionsLazyQueryHookResult = ReturnType<typeof useGetNonPastDueCodTransactionsLazyQuery>;
export type GetNonPastDueCodTransactionsQueryResult = Apollo.QueryResult<GetNonPastDueCodTransactionsQuery, GetNonPastDueCodTransactionsQueryVariables>;
export const GetFilteredTransactionAccountSummaryDocument = gql`
    query GetFilteredTransactionAccountSummary($filter: TransactionFilter!) {
  getTransactionsAccountSummary(filter: $filter) @rest(endpoint: "stullercom", path: "receivables/transactions/account-summary", type: "ReceivableTransactionBillToAccountSummary", method: POST, bodyKey: "filter") {
    TransactionCount
    Balance {
      Value
      CurrencyCode
    }
    StatementIssueDate
    IncludesAutomaticPaymentTransaction
  }
}
    `;

/**
 * __useGetFilteredTransactionAccountSummaryQuery__
 *
 * To run a query within a React component, call `useGetFilteredTransactionAccountSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredTransactionAccountSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredTransactionAccountSummaryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetFilteredTransactionAccountSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetFilteredTransactionAccountSummaryQuery, GetFilteredTransactionAccountSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilteredTransactionAccountSummaryQuery, GetFilteredTransactionAccountSummaryQueryVariables>(GetFilteredTransactionAccountSummaryDocument, options);
      }
export function useGetFilteredTransactionAccountSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilteredTransactionAccountSummaryQuery, GetFilteredTransactionAccountSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilteredTransactionAccountSummaryQuery, GetFilteredTransactionAccountSummaryQueryVariables>(GetFilteredTransactionAccountSummaryDocument, options);
        }
export type GetFilteredTransactionAccountSummaryQueryHookResult = ReturnType<typeof useGetFilteredTransactionAccountSummaryQuery>;
export type GetFilteredTransactionAccountSummaryLazyQueryHookResult = ReturnType<typeof useGetFilteredTransactionAccountSummaryLazyQuery>;
export type GetFilteredTransactionAccountSummaryQueryResult = Apollo.QueryResult<GetFilteredTransactionAccountSummaryQuery, GetFilteredTransactionAccountSummaryQueryVariables>;
export const GetCurrentBalanceAccountSummaryDocument = gql`
    query GetCurrentBalanceAccountSummary {
  getCurrentBalanceAccountSummary @rest(endpoint: "stullercom", path: "receivables/transactions/account-summary", type: "ReceivableTransactionBillToAccountSummary") {
    TransactionCount
    Balance {
      Value
      CurrencyCode
    }
    StatementIssueDate
    IncludesAutomaticPaymentTransaction
  }
}
    `;

/**
 * __useGetCurrentBalanceAccountSummaryQuery__
 *
 * To run a query within a React component, call `useGetCurrentBalanceAccountSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentBalanceAccountSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentBalanceAccountSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentBalanceAccountSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentBalanceAccountSummaryQuery, GetCurrentBalanceAccountSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentBalanceAccountSummaryQuery, GetCurrentBalanceAccountSummaryQueryVariables>(GetCurrentBalanceAccountSummaryDocument, options);
      }
export function useGetCurrentBalanceAccountSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentBalanceAccountSummaryQuery, GetCurrentBalanceAccountSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentBalanceAccountSummaryQuery, GetCurrentBalanceAccountSummaryQueryVariables>(GetCurrentBalanceAccountSummaryDocument, options);
        }
export type GetCurrentBalanceAccountSummaryQueryHookResult = ReturnType<typeof useGetCurrentBalanceAccountSummaryQuery>;
export type GetCurrentBalanceAccountSummaryLazyQueryHookResult = ReturnType<typeof useGetCurrentBalanceAccountSummaryLazyQuery>;
export type GetCurrentBalanceAccountSummaryQueryResult = Apollo.QueryResult<GetCurrentBalanceAccountSummaryQuery, GetCurrentBalanceAccountSummaryQueryVariables>;
export const GetPastDueBalanceAccountSummaryDocument = gql`
    query GetPastDueBalanceAccountSummary {
  getPastDueBalanceAccountSummary @rest(endpoint: "stullercom", path: "receivables/transactions/account-summary?pastdueonly=true", type: "ReceivableTransactionBillToAccountSummary") {
    TransactionCount
    Balance {
      Value
      CurrencyCode
    }
    StatementIssueDate
    IncludesAutomaticPaymentTransaction
  }
}
    `;

/**
 * __useGetPastDueBalanceAccountSummaryQuery__
 *
 * To run a query within a React component, call `useGetPastDueBalanceAccountSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPastDueBalanceAccountSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPastDueBalanceAccountSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPastDueBalanceAccountSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetPastDueBalanceAccountSummaryQuery, GetPastDueBalanceAccountSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPastDueBalanceAccountSummaryQuery, GetPastDueBalanceAccountSummaryQueryVariables>(GetPastDueBalanceAccountSummaryDocument, options);
      }
export function useGetPastDueBalanceAccountSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPastDueBalanceAccountSummaryQuery, GetPastDueBalanceAccountSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPastDueBalanceAccountSummaryQuery, GetPastDueBalanceAccountSummaryQueryVariables>(GetPastDueBalanceAccountSummaryDocument, options);
        }
export type GetPastDueBalanceAccountSummaryQueryHookResult = ReturnType<typeof useGetPastDueBalanceAccountSummaryQuery>;
export type GetPastDueBalanceAccountSummaryLazyQueryHookResult = ReturnType<typeof useGetPastDueBalanceAccountSummaryLazyQuery>;
export type GetPastDueBalanceAccountSummaryQueryResult = Apollo.QueryResult<GetPastDueBalanceAccountSummaryQuery, GetPastDueBalanceAccountSummaryQueryVariables>;
export const GetCurrentStatementAccountSummaryDocument = gql`
    query GetCurrentStatementAccountSummary {
  getCurrentStatementAccountSummary @rest(endpoint: "stullercom", path: "receivables/transactions/account-summary?currentstatementonly=true", type: "ReceivableTransactionBillToAccountSummary") {
    TransactionCount
    Balance {
      Value
      CurrencyCode
    }
    StatementIssueDate
    IncludesAutomaticPaymentTransaction
  }
}
    `;

/**
 * __useGetCurrentStatementAccountSummaryQuery__
 *
 * To run a query within a React component, call `useGetCurrentStatementAccountSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentStatementAccountSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentStatementAccountSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentStatementAccountSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentStatementAccountSummaryQuery, GetCurrentStatementAccountSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentStatementAccountSummaryQuery, GetCurrentStatementAccountSummaryQueryVariables>(GetCurrentStatementAccountSummaryDocument, options);
      }
export function useGetCurrentStatementAccountSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentStatementAccountSummaryQuery, GetCurrentStatementAccountSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentStatementAccountSummaryQuery, GetCurrentStatementAccountSummaryQueryVariables>(GetCurrentStatementAccountSummaryDocument, options);
        }
export type GetCurrentStatementAccountSummaryQueryHookResult = ReturnType<typeof useGetCurrentStatementAccountSummaryQuery>;
export type GetCurrentStatementAccountSummaryLazyQueryHookResult = ReturnType<typeof useGetCurrentStatementAccountSummaryLazyQuery>;
export type GetCurrentStatementAccountSummaryQueryResult = Apollo.QueryResult<GetCurrentStatementAccountSummaryQuery, GetCurrentStatementAccountSummaryQueryVariables>;
export const GetPendingPaymentsDocument = gql`
    query GetPendingPayments {
  getPendingPayments @rest(endpoint: "stullercom", path: "receivables/payments", type: "[PaymentOnAccount]") {
    Id
    BillToAccountNumber
    Amount {
      Value
      CurrencyCode
    }
    Status
    ProcessingStatus
    PaymentType
    AccountId
    PaymentDate
    PaymentAuthorizationCode
    PaymentCreditCardType
    PaymentLabel
  }
}
    `;

/**
 * __useGetPendingPaymentsQuery__
 *
 * To run a query within a React component, call `useGetPendingPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingPaymentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPendingPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingPaymentsQuery, GetPendingPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingPaymentsQuery, GetPendingPaymentsQueryVariables>(GetPendingPaymentsDocument, options);
      }
export function useGetPendingPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingPaymentsQuery, GetPendingPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingPaymentsQuery, GetPendingPaymentsQueryVariables>(GetPendingPaymentsDocument, options);
        }
export type GetPendingPaymentsQueryHookResult = ReturnType<typeof useGetPendingPaymentsQuery>;
export type GetPendingPaymentsLazyQueryHookResult = ReturnType<typeof useGetPendingPaymentsLazyQuery>;
export type GetPendingPaymentsQueryResult = Apollo.QueryResult<GetPendingPaymentsQuery, GetPendingPaymentsQueryVariables>;
export const GetPaymentDocument = gql`
    query GetPayment($id: Int!) {
  getPayment(id: $id) @rest(endpoint: "stullercom", path: "receivables/payment/{args.id}", type: "PaymentOnAccount") {
    Id
    BillToAccountNumber
    Amount {
      Value
      CurrencyCode
    }
    Status
    ProcessingStatus
    PaymentType
    AccountId
    PaymentDate
    PaymentAuthorizationCode
    PaymentLabel
    PaymentCreditCardType
  }
}
    `;

/**
 * __useGetPaymentQuery__
 *
 * To run a query within a React component, call `useGetPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPaymentQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
      }
export function useGetPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentQuery, GetPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, options);
        }
export type GetPaymentQueryHookResult = ReturnType<typeof useGetPaymentQuery>;
export type GetPaymentLazyQueryHookResult = ReturnType<typeof useGetPaymentLazyQuery>;
export type GetPaymentQueryResult = Apollo.QueryResult<GetPaymentQuery, GetPaymentQueryVariables>;
export const GetPaymentInvoicesDocument = gql`
    query GetPaymentInvoices($id: Int!, $page: Int!, $pageSize: Int!) {
  getPaymentInvoices(id: $id, page: $page, pageSize: $pageSize) @rest(endpoint: "stullercom", path: "receivables/payment/{args.id}/invoices?page={args.page}&pageSize={args.pageSize}", type: "PaymentInvoicesResults") {
    Page
    PageSize
    TotalInvoices
    Invoices {
      Id
      PaymentId
      InvoiceNumber
      InvoiceId
      Amount {
        Value
        CurrencyCode
      }
      SequenceNumber
      Installment
      TransactionType
      TransactionTypeDisplay
    }
  }
}
    `;

/**
 * __useGetPaymentInvoicesQuery__
 *
 * To run a query within a React component, call `useGetPaymentInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentInvoicesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetPaymentInvoicesQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentInvoicesQuery, GetPaymentInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentInvoicesQuery, GetPaymentInvoicesQueryVariables>(GetPaymentInvoicesDocument, options);
      }
export function useGetPaymentInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentInvoicesQuery, GetPaymentInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentInvoicesQuery, GetPaymentInvoicesQueryVariables>(GetPaymentInvoicesDocument, options);
        }
export type GetPaymentInvoicesQueryHookResult = ReturnType<typeof useGetPaymentInvoicesQuery>;
export type GetPaymentInvoicesLazyQueryHookResult = ReturnType<typeof useGetPaymentInvoicesLazyQuery>;
export type GetPaymentInvoicesQueryResult = Apollo.QueryResult<GetPaymentInvoicesQuery, GetPaymentInvoicesQueryVariables>;
export const SubmitPaymentsDocument = gql`
    mutation SubmitPayments($input: SubmitPaymentParams!) {
  submitPayments(input: $input) @rest(endpoint: "stullercom", path: "receivables/payments", type: "SubmitPaymentResult", method: POST) {
    PaymentId
  }
}
    `;
export type SubmitPaymentsMutationFn = Apollo.MutationFunction<SubmitPaymentsMutation, SubmitPaymentsMutationVariables>;

/**
 * __useSubmitPaymentsMutation__
 *
 * To run a mutation, you first call `useSubmitPaymentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPaymentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPaymentsMutation, { data, loading, error }] = useSubmitPaymentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitPaymentsMutation(baseOptions?: Apollo.MutationHookOptions<SubmitPaymentsMutation, SubmitPaymentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitPaymentsMutation, SubmitPaymentsMutationVariables>(SubmitPaymentsDocument, options);
      }
export type SubmitPaymentsMutationHookResult = ReturnType<typeof useSubmitPaymentsMutation>;
export type SubmitPaymentsMutationResult = Apollo.MutationResult<SubmitPaymentsMutation>;
export type SubmitPaymentsMutationOptions = Apollo.BaseMutationOptions<SubmitPaymentsMutation, SubmitPaymentsMutationVariables>;
export const GetReturnsDocument = gql`
    query GetReturns($params: ReturnHistoryParams!) {
  returnHistory(params: $params) @rest(endpoint: "stullercom", path: "myaccount/returns/webreturnhistory?{args.params}", type: "ReturnHistory") {
    returns {
      AccountNumber
      OrderDate
      OrderDateString
      OrderLineCount
      OrderNumber
      Status
      TotalPrice
      TrackingNumber
      TrackingUrl
      WebNumber
    }
    totalRecords
  }
}
    `;

/**
 * __useGetReturnsQuery__
 *
 * To run a query within a React component, call `useGetReturnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReturnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReturnsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetReturnsQuery(baseOptions: Apollo.QueryHookOptions<GetReturnsQuery, GetReturnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReturnsQuery, GetReturnsQueryVariables>(GetReturnsDocument, options);
      }
export function useGetReturnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReturnsQuery, GetReturnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReturnsQuery, GetReturnsQueryVariables>(GetReturnsDocument, options);
        }
export type GetReturnsQueryHookResult = ReturnType<typeof useGetReturnsQuery>;
export type GetReturnsLazyQueryHookResult = ReturnType<typeof useGetReturnsLazyQuery>;
export type GetReturnsQueryResult = Apollo.QueryResult<GetReturnsQuery, GetReturnsQueryVariables>;
export const GetReturnReasonsDocument = gql`
    query GetReturnReasons {
  getReturnReasons @rest(endpoint: "stullercom", path: "myaccount/returns/getreturnreasons", type: "[ReturnReason!]!") {
    Code
    Meaning
  }
}
    `;

/**
 * __useGetReturnReasonsQuery__
 *
 * To run a query within a React component, call `useGetReturnReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReturnReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReturnReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReturnReasonsQuery(baseOptions?: Apollo.QueryHookOptions<GetReturnReasonsQuery, GetReturnReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReturnReasonsQuery, GetReturnReasonsQueryVariables>(GetReturnReasonsDocument, options);
      }
export function useGetReturnReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReturnReasonsQuery, GetReturnReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReturnReasonsQuery, GetReturnReasonsQueryVariables>(GetReturnReasonsDocument, options);
        }
export type GetReturnReasonsQueryHookResult = ReturnType<typeof useGetReturnReasonsQuery>;
export type GetReturnReasonsLazyQueryHookResult = ReturnType<typeof useGetReturnReasonsLazyQuery>;
export type GetReturnReasonsQueryResult = Apollo.QueryResult<GetReturnReasonsQuery, GetReturnReasonsQueryVariables>;
export const CreateRmaDocument = gql`
    mutation CreateRMA($input: CreateRMAInput) {
  createRMA(input: $input) @rest(endpoint: "stullercom", method: "POST", path: "myaccount/returns/createrma", type: "CreateRMAResult") {
    success
    errors
    orderNumber
  }
}
    `;
export type CreateRmaMutationFn = Apollo.MutationFunction<CreateRmaMutation, CreateRmaMutationVariables>;

/**
 * __useCreateRmaMutation__
 *
 * To run a mutation, you first call `useCreateRmaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRmaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRmaMutation, { data, loading, error }] = useCreateRmaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRmaMutation(baseOptions?: Apollo.MutationHookOptions<CreateRmaMutation, CreateRmaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRmaMutation, CreateRmaMutationVariables>(CreateRmaDocument, options);
      }
export type CreateRmaMutationHookResult = ReturnType<typeof useCreateRmaMutation>;
export type CreateRmaMutationResult = Apollo.MutationResult<CreateRmaMutation>;
export type CreateRmaMutationOptions = Apollo.BaseMutationOptions<CreateRmaMutation, CreateRmaMutationVariables>;
export const GetSearchNavigationDocument = gql`
    query GetSearchNavigation($pathname: String!, $search: String!) {
  getSearchNavigation(pathname: $pathname, search: $search) @rest(endpoint: "stullercom", path: "{args.pathname}?{args.search}", type: "CategoryOrSearchViewModel") {
    ...CategoryOrSearchQueryResponse
  }
}
    ${CategoryOrSearchQueryResponseFragmentDoc}`;

/**
 * __useGetSearchNavigationQuery__
 *
 * To run a query within a React component, call `useGetSearchNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchNavigationQuery({
 *   variables: {
 *      pathname: // value for 'pathname'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetSearchNavigationQuery(baseOptions: Apollo.QueryHookOptions<GetSearchNavigationQuery, GetSearchNavigationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchNavigationQuery, GetSearchNavigationQueryVariables>(GetSearchNavigationDocument, options);
      }
export function useGetSearchNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchNavigationQuery, GetSearchNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchNavigationQuery, GetSearchNavigationQueryVariables>(GetSearchNavigationDocument, options);
        }
export type GetSearchNavigationQueryHookResult = ReturnType<typeof useGetSearchNavigationQuery>;
export type GetSearchNavigationLazyQueryHookResult = ReturnType<typeof useGetSearchNavigationLazyQuery>;
export type GetSearchNavigationQueryResult = Apollo.QueryResult<GetSearchNavigationQuery, GetSearchNavigationQueryVariables>;
export const GetArticleResultsDocument = gql`
    query GetArticleResults($params: ArticleResultsParams) {
  getArticleResults(params: $params) @rest(endpoint: "stullercom", path: "search/articlesjson?{args.params}", type: "CategoryOrSearchViewModel") {
    Query
    SortBy {
      Disabled
      Group
      Selected
      Text
      Value
    }
    Pager {
      TotalPages
      CurrentPage
      TotalRecords
      FirstDisplayPage
      LastDisplayPage
      HidePagerWhenOnlyOnePageIsAvailable
      ChangePageIsJavascript
      ShowingText
      RecordsPerPage
    }
    SearchResults {
      CreationDate
      Title
      Url
      Teaser
      ContentType
    }
  }
}
    `;

/**
 * __useGetArticleResultsQuery__
 *
 * To run a query within a React component, call `useGetArticleResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArticleResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArticleResultsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetArticleResultsQuery(baseOptions?: Apollo.QueryHookOptions<GetArticleResultsQuery, GetArticleResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArticleResultsQuery, GetArticleResultsQueryVariables>(GetArticleResultsDocument, options);
      }
export function useGetArticleResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArticleResultsQuery, GetArticleResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArticleResultsQuery, GetArticleResultsQueryVariables>(GetArticleResultsDocument, options);
        }
export type GetArticleResultsQueryHookResult = ReturnType<typeof useGetArticleResultsQuery>;
export type GetArticleResultsLazyQueryHookResult = ReturnType<typeof useGetArticleResultsLazyQuery>;
export type GetArticleResultsQueryResult = Apollo.QueryResult<GetArticleResultsQuery, GetArticleResultsQueryVariables>;
export const MerchandiseSubmissionShippingRatesDocument = gql`
    query merchandiseSubmissionShippingRates($input: MerchandiseSubmissionShippingRatesInput) {
  merchandiseSubmissionShippingRates(input: $input) @rest(endpoint: "stullercom", method: "POST", path: "shipments/MerchandiseSubmissionShippingRates", type: "[MerchandiseSubmissionShippingRatesResults!]") {
    Carrier
    Description
    FreightPrice
    InsurancePrice
    ReplacementValue
    TotalShippingPrice
    ShippingMethodCode
  }
}
    `;

/**
 * __useMerchandiseSubmissionShippingRatesQuery__
 *
 * To run a query within a React component, call `useMerchandiseSubmissionShippingRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchandiseSubmissionShippingRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchandiseSubmissionShippingRatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMerchandiseSubmissionShippingRatesQuery(baseOptions?: Apollo.QueryHookOptions<MerchandiseSubmissionShippingRatesQuery, MerchandiseSubmissionShippingRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchandiseSubmissionShippingRatesQuery, MerchandiseSubmissionShippingRatesQueryVariables>(MerchandiseSubmissionShippingRatesDocument, options);
      }
export function useMerchandiseSubmissionShippingRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchandiseSubmissionShippingRatesQuery, MerchandiseSubmissionShippingRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchandiseSubmissionShippingRatesQuery, MerchandiseSubmissionShippingRatesQueryVariables>(MerchandiseSubmissionShippingRatesDocument, options);
        }
export type MerchandiseSubmissionShippingRatesQueryHookResult = ReturnType<typeof useMerchandiseSubmissionShippingRatesQuery>;
export type MerchandiseSubmissionShippingRatesLazyQueryHookResult = ReturnType<typeof useMerchandiseSubmissionShippingRatesLazyQuery>;
export type MerchandiseSubmissionShippingRatesQueryResult = Apollo.QueryResult<MerchandiseSubmissionShippingRatesQuery, MerchandiseSubmissionShippingRatesQueryVariables>;
export const GetAvailableShipToAccountsDocument = gql`
    query GetAvailableShipToAccounts {
  availableShipToAccounts @rest(endpoint: "stullercom", path: "shiptoaccount/GetAvailableShipToAccounts", type: "ShipToAccounts!") {
    shipToAccounts {
      ShipToAccountNumber
      IsActive
      HtmlFormattedAddress
      InlineFormattedAddress
    }
  }
}
    `;

/**
 * __useGetAvailableShipToAccountsQuery__
 *
 * To run a query within a React component, call `useGetAvailableShipToAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableShipToAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableShipToAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableShipToAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableShipToAccountsQuery, GetAvailableShipToAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableShipToAccountsQuery, GetAvailableShipToAccountsQueryVariables>(GetAvailableShipToAccountsDocument, options);
      }
export function useGetAvailableShipToAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableShipToAccountsQuery, GetAvailableShipToAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableShipToAccountsQuery, GetAvailableShipToAccountsQueryVariables>(GetAvailableShipToAccountsDocument, options);
        }
export type GetAvailableShipToAccountsQueryHookResult = ReturnType<typeof useGetAvailableShipToAccountsQuery>;
export type GetAvailableShipToAccountsLazyQueryHookResult = ReturnType<typeof useGetAvailableShipToAccountsLazyQuery>;
export type GetAvailableShipToAccountsQueryResult = Apollo.QueryResult<GetAvailableShipToAccountsQuery, GetAvailableShipToAccountsQueryVariables>;
export const FindShipToAccountNumbersDocument = gql`
    query FindShipToAccountNumbers($params: FindShipToAccountNumbersParams!) {
  findShipToAccountNumbers(params: $params) @rest(endpoint: "stullercom", path: "shiptoaccount/FindShipToAccountNumbers?{args.params}", type: "[ShipToAccountNumber!]!") {
    value
    label
  }
}
    `;

/**
 * __useFindShipToAccountNumbersQuery__
 *
 * To run a query within a React component, call `useFindShipToAccountNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindShipToAccountNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindShipToAccountNumbersQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useFindShipToAccountNumbersQuery(baseOptions: Apollo.QueryHookOptions<FindShipToAccountNumbersQuery, FindShipToAccountNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindShipToAccountNumbersQuery, FindShipToAccountNumbersQueryVariables>(FindShipToAccountNumbersDocument, options);
      }
export function useFindShipToAccountNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindShipToAccountNumbersQuery, FindShipToAccountNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindShipToAccountNumbersQuery, FindShipToAccountNumbersQueryVariables>(FindShipToAccountNumbersDocument, options);
        }
export type FindShipToAccountNumbersQueryHookResult = ReturnType<typeof useFindShipToAccountNumbersQuery>;
export type FindShipToAccountNumbersLazyQueryHookResult = ReturnType<typeof useFindShipToAccountNumbersLazyQuery>;
export type FindShipToAccountNumbersQueryResult = Apollo.QueryResult<FindShipToAccountNumbersQuery, FindShipToAccountNumbersQueryVariables>;
export const GetSystemSettingValueDocument = gql`
    query GetSystemSettingValue($settingName: String!, $appendSearch: String = "") {
  systemSettingValue(settingName: $settingName, appendSearch: $appendSearch) @rest(endpoint: "stullercom", path: "systemsettings/value?settingName={args.settingName}&{args.appendSearch}", type: "SystemSettingResponse") {
    value
  }
}
    `;

/**
 * __useGetSystemSettingValueQuery__
 *
 * To run a query within a React component, call `useGetSystemSettingValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemSettingValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemSettingValueQuery({
 *   variables: {
 *      settingName: // value for 'settingName'
 *      appendSearch: // value for 'appendSearch'
 *   },
 * });
 */
export function useGetSystemSettingValueQuery(baseOptions: Apollo.QueryHookOptions<GetSystemSettingValueQuery, GetSystemSettingValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemSettingValueQuery, GetSystemSettingValueQueryVariables>(GetSystemSettingValueDocument, options);
      }
export function useGetSystemSettingValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemSettingValueQuery, GetSystemSettingValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemSettingValueQuery, GetSystemSettingValueQueryVariables>(GetSystemSettingValueDocument, options);
        }
export type GetSystemSettingValueQueryHookResult = ReturnType<typeof useGetSystemSettingValueQuery>;
export type GetSystemSettingValueLazyQueryHookResult = ReturnType<typeof useGetSystemSettingValueLazyQuery>;
export type GetSystemSettingValueQueryResult = Apollo.QueryResult<GetSystemSettingValueQuery, GetSystemSettingValueQueryVariables>;
export const GetFakePaymentDocument = gql`
    query GetFakePayment($id: Int!) {
  getFakePayment(id: $id) @rest(endpoint: "stullercom", path: "utility/data/fake-payment/{args.id}", type: "FakePayment") {
    Id
    Amount
    From
    Comment
  }
}
    `;

/**
 * __useGetFakePaymentQuery__
 *
 * To run a query within a React component, call `useGetFakePaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFakePaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFakePaymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFakePaymentQuery(baseOptions: Apollo.QueryHookOptions<GetFakePaymentQuery, GetFakePaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFakePaymentQuery, GetFakePaymentQueryVariables>(GetFakePaymentDocument, options);
      }
export function useGetFakePaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFakePaymentQuery, GetFakePaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFakePaymentQuery, GetFakePaymentQueryVariables>(GetFakePaymentDocument, options);
        }
export type GetFakePaymentQueryHookResult = ReturnType<typeof useGetFakePaymentQuery>;
export type GetFakePaymentLazyQueryHookResult = ReturnType<typeof useGetFakePaymentLazyQuery>;
export type GetFakePaymentQueryResult = Apollo.QueryResult<GetFakePaymentQuery, GetFakePaymentQueryVariables>;
export const GetFakePaymentIdsDocument = gql`
    query GetFakePaymentIds {
  getFakePaymentIds @rest(endpoint: "stullercom", path: "utility/data/fake-payments", type: "[Int]")
}
    `;

/**
 * __useGetFakePaymentIdsQuery__
 *
 * To run a query within a React component, call `useGetFakePaymentIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFakePaymentIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFakePaymentIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFakePaymentIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetFakePaymentIdsQuery, GetFakePaymentIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFakePaymentIdsQuery, GetFakePaymentIdsQueryVariables>(GetFakePaymentIdsDocument, options);
      }
export function useGetFakePaymentIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFakePaymentIdsQuery, GetFakePaymentIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFakePaymentIdsQuery, GetFakePaymentIdsQueryVariables>(GetFakePaymentIdsDocument, options);
        }
export type GetFakePaymentIdsQueryHookResult = ReturnType<typeof useGetFakePaymentIdsQuery>;
export type GetFakePaymentIdsLazyQueryHookResult = ReturnType<typeof useGetFakePaymentIdsLazyQuery>;
export type GetFakePaymentIdsQueryResult = Apollo.QueryResult<GetFakePaymentIdsQuery, GetFakePaymentIdsQueryVariables>;
export const CreateFakePaymentDocument = gql`
    mutation CreateFakePayment($input: CreateFakePaymentParams!) {
  createFakePayment(input: $input) @rest(endpoint: "stullercom", path: "utility/data/fake-payments?{args.input}", type: "CreateFakePaymentResult", method: POST) {
    Id
  }
}
    `;
export type CreateFakePaymentMutationFn = Apollo.MutationFunction<CreateFakePaymentMutation, CreateFakePaymentMutationVariables>;

/**
 * __useCreateFakePaymentMutation__
 *
 * To run a mutation, you first call `useCreateFakePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFakePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFakePaymentMutation, { data, loading, error }] = useCreateFakePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFakePaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateFakePaymentMutation, CreateFakePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFakePaymentMutation, CreateFakePaymentMutationVariables>(CreateFakePaymentDocument, options);
      }
export type CreateFakePaymentMutationHookResult = ReturnType<typeof useCreateFakePaymentMutation>;
export type CreateFakePaymentMutationResult = Apollo.MutationResult<CreateFakePaymentMutation>;
export type CreateFakePaymentMutationOptions = Apollo.BaseMutationOptions<CreateFakePaymentMutation, CreateFakePaymentMutationVariables>;
export const CancelFakePaymentDocument = gql`
    mutation CancelFakePayment($input: CancelFakePaymentParams!) {
  cancelFakePayment(input: $input) @rest(endpoint: "stullercom", path: "utility/data/fake-payment/{args.input.id}?from={args.input.from}&comment={args.input.comment}", type: "CancelFakePaymentResult", method: DELETE) {
    CanceledPaymentId
  }
}
    `;
export type CancelFakePaymentMutationFn = Apollo.MutationFunction<CancelFakePaymentMutation, CancelFakePaymentMutationVariables>;

/**
 * __useCancelFakePaymentMutation__
 *
 * To run a mutation, you first call `useCancelFakePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelFakePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelFakePaymentMutation, { data, loading, error }] = useCancelFakePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelFakePaymentMutation(baseOptions?: Apollo.MutationHookOptions<CancelFakePaymentMutation, CancelFakePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelFakePaymentMutation, CancelFakePaymentMutationVariables>(CancelFakePaymentDocument, options);
      }
export type CancelFakePaymentMutationHookResult = ReturnType<typeof useCancelFakePaymentMutation>;
export type CancelFakePaymentMutationResult = Apollo.MutationResult<CancelFakePaymentMutation>;
export type CancelFakePaymentMutationOptions = Apollo.BaseMutationOptions<CancelFakePaymentMutation, CancelFakePaymentMutationVariables>;
export const SendPasswordLinkDocument = gql`
    mutation sendPasswordLink($input: SendPasswordLinkParams!) {
  sendPasswordLink(input: $input) @rest(endpoint: "stullercom", method: "POST", path: "accountsignup/SendPasswordLink", type: "SendPasswordLinkResponse") {
    success
  }
}
    `;
export type SendPasswordLinkMutationFn = Apollo.MutationFunction<SendPasswordLinkMutation, SendPasswordLinkMutationVariables>;

/**
 * __useSendPasswordLinkMutation__
 *
 * To run a mutation, you first call `useSendPasswordLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordLinkMutation, { data, loading, error }] = useSendPasswordLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPasswordLinkMutation(baseOptions?: Apollo.MutationHookOptions<SendPasswordLinkMutation, SendPasswordLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPasswordLinkMutation, SendPasswordLinkMutationVariables>(SendPasswordLinkDocument, options);
      }
export type SendPasswordLinkMutationHookResult = ReturnType<typeof useSendPasswordLinkMutation>;
export type SendPasswordLinkMutationResult = Apollo.MutationResult<SendPasswordLinkMutation>;
export type SendPasswordLinkMutationOptions = Apollo.BaseMutationOptions<SendPasswordLinkMutation, SendPasswordLinkMutationVariables>;